import GetLoading from "../../../share/getLoading";
// // // //  // IDCardDesigner.js - Complete Fixed Version
// // // // import React, { useState, useEffect, useRef, useCallback } from "react";
// // // // import {
// // // //   Button, Modal, Form, Input, Select, InputNumber, ColorPicker,
// // // //   Space, message, Spin, Card, Slider, Switch, Tooltip,
// // // //   Segmented, Upload, Divider, Radio
// // // // } from "antd";
// // // // import {
// // // //   PlusOutlined, EditOutlined, DeleteOutlined, SaveOutlined,
// // // //   EyeOutlined, SettingOutlined, DownloadOutlined,
// // // //   IdcardOutlined, PictureOutlined, FontSizeOutlined,
// // // //   SwapOutlined, CheckCircleOutlined,
// // // //   QrcodeOutlined, CameraOutlined,
// // // //   UserOutlined, PhoneOutlined, BankOutlined, TeamOutlined,
// // // //   GlobalOutlined, CrownOutlined, StarOutlined, ThunderboltOutlined,
// // // //   UploadOutlined, DeleteOutlined as DeleteIcon,
// // // // } from "@ant-design/icons";
// // // // import { request } from "../../../share/request";
// // // // import { getCurrentUser } from "../../../share/getProfile";
// // // // import { linkPath } from "../../../share/helper";
// // // // 
// // // // import "./IDCardDesigner.css";

// // // // const { Option } = Select;

// // // // const GRADIENT_PRESETS = [
// // // //   { name: 'None', color1: null, color2: null, direction: '135deg', type: 'none' },
// // // //   { name: 'Ocean Blue', color1: '#1a237e', color2: '#0d47a1', direction: '135deg', type: 'linear' },
// // // //   { name: 'Royal Purple', color1: '#4a148c', color2: '#7b1fa2', direction: '135deg', type: 'linear' },
// // // //   { name: 'Sunset Gold', color1: '#f57f17', color2: '#e65100', direction: '45deg', type: 'linear' },
// // // //   { name: 'Forest Green', color1: '#1b5e20', color2: '#004d40', direction: '135deg', type: 'linear' },
// // // //   { name: 'Crimson Red', color1: '#b71c1c', color2: '#880e4f', direction: '135deg', type: 'linear' },
// // // //   { name: 'Midnight Sky', color1: '#1a237e', color2: '#000051', direction: '180deg', type: 'linear' },
// // // //   { name: 'Rose Gold', color1: '#880e4f', color2: '#e91e63', direction: '45deg', type: 'linear' },
// // // //   { name: 'Teal Dream', color1: '#004d40', color2: '#00695c', direction: '135deg', type: 'linear' },
// // // // ];

// // // // const PATTERNS = [
// // // //   { name: 'None', value: 'none' },
// // // //   { name: 'Dots', value: 'dots' },
// // // //   { name: 'Lines', value: 'lines' },
// // // //   { name: 'Grid', value: 'grid' },
// // // // ];

// // // // const FONT_FAMILIES = [
// // // //   { name: 'Content (Khmer)', value: 'Content, sans-serif' },
// // // //   { name: 'Noto Sans Khmer', value: "'Noto Sans Khmer', sans-serif" },
// // // //   { name: 'Hanuman', value: "'Hanuman', serif" },
// // // //   { name: 'Battambang', value: "'Battambang', cursive" },
// // // //   { name: 'Siemreap', value: "'Siemreap', cursive" },
// // // //   { name: 'Moul', value: "'Moul', cursive" },
// // // //   { name: 'Arial', value: 'Arial, sans-serif' },
// // // //   { name: 'Times New Roman', value: "'Times New Roman', serif" },
// // // //   { name: 'Courier New', value: "'Courier New', monospace" },
// // // // ];

// // // // const IDCardDesigner = () => {
// // // //   const getProfile = getCurrentUser();
// // // //   const [loading, setLoading] = useState(false);
// // // //   const [loadingSpin, setLoadingSpin] = useState(false);
// // // //   const [templates, setTemplates] = useState([]);
// // // //   const [currentTemplate, setCurrentTemplate] = useState(null);
// // // //   const [elements, setElements] = useState([]);
// // // //   const [selectedElement, setSelectedElement] = useState(null);
// // // //   const [previewStaff, setPreviewStaff] = useState(null);
// // // //   const [showPreview, setShowPreview] = useState(false);
// // // //   const [showTemplateModal, setShowTemplateModal] = useState(false);
// // // //   const [editingTemplate, setEditingTemplate] = useState(null);

// // // //   const [orientation, setOrientation] = useState('landscape');
// // // //   const [cardSize, setCardSize] = useState({ width: 540, height: 340 });

// // // //   const [backgroundType, setBackgroundType] = useState('gradient');
// // // //   const [bgColor, setBgColor] = useState('#1a237e');
// // // //   const [gradientType, setGradientType] = useState('linear');
// // // //   const [gradientColor1, setGradientColor1] = useState('#1a237e');
// // // //   const [gradientColor2, setGradientColor2] = useState('#4a148c');
// // // //   const [gradientDirection, setGradientDirection] = useState('135deg');
// // // //   const [bgImage, setBgImage] = useState(null);
// // // //   const [bgImageFile, setBgImageFile] = useState(null);
// // // //   const [bgImagePreview, setBgImagePreview] = useState(null);
// // // //   const [bgImageSize, setBgImageSize] = useState('cover');
// // // //   const [bgImagePosition, setBgImagePosition] = useState('center');
// // // //   const [bgImageOpacity, setBgImageOpacity] = useState(1);

// // // //   const [borderRadius, setBorderRadius] = useState(16);
// // // //   const [shadowEnabled, setShadowEnabled] = useState(true);
// // // //   const [shadowColor, setShadowColor] = useState('rgba(0,0,0,0.3)');
// // // //   const [overlayEnabled, setOverlayEnabled] = useState(false);
// // // //   const [overlayPattern, setOverlayPattern] = useState('none');
// // // //   const [overlayOpacity, setOverlayOpacity] = useState(0.1);
// // // //   const [chipEnabled, setChipEnabled] = useState(true);
// // // //   const [chipColor, setChipColor] = useState('#FFD700');
// // // //   const [zoomLevel, setZoomLevel] = useState(1);

// // // //   const [signatureImage, setSignatureImage] = useState(null);
// // // //   const [signatureFile, setSignatureFile] = useState(null);
// // // //   const [signaturePreview, setSignaturePreview] = useState(null);
// // // //   const [logoImage, setLogoImage] = useState(null);
// // // //   const [logoFile, setLogoFile] = useState(null);
// // // //   const [logoPreview, setLogoPreview] = useState(null);
// // // //   const [uploadedImages, setUploadedImages] = useState([]);

// // // //   const [isDragging, setIsDragging] = useState(false);
// // // //   const [dragElement, setDragElement] = useState(null);
// // // //   const [dragStartPos, setDragStartPos] = useState({ x: 0, y: 0 });
// // // //   const [elementStartPos, setElementStartPos] = useState({ x: 0, y: 0 });
// // // //   const canvasRef = useRef(null);
// // // //   const [templateForm] = Form.useForm();

// // // //   // ==================== HELPERS ====================
// // // //   const getBackgroundStyle = () => {
// // // //     let style = {};
// // // //     if (backgroundType === 'image' && bgImagePreview) {
// // // //       style.backgroundImage = `url(${bgImagePreview})`;
// // // //       style.backgroundSize = bgImageSize === 'stretch' ? '100% 100%' : bgImageSize;
// // // //       style.backgroundPosition = bgImagePosition;
// // // //       style.backgroundRepeat = 'no-repeat';
// // // //       if (bgImageOpacity < 1) style.opacity = bgImageOpacity;
// // // //       return style;
// // // //     }
// // // //     if (backgroundType === 'gradient') {
// // // //       style.background = gradientType === 'linear'
// // // //         ? `linear-gradient(${gradientDirection}, ${gradientColor1}, ${gradientColor2})`
// // // //         : `radial-gradient(circle at center, ${gradientColor1}, ${gradientColor2})`;
// // // //     } else if (backgroundType === 'color') {
// // // //       style.backgroundColor = bgColor;
// // // //     } else {
// // // //       style.backgroundColor = 'transparent';
// // // //     }
// // // //     if (overlayEnabled && overlayPattern !== 'none') {
// // // //       const o = overlayOpacity;
// // // //       if (overlayPattern === 'dots') {
// // // //         style.backgroundImage = `radial-gradient(circle, rgba(255,255,255,${o}) 1px, transparent 1px)`;
// // // //         style.backgroundSize = '20px 20px';
// // // //       } else if (overlayPattern === 'lines') {
// // // //         style.backgroundImage = `linear-gradient(90deg, rgba(255,255,255,${o}) 1px, transparent 1px)`;
// // // //         style.backgroundSize = '20px 20px';
// // // //       } else if (overlayPattern === 'grid') {
// // // //         style.backgroundImage = `linear-gradient(90deg, rgba(255,255,255,${o}) 1px, transparent 1px), linear-gradient(0deg, rgba(255,255,255,${o}) 1px, transparent 1px)`;
// // // //         style.backgroundSize = '20px 20px';
// // // //       }
// // // //     }
// // // //     return style;
// // // //   };

// // // //   const getCardShadow = () => shadowEnabled ? `0 20px 60px ${shadowColor}, 0 10px 30px rgba(0,0,0,0.2)` : 'none';

// // // //   const generateQRCode = (text, size) => {
// // // //     if (!text) return '';
// // // //     return `https://api.qrserver.com/v1/create-qr-code/?size=${size}x${size}&data=${encodeURIComponent(text)}&margin=5`;
// // // //   };

// // // //   // ==================== LOAD DATA ====================
// // // //   const loadTemplates = async () => {
// // // //     setLoading(true);
// // // //     try {
// // // //       const param = new URLSearchParams({ org_code: getProfile.org_code });
// // // //       const res = await request(`id-card-templates?${param.toString()}`, "get", {});
// // // //       if (res?.success) {
// // // //         setTemplates(res.data);
// // // //         if (res.data.length > 0 && !currentTemplate) loadTemplate(res.data[0].id);
// // // //       }
// // // //     } catch (e) { console.error(e); }
// // // //     finally { setLoading(false); }
// // // //   };

// // // //   const loadTemplateImages = async (templateId) => {
// // // //     try {
// // // //       const res = await request(`id-card-images/template/${templateId}`, "get", {});
// // // //       if (res?.success) {
// // // //         setUploadedImages(res.data);
// // // //         res.data.forEach(img => {
// // // //           const url = `${linkPath}/${img.image_path}`;
// // // //           if (img.image_type === 'signature') { setSignatureImage(img.image_path); setSignaturePreview(url); }
// // // //           if (img.image_type === 'logo') { setLogoImage(img.image_path); setLogoPreview(url); }
// // // //         });
// // // //       }
// // // //     } catch (e) { console.error(e); }
// // // //   };

// // // //   const loadTemplate = async (templateId) => {
// // // //     setLoading(true);
// // // //     try {
// // // //       const res = await request(`id-card-templates/${templateId}`, "get", {});
// // // //       if (res?.success) {
// // // //         const tpl = res.data;
// // // //         setCurrentTemplate(tpl);
// // // //         setElements(tpl.elements || []);
// // // //         setOrientation(tpl.orientation || 'landscape');
// // // //         setCardSize({ width: tpl.width || 540, height: tpl.height || 340 });
// // // //         setBackgroundType(tpl.background_type || 'gradient');
// // // //         setBgColor(tpl.background_color || '#1a237e');
// // // //         setGradientType(tpl.gradient_type || 'linear');
// // // //         setGradientColor1(tpl.gradient_color1 || '#1a237e');
// // // //         setGradientColor2(tpl.gradient_color2 || '#4a148c');
// // // //         setGradientDirection(tpl.gradient_direction || '135deg');
// // // //         if (tpl.background_image) {
// // // //           setBgImage(tpl.background_image);
// // // //           setBgImagePreview(`${linkPath}/${tpl.background_image}`);
// // // //         } else { setBgImage(null); setBgImagePreview(null); }
// // // //         setBgImageSize(tpl.bg_image_size || 'cover');
// // // //         setBgImagePosition(tpl.bg_image_position || 'center');
// // // //         setBgImageOpacity(tpl.bg_image_opacity || 1);
// // // //         setBorderRadius(tpl.border_radius || 16);
// // // //         setShadowEnabled(tpl.shadow_enabled === 1);
// // // //         setOverlayEnabled(tpl.overlay_enabled === 1);
// // // //         setOverlayPattern(tpl.overlay_pattern || 'none');
// // // //         setOverlayOpacity(tpl.overlay_opacity || 0.1);
// // // //         setChipEnabled(tpl.chip_enabled === 1);
// // // //         setChipColor(tpl.chip_color || '#FFD700');
// // // //         setSelectedElement(null);
// // // //         loadTemplateImages(templateId);
// // // //       }
// // // //     } catch (e) { console.error(e); }
// // // //     finally { setLoading(false); }
// // // //   };

// // // //   useEffect(() => { loadTemplates(); }, []);

// // // //   // ==================== HANDLERS ====================
// // // //   const handleOrientationChange = (v) => {
// // // //     setOrientation(v);
// // // //     setCardSize(v === 'portrait' ? { width: 340, height: 540 } : { width: 540, height: 340 });
// // // //   };

// // // //   const handleBgImageUpload = (file) => {
// // // //     const r = new FileReader();
// // // //     r.onload = (e) => { setBgImagePreview(e.target.result); setBgImageFile(file); };
// // // //     r.readAsDataURL(file);
// // // //     return false;
// // // //   };
// // // //   const handleRemoveBgImage = () => { setBgImagePreview(null); setBgImageFile(null); setBgImage(null); };

// // // //   const handleSignatureUpload = (file) => {
// // // //     const r = new FileReader();
// // // //     r.onload = (e) => { setSignaturePreview(e.target.result); setSignatureFile(file); };
// // // //     r.readAsDataURL(file);
// // // //     return false;
// // // //   };
// // // //   const handleRemoveSignature = () => { setSignaturePreview(null); setSignatureFile(null); setSignatureImage(null); };

// // // //   const handleLogoUpload = (file) => {
// // // //     const r = new FileReader();
// // // //     r.onload = (e) => { setLogoPreview(e.target.result); setLogoFile(file); };
// // // //     r.readAsDataURL(file);
// // // //     return false;
// // // //   };
// // // //   const handleRemoveLogo = () => { setLogoPreview(null); setLogoFile(null); setLogoImage(null); };

// // // //   const uploadImageWithType = async (file, imageType) => {
// // // //     const fd = new FormData();
// // // //     fd.append('idcard_bg', file);
// // // //     fd.append('template_id', currentTemplate?.id);
// // // //     fd.append('image_type', imageType);
// // // //     fd.append('org_code', getProfile.org_code);
// // // //     try {
// // // //       const res = await request("id-card-images", "POST", fd, true);
// // // //       if (res?.success) { message.success(`${imageType} uploaded!`); loadTemplateImages(currentTemplate?.id); return res.data; }
// // // //     } catch (e) { message.error("Upload failed"); }
// // // //     return null;
// // // //   };

// // // //   const addElement = (type, key = null, label = '') => {
// // // //     const defaults = {
// // // //       text: { w: 150, h: 30, fs: 14, fw: 'bold' },
// // // //       'custom-text': { w: 150, h: 30, fs: 14, fw: 'normal' },
// // // //       image: { w: 80, h: 100, fs: 0, fw: 'normal' },
// // // //       qrcode: { w: 80, h: 80, fs: 0, fw: 'normal' },
// // // //     };
// // // //     const s = defaults[type] || defaults.text;
// // // //     const el = {
// // // //       template_id: currentTemplate?.id,
// // // //       element_type: type, element_key: key, label: label || type,
// // // //       custom_text: type === 'custom-text' ? 'Enter text' : '',
// // // //       x_position: 50 + elements.length * 20, y_position: 50 + elements.length * 20,
// // // //       width: s.w, height: s.h, font_size: s.fs, font_color: '#FFFFFF',
// // // //       font_weight: s.fw, font_family: 'Content, sans-serif', text_align: 'left',
// // // //       is_visible: 1, sort_order: elements.length + 1, is_new: true,
// // // //       tempId: `t_${Date.now()}_${Math.random().toString(36).substr(2, 9)}`,
// // // //     };
// // // //     setElements([...elements, el]);
// // // //     setSelectedElement(el);
// // // //   };

// // // //   const handleMouseDown = (e, el) => {
// // // //     e.preventDefault(); e.stopPropagation();
// // // //     setSelectedElement(el); setIsDragging(true); setDragElement(el);
// // // //     setDragStartPos({ x: e.clientX, y: e.clientY });
// // // //     setElementStartPos({ x: el.x_position || 0, y: el.y_position || 0 });
// // // //   };
// // // //   const handleMouseMove = useCallback((e) => {
// // // //     if (!isDragging || !dragElement) return;
// // // //     const dx = (e.clientX - dragStartPos.x) / zoomLevel;
// // // //     const dy = (e.clientY - dragStartPos.y) / zoomLevel;
// // // //     const nx = Math.max(0, Math.min(cardSize.width - (dragElement.width || 100), elementStartPos.x + dx));
// // // //     const ny = Math.max(0, Math.min(cardSize.height - (dragElement.height || 30), elementStartPos.y + dy));
// // // //     const eid = dragElement.id || dragElement.tempId;
// // // //     setElements(prev => prev.map(el => (el.id || el.tempId) === eid ? { ...el, x_position: Math.round(nx), y_position: Math.round(ny) } : el));
// // // //   }, [isDragging, dragElement, dragStartPos, elementStartPos, cardSize, zoomLevel]);
// // // //   const handleMouseUp = useCallback(() => { setIsDragging(false); setDragElement(null); }, [isDragging]);
// // // //   useEffect(() => {
// // // //     if (isDragging) { window.addEventListener('mousemove', handleMouseMove); window.addEventListener('mouseup', handleMouseUp); }
// // // //     return () => { window.removeEventListener('mousemove', handleMouseMove); window.removeEventListener('mouseup', handleMouseUp); };
// // // //   }, [isDragging]);

// // // //   const updateElementProps = (eid, props) => {
// // // //     setElements(prev => prev.map(el => (el.id || el.tempId) === eid ? { ...el, ...props } : el));
// // // //     setSelectedElement(prev => prev && ((prev.id || prev.tempId) === eid) ? { ...prev, ...props } : prev);
// // // //   };
// // // //   const deleteElement = async (eid) => {
// // // //     const el = elements.find(e => (e.id || e.tempId) === eid);
// // // //     if (el?.is_new) { setElements(elements.filter(e => (e.id || e.tempId) !== eid)); setSelectedElement(null); return; }
// // // //     if (el?.id) {
// // // //       try { await request(`id-card-elements/${el.id}`, "DELETE", {}); setElements(elements.filter(e => e.id !== el.id)); setSelectedElement(null); }
// // // //       catch (e) { console.error(e); }
// // // //     }
// // // //   };

// // // //   // ==================== SAVE ====================
// // // //   const saveElements = async () => {
// // // //     if (!currentTemplate) { message.warning("Select a template first"); return; }
// // // //     setLoadingSpin(true);
// // // //     try {
// // // //       if (signatureFile) { const d = await uploadImageWithType(signatureFile, 'signature'); if (d) { setSignatureImage(d.filename); setSignatureFile(null); } }
// // // //       if (logoFile) { const d = await uploadImageWithType(logoFile, 'logo'); if (d) { setLogoImage(d.filename); setLogoFile(null); } }
// // // //       let fBg = bgImage;
// // // //       if (bgImageFile) {
// // // //         const fd = new FormData(); fd.append('idcard_bg', bgImageFile);
// // // //         const res = await request("id-card-upload", "POST", fd, true);
// // // //         if (res?.success) { fBg = res.data.filename; setBgImage(fBg); setBgImageFile(null); setBgImagePreview(`${linkPath}/${res.data.filename}`); }
// // // //       }
// // // //       await request(`id-card-templates/${currentTemplate.id}`, "PUT", {
// // // //         width: cardSize.width, height: cardSize.height, orientation,
// // // //         background_type: backgroundType, background_color: bgColor, background_image: fBg,
// // // //         gradient_type: gradientType, gradient_color1: gradientColor1, gradient_color2: gradientColor2, gradient_direction: gradientDirection,
// // // //         bg_image_size: bgImageSize, bg_image_position: bgImagePosition, bg_image_opacity: bgImageOpacity,
// // // //         border_radius: borderRadius, shadow_enabled: shadowEnabled, shadow_color: shadowColor,
// // // //         overlay_enabled: overlayEnabled, overlay_pattern: overlayPattern, overlay_opacity: overlayOpacity,
// // // //         chip_enabled: chipEnabled, chip_color: chipColor,
// // // //       });
// // // //       for (const el of elements) {
// // // //         const data = {
// // // //           id: el.id || null, template_id: currentTemplate.id,
// // // //           element_type: el.element_type, element_key: el.element_key, label: el.label,
// // // //           custom_text: el.custom_text || null,
// // // //           x_position: el.x_position, y_position: el.y_position, width: el.width, height: el.height,
// // // //           font_size: el.font_size, font_color: el.font_color, font_weight: el.font_weight,
// // // //           font_family: el.font_family, text_align: el.text_align,
// // // //           is_visible: el.is_visible, sort_order: el.sort_order,
// // // //         };
// // // //         const r = await request("id-card-elements", "POST", data);
// // // //         if (r?.data?.id && el.is_new) {
// // // //           setElements(prev => prev.map(e => e.tempId === el.tempId ? { ...e, id: r.data.id, is_new: false } : e));
// // // //         }
// // // //       }
// // // //       message.success("💾 Saved!");
// // // //       loadTemplate(currentTemplate.id);
// // // //     } catch (e) { console.error(e); message.error("Save failed"); }
// // // //     finally { setLoadingSpin(false); }
// // // //   };

// // // //   const previewIDCard = async () => {
// // // //     setLoadingSpin(true);
// // // //     try {
// // // //       const res = await request(`id-card-preview?username=${getProfile.username}&org_code=${getProfile.org_code}`, "get", {});
// // // //       if (res?.success) { setPreviewStaff(res.data.staff); setShowPreview(true); }
// // // //     } catch (e) { console.error(e); }
// // // //     finally { setLoadingSpin(false); }
// // // //   };

// // // //   const handleTemplateSave = async () => {
// // // //     try {
// // // //       const v = await templateForm.validateFields();
// // // //       setLoadingSpin(true);
// // // //       const data = { ...v, org_code: getProfile.org_code, usercreate: getProfile.fullname, width: cardSize.width, height: cardSize.height, orientation, background_type: backgroundType, background_color: bgColor, gradient_type: gradientType, gradient_color1: gradientColor1, gradient_color2: gradientColor2, gradient_direction: gradientDirection, border_radius: borderRadius, shadow_enabled: shadowEnabled, shadow_color: shadowColor, overlay_enabled: overlayEnabled, chip_enabled: chipEnabled, chip_color: chipColor };
// // // //       const res = editingTemplate ? await request(`id-card-templates/${editingTemplate.id}`, "PUT", data) : await request("id-card-templates", "POST", data);
// // // //       if (res?.isOk) { message.success(editingTemplate ? "✅ Updated!" : "✨ Created!"); setShowTemplateModal(false); templateForm.resetFields(); loadTemplates(); }
// // // //     } catch (e) { console.error(e); }
// // // //     finally { setLoadingSpin(false); }
// // // //   };

// // // //   const applyGradientPreset = (p) => {
// // // //     if (p.type === 'none') { setBackgroundType('none'); return; }
// // // //     setBackgroundType('gradient'); setGradientColor1(p.color1); setGradientColor2(p.color2); setGradientDirection(p.direction); setGradientType(p.type);
// // // //   };

// // // //   // ==================== RENDER ====================
// // // //   const renderIDCard = () => (
// // // //     <div ref={canvasRef} style={{
// // // //       width: cardSize.width, height: cardSize.height, ...getBackgroundStyle(),
// // // //       borderRadius: borderRadius, boxShadow: getCardShadow(),
// // // //       position: 'relative', overflow: 'hidden',
// // // //       border: backgroundType === 'none' ? '2px dashed #d9d9d9' : '1px solid rgba(255,255,255,0.2)',
// // // //       cursor: isDragging ? 'grabbing' : 'default', userSelect: 'none',
// // // //     }}>
// // // //       {backgroundType !== 'none' && (
// // // //         <>
// // // //           <div style={{ position: 'absolute', top: -60, right: -60, width: 220, height: 220, borderRadius: '50%', background: 'rgba(255,255,255,0.03)', pointerEvents: 'none' }} />
// // // //           <div style={{ position: 'absolute', bottom: -90, left: -40, width: 280, height: 280, borderRadius: '50%', background: 'rgba(255,255,255,0.03)', pointerEvents: 'none' }} />
// // // //         </>
// // // //       )}
// // // //       {chipEnabled && (
// // // //         <div style={{ position: 'absolute', top: 20, left: 20, width: 45, height: 32, borderRadius: 6, background: `linear-gradient(135deg, ${chipColor}, ${chipColor}cc)`, boxShadow: '0 2px 8px rgba(0,0,0,0.2)', zIndex: 2, pointerEvents: 'none' }}>
// // // //           <div style={{ width: '100%', height: '100%', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
// // // //             <div style={{ width: 22, height: 16, borderRadius: 3, background: 'rgba(255,255,255,0.3)', border: '1px solid rgba(255,255,255,0.5)' }} />
// // // //           </div>
// // // //         </div>
// // // //       )}
// // // //       {backgroundType === 'none' && (
// // // //         <div style={{ position: 'absolute', top: '50%', left: '50%', transform: 'translate(-50%,-50%)', color: '#d9d9d9', textAlign: 'center', pointerEvents: 'none' }}>
// // // //           <PictureOutlined style={{ fontSize: 48, display: 'block', marginBottom: 8 }} />
// // // //           {cardSize.width} × {cardSize.height}
// // // //         </div>
// // // //       )}
// // // //       {elements.filter(el => el.is_visible !== 0).map((el, i) => {
// // // //         const eid = el.id || el.tempId;
// // // //         const sel = selectedElement && (selectedElement.id || selectedElement.tempId) === eid;
// // // //         return (
// // // //           <div key={eid} onMouseDown={(e) => handleMouseDown(e, el)} style={{
// // // //             position: 'absolute', left: el.x_position || 0, top: el.y_position || 0,
// // // //             width: el.width || 100, height: el.height || 30,
// // // //             display: 'flex', alignItems: 'center',
// // // //             justifyContent: el.text_align === 'center' ? 'center' : el.text_align === 'right' ? 'flex-end' : 'flex-start',
// // // //             fontSize: el.font_size || 12, color: el.font_color || '#FFF',
// // // //             fontWeight: el.font_weight || 'normal', fontFamily: el.font_family || 'Content',
// // // //             zIndex: sel ? 100 : 2, overflow: 'hidden', cursor: 'move',
// // // //             border: sel ? '2px solid #1890ff' : '1px dashed rgba(255,255,255,0.3)',
// // // //             background: sel ? 'rgba(24,144,255,0.15)' : 'rgba(255,255,255,0.05)',
// // // //             borderRadius: 4, padding: 2,
// // // //           }}>
// // // //             {el.element_type === 'qrcode' ? (
// // // //               <div style={{ width: '100%', height: '100%', display: 'flex', alignItems: 'center', justifyContent: 'center', background: 'white', borderRadius: 4, padding: 4 }}>
// // // //                 <img src={generateQRCode(el.label || 'QR', Math.min(el.width, el.height))} alt="QR" style={{ width: '100%', height: '100%', objectFit: 'contain' }} />
// // // //               </div>
// // // //             ) : el.element_type === 'image' ? (
// // // //               <div style={{ width: '100%', height: '100%', borderRadius: el.element_key === 'photo' ? 6 : 0, border: el.element_key === 'photo' ? '1px solid rgba(255,255,255,0.3)' : 'none', overflow: 'hidden', display: 'flex', alignItems: 'center', justifyContent: 'center', background: 'rgba(255,255,255,0.1)', color: 'rgba(255,255,255,0.6)', fontSize: 11 }}>
// // // //                 {el.element_key === 'signature' ? (signaturePreview ? <img src={signaturePreview} alt="Sig" style={{ width: '100%', height: '100%', objectFit: 'contain' }} /> : <EditOutlined style={{ fontSize: 20 }} />) :
// // // //                  el.element_key === 'org_logo' ? (logoPreview ? <img src={logoPreview} alt="Logo" style={{ width: '100%', height: '100%', objectFit: 'contain' }} /> : <BankOutlined style={{ fontSize: 20 }} />) :
// // // //                  el.element_key === 'photo' ? <CameraOutlined style={{ fontSize: 20 }} /> : <PictureOutlined style={{ fontSize: 20 }} />}
// // // //               </div>
// // // //             ) : (
// // // //              <span style={{ width: '100%', textAlign: el.text_align || 'left', fontFamily: el.font_family || 'Content, sans-serif' }}>
// // // //   {el.element_type === 'custom-text' ? (el.custom_text || 'Custom Text') : el.label}
// // // // </span>
// // // //             )}
// // // //             {sel && <div style={{ position: 'absolute', top: -10, right: -10, width: 20, height: 20, borderRadius: '50%', background: '#ff4d4f', color: 'white', display: 'flex', alignItems: 'center', justifyContent: 'center', cursor: 'pointer', fontSize: 12, zIndex: 101 }} onClick={(e) => { e.stopPropagation(); deleteElement(eid); }}>×</div>}
// // // //           </div>
// // // //         );
// // // //       })}
// // // //     </div>
// // // //   );

// // // //   const elementGroups = [
// // // //     { title: '👤 Personal', items: [
// // // //       { type: 'text', key: 'fullname', label: 'Full Name', icon: <UserOutlined /> },
// // // //       { type: 'text', key: 'frontname', label: 'Title', icon: <StarOutlined /> },
// // // //       { type: 'text', key: 'staffname_eng', label: 'Name ENG', icon: <GlobalOutlined /> },
// // // //       { type: 'text', key: 'idnumber', label: 'ID Number', icon: <IdcardOutlined /> },
// // // //       { type: 'text', key: 'gender', label: 'Gender', icon: <UserOutlined /> },
// // // //       { type: 'text', key: 'dob', label: 'DOB', icon: <IdcardOutlined /> },
// // // //     ]},
// // // //     { title: '💼 Work', items: [
// // // //       { type: 'text', key: 'position_name', label: 'Position', icon: <CrownOutlined /> },
// // // //       { type: 'text', key: 'department_name', label: 'Department', icon: <TeamOutlined /> },
// // // //       { type: 'text', key: 'skill_name', label: 'Skill', icon: <ThunderboltOutlined /> },
// // // //       { type: 'text', key: 'jobstatus', label: 'Job Status', icon: <CheckCircleOutlined /> },
// // // //       { type: 'text', key: 'stafftype', label: 'Staff Type', icon: <IdcardOutlined /> },
// // // //       { type: 'text', key: 'level', label: 'Level', icon: <StarOutlined /> },
// // // //       { type: 'text', key: 'joinwork', label: 'Join Date', icon: <IdcardOutlined /> },
// // // //     ]},
// // // //     { title: '📱 Contact', items: [
// // // //       { type: 'text', key: 'username', label: 'Phone', icon: <PhoneOutlined /> },
// // // //     ]},
// // // //     { title: '🖼️ Media', items: [
// // // //       { type: 'image', key: 'photo', label: 'Photo', icon: <CameraOutlined /> },
// // // //       { type: 'image', key: 'org_logo', label: 'Org Logo', icon: <BankOutlined /> },
// // // //       { type: 'image', key: 'signature', label: 'Signature', icon: <EditOutlined /> },
// // // //       { type: 'text', key: 'org_name', label: 'Org Name', icon: <GlobalOutlined /> },
// // // //     ]},
// // // //     { title: '✏️ Custom', items: [
// // // //       { type: 'custom-text', key: 'custom_text', label: 'Custom Text', icon: <FontSizeOutlined /> },
// // // //     ]},
// // // //     { title: '🔢 Extra', items: [
// // // //       { type: 'qrcode', key: 'qrcode_id', label: 'QR Code', icon: <QrcodeOutlined /> },
// // // //       { type: 'text', key: 'role_name', label: 'Role', icon: <TeamOutlined /> },
// // // //     ]},
// // // //   ];

// // // //   return (
// // // //     <div className="id-card-designer" style={{ padding: 24, background: '#f0f2f5', minHeight: '100vh' }}>
// // // //       {loadingSpin && <div className="sprinSave"><GetLoading /></div>}
      
// // // //       {/* Header */}
// // // //       <div style={{ background: 'linear-gradient(135deg, #667eea, #764ba2)', borderRadius: 16, padding: '24px 32px', marginBottom: 24, color: 'white', boxShadow: '0 10px 40px rgba(102,126,234,0.4)' }}>
// // // //         <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', flexWrap: 'wrap', gap: 16 }}>
// // // //           <div>
// // // //             <h1 style={{ color: 'white', margin: 0, fontSize: 28, fontWeight: 700 }}><IdcardOutlined style={{ marginRight: 12 }} />ID Card Designer</h1>
// // // //             <p style={{ color: 'rgba(255,255,255,0.8)', margin: '8px 0 0', fontSize: 14 }}>Click & drag elements to position them</p>
// // // //           </div>
// // // //           <Space>
// // // //              <Button icon={<SaveOutlined />} onClick={saveElements} loading={loadingSpin} size="large" style={{ background: 'white', color: '#667eea', border: 'none' }}>Save Design</Button>
// // // //           </Space>
// // // //         </div>
// // // //       </div>

// // // //       <div style={{ display: 'grid', gridTemplateColumns: '260px 1fr 320px', gap: 24 }}>
// // // //         {/* Left - Elements */}
// // // //         <Card title="📦 Elements" style={{ borderRadius: 16, boxShadow: '0 4px 20px rgba(0,0,0,0.08)', position: 'sticky', top: 24 }}>
// // // //           <Segmented block value={orientation} onChange={handleOrientationChange} options={[{ label: '🏞️ Landscape', value: 'landscape' }, { label: '📱 Portrait', value: 'portrait' }]} style={{ marginBottom: 16 }} />
// // // //           <Divider />
// // // //           {elementGroups.map(g => (
// // // //             <div key={g.title} style={{ marginBottom: 20 }}>
// // // //               <h4 style={{ color: '#666', fontSize: 12, textTransform: 'uppercase', marginBottom: 8 }}>{g.title}</h4>
// // // //               <Space direction="vertical" style={{ width: '100%' }}>
// // // //                 {g.items.map(item => (
// // // //                   <Button key={item.key} block icon={item.icon} onClick={() => addElement(item.type, item.key, item.label)} style={{ textAlign: 'left', borderRadius: 10, height: 40 }}>{item.label}</Button>
// // // //                 ))}
// // // //               </Space>
// // // //             </div>
// // // //           ))}
// // // //         </Card>

// // // //         {/* Center - Canvas */}
// // // //         <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', gap: 16 }}>
// // // //           <Card style={{ width: '100%', borderRadius: 16, boxShadow: '0 4px 20px rgba(0,0,0,0.08)' }}>
// // // //             <Space style={{ width: '100%', justifyContent: 'space-between' }}>
// // // //               <Select style={{ width: 250 }} placeholder="Select template" value={currentTemplate?.id} onChange={loadTemplate} size="large">
// // // //                 {templates.map(t => <Option key={t.id} value={t.id}>{t.is_default === 1 && '⭐ '}{t.template_name}</Option>)}
// // // //               </Select>
// // // //               <Space>
// // // //                 <Button icon={<PlusOutlined />} onClick={() => { setEditingTemplate(null); templateForm.resetFields(); setShowTemplateModal(true); }}>New</Button>
// // // //                 <Button icon={<SettingOutlined />} onClick={() => { setEditingTemplate(currentTemplate); templateForm.setFieldsValue(currentTemplate); setShowTemplateModal(true); }} disabled={!currentTemplate}>Settings</Button>
// // // //               </Space>
// // // //             </Space>
// // // //           </Card>
// // // //           <div style={{ background: '#e8e8e8', borderRadius: 16, padding: 40, boxShadow: 'inset 0 2px 10px rgba(0,0,0,0.1)', overflow: 'auto', maxHeight: 'calc(100vh - 300px)', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
// // // //             <div style={{ transform: `scale(${zoomLevel})`, transformOrigin: 'center center', transition: 'transform 0.2s' }}>{renderIDCard()}</div>
// // // //           </div>
// // // //           <Card size="small" style={{ borderRadius: 12 }}>
// // // //             <Space><span>🔍</span><Slider min={0.5} max={1.5} step={0.1} value={zoomLevel} onChange={setZoomLevel} style={{ width: 150 }} /><span>{Math.round(zoomLevel * 100)}%</span></Space>
// // // //           </Card>
// // // //         </div>

// // // //         {/* Right - Settings */}
// // // //         <div style={{ maxHeight: 'calc(100vh - 150px)', overflowY: 'auto' }}>
// // // //           {/* Background */}
// // // //           <Card title="🎨 Background" style={{ borderRadius: 16, boxShadow: '0 4px 20px rgba(0,0,0,0.08)', marginBottom: 16 }}>
// // // //             <Radio.Group value={backgroundType} onChange={(e) => setBackgroundType(e.target.value)} style={{ marginBottom: 16, width: '100%' }} size="small">
// // // //               <Radio.Button value="none" style={{ width: '25%', textAlign: 'center' }}>None</Radio.Button>
// // // //               <Radio.Button value="color" style={{ width: '25%', textAlign: 'center' }}>Color</Radio.Button>
// // // //               <Radio.Button value="gradient" style={{ width: '25%', textAlign: 'center' }}>Gradient</Radio.Button>
// // // //               <Radio.Button value="image" style={{ width: '25%', textAlign: 'center' }}>Image</Radio.Button>
// // // //             </Radio.Group>
// // // //             {backgroundType === 'color' && (
// // // //               <div style={{ marginBottom: 12 }}>
// // // //                 <label style={{ fontSize: 12, color: '#666' }}>Color</label>
// // // //                 <ColorPicker value={bgColor} onChange={(c) => setBgColor(c.toHexString())} style={{ width: '100%' }} />
// // // //               </div>
// // // //             )}
// // // //             {backgroundType === 'gradient' && (
// // // //               <div>
// // // //                 <div style={{ marginBottom: 12 }}>
// // // //                   <label style={{ fontSize: 12, color: '#666' }}>Presets</label>
// // // //                   <div style={{ display: 'grid', gridTemplateColumns: 'repeat(4, 1fr)', gap: 6 }}>
// // // //                                       {GRADIENT_PRESETS.filter(p => p.type !== 'none').map((p, i) => (
// // // //                       <Tooltip key={i} title={p.name}>
// // // //                         <div onClick={() => applyGradientPreset(p)} style={{ height: 30, borderRadius: 6, cursor: 'pointer', background: `linear-gradient(${p.direction}, ${p.color1}, ${p.color2})`, border: gradientColor1 === p.color1 ? '2px solid #1890ff' : '2px solid transparent' }} />
// // // //                       </Tooltip>
// // // //                     ))}
// // // //                   </div>
// // // //                 </div>
// // // //                 <Select value={gradientType} onChange={setGradientType} style={{ width: '100%', marginBottom: 8 }} size="small">
// // // //                   <Option value="linear">Linear</Option>
// // // //                   <Option value="radial">Radial</Option>
// // // //                 </Select>
// // // //                 <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: 8, marginBottom: 8 }}>
// // // //                   <ColorPicker value={gradientColor1} onChange={(c) => setGradientColor1(c.toHexString())} />
// // // //                   <ColorPicker value={gradientColor2} onChange={(c) => setGradientColor2(c.toHexString())} />
// // // //                 </div>
// // // //                 <Select value={gradientDirection} onChange={setGradientDirection} style={{ width: '100%' }} size="small">
// // // //                   {['0deg','45deg','90deg','135deg','180deg','225deg','270deg','315deg'].map(d => <Option key={d} value={d}>{d}</Option>)}
// // // //                 </Select>
// // // //               </div>
// // // //             )}
// // // //             {backgroundType === 'image' && (
// // // //               <div>
// // // //                 <label style={{ fontSize: 12, color: '#666' }}>Image</label>
// // // //                 {bgImagePreview ? (
// // // //                   <div style={{ position: 'relative', marginBottom: 8 }}>
// // // //                     <img src={bgImagePreview} alt="BG" style={{ width: '100%', height: 120, objectFit: 'cover', borderRadius: 8 }} />
// // // //                     <Button icon={<DeleteIcon />} size="small" danger onClick={handleRemoveBgImage} style={{ position: 'absolute', top: 8, right: 8 }} />
// // // //                   </div>
// // // //                 ) : (
// // // //                   <Upload beforeUpload={handleBgImageUpload} showUploadList={false} accept="image/*">
// // // //                     <Button icon={<UploadOutlined />} block style={{ borderRadius: 8, height: 80 }}>Upload Background</Button>
// // // //                   </Upload>
// // // //                 )}
// // // //                 <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: 8, marginTop: 8 }}>
// // // //                   <Select value={bgImageSize} onChange={setBgImageSize} size="small"><Option value="cover">Cover</Option><Option value="contain">Contain</Option><Option value="stretch">Stretch</Option></Select>
// // // //                   <Select value={bgImagePosition} onChange={setBgImagePosition} size="small"><Option value="center">Center</Option><Option value="top">Top</Option><Option value="bottom">Bottom</Option></Select>
// // // //                 </div>
// // // //                 <div style={{ marginTop: 8 }}><label style={{ fontSize: 12, color: '#666' }}>Opacity: {bgImageOpacity}</label><Slider min={0.1} max={1} step={0.1} value={bgImageOpacity} onChange={setBgImageOpacity} /></div>
// // // //               </div>
// // // //             )}
// // // //           </Card>

// // // //           {/* Card Style */}
// // // //           <Card title="✨ Card Style" style={{ borderRadius: 16, boxShadow: '0 4px 20px rgba(0,0,0,0.08)', marginBottom: 16 }}>
// // // //             <Space direction="vertical" style={{ width: '100%' }} size="small">
// // // //               <div style={{ display: 'flex', justifyContent: 'space-between' }}><span style={{ fontSize: 12 }}>Border Radius</span><InputNumber size="small" min={0} max={50} value={borderRadius} onChange={setBorderRadius} style={{ width: 80 }} addonAfter="px" /></div>
// // // //               <div style={{ display: 'flex', justifyContent: 'space-between' }}><span style={{ fontSize: 12 }}>Shadow</span><Switch size="small" checked={shadowEnabled} onChange={setShadowEnabled} /></div>
// // // //               <div style={{ display: 'flex', justifyContent: 'space-between' }}><span style={{ fontSize: 12 }}>Overlay</span><Select size="small" value={overlayPattern} onChange={setOverlayPattern} style={{ width: 100 }}>{PATTERNS.map(p => <Option key={p.value} value={p.value}>{p.name}</Option>)}</Select></div>
// // // //               {overlayPattern !== 'none' && <div style={{ display: 'flex', justifyContent: 'space-between' }}><span style={{ fontSize: 12 }}>Opacity</span><InputNumber size="small" min={0} max={1} step={0.1} value={overlayOpacity} onChange={setOverlayOpacity} style={{ width: 80 }} /></div>}
// // // //               <div style={{ display: 'flex', justifyContent: 'space-between' }}><span style={{ fontSize: 12 }}>Gold Chip</span><Space size="small"><Switch size="small" checked={chipEnabled} onChange={setChipEnabled} />{chipEnabled && <ColorPicker value={chipColor} onChange={(c) => setChipColor(c.toHexString())} size="small" />}</Space></div>
// // // //             </Space>
// // // //           </Card>

// // // //           {/* Signature & Logo */}
// // // //           <Card title={<Space><EditOutlined /> Signature & Logo</Space>} style={{ borderRadius: 16, boxShadow: '0 4px 20px rgba(0,0,0,0.08)', marginBottom: 16 }}>
// // // //             <Space direction="vertical" style={{ width: '100%' }} size="middle">
// // // //               <div><label style={{ fontSize: 12, color: '#666', fontWeight: 'bold' }}>✍️ Signature</label>
// // // //                 {signaturePreview ? <div style={{ position: 'relative' }}><img src={signaturePreview} alt="Sig" style={{ width: '100%', height: 70, objectFit: 'contain', borderRadius: 8, background: '#f5f5f5', padding: 8 }} /><Button icon={<DeleteIcon />} size="small" danger onClick={handleRemoveSignature} style={{ position: 'absolute', top: 4, right: 4 }} /></div>
// // // //                 : <Upload beforeUpload={handleSignatureUpload} showUploadList={false} accept="image/*"><Button icon={<UploadOutlined />} block style={{ borderRadius: 8, height: 50 }}>Upload Signature</Button></Upload>}
// // // //               </div>
// // // //               <Divider />
// // // //               <div><label style={{ fontSize: 12, color: '#666', fontWeight: 'bold' }}>🏢 Logo</label>
// // // //                 {logoPreview ? <div style={{ position: 'relative' }}><img src={logoPreview} alt="Logo" style={{ width: '100%', height: 70, objectFit: 'contain', borderRadius: 8, background: '#f5f5f5', padding: 8 }} /><Button icon={<DeleteIcon />} size="small" danger onClick={handleRemoveLogo} style={{ position: 'absolute', top: 4, right: 4 }} /></div>
// // // //                 : <Upload beforeUpload={handleLogoUpload} showUploadList={false} accept="image/*"><Button icon={<UploadOutlined />} block style={{ borderRadius: 8, height: 50 }}>Upload Logo</Button></Upload>}
// // // //               </div>
// // // //             </Space>
// // // //           </Card>

// // // //           {/* Element Properties */}
// // // //           {selectedElement && (
// // // //             <Card title={<Space><EditOutlined /> Properties</Space>} extra={<Button type="text" danger icon={<DeleteOutlined />} size="small" onClick={() => deleteElement(selectedElement.id || selectedElement.tempId)} />} style={{ borderRadius: 16, boxShadow: '0 4px 20px rgba(0,0,0,0.08)' }}>
// // // //               <Form layout="vertical" size="small">
// // // //                 <Form.Item label="Label"><Input value={selectedElement.label} onChange={(e) => updateElementProps(selectedElement.id || selectedElement.tempId, { label: e.target.value })} /></Form.Item>
// // // //                 {selectedElement.element_type === 'custom-text' && <Form.Item label="Custom Text"><Input.TextArea value={selectedElement.custom_text || ''} rows={3} onChange={(e) => updateElementProps(selectedElement.id || selectedElement.tempId, { custom_text: e.target.value })} /></Form.Item>}
// // // //                 {(selectedElement.element_type === 'text' || selectedElement.element_type === 'custom-text') && (
// // // //                   <>
// // // //                     <Form.Item label="Font"><Select value={selectedElement.font_family || 'Content, sans-serif'} onChange={(v) => updateElementProps(selectedElement.id || selectedElement.tempId, { font_family: v })} size="small">{FONT_FAMILIES.map(f => <Option key={f.value} value={f.value}><span style={{ fontFamily: f.value }}>{f.name}</span></Option>)}</Select></Form.Item>
// // // //                     <Form.Item label="Size"><InputNumber value={selectedElement.font_size} min={8} max={72} style={{ width: '100%' }} onChange={(v) => updateElementProps(selectedElement.id || selectedElement.tempId, { font_size: v })} /></Form.Item>
// // // //                     <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: 8 }}>
// // // //                       <Form.Item label="Color"><ColorPicker value={selectedElement.font_color} onChange={(c) => updateElementProps(selectedElement.id || selectedElement.tempId, { font_color: c.toHexString() })} /></Form.Item>
// // // //                       <Form.Item label="Weight"><Select value={selectedElement.font_weight} onChange={(v) => updateElementProps(selectedElement.id || selectedElement.tempId, { font_weight: v })}><Option value="normal">Normal</Option><Option value="bold">Bold</Option></Select></Form.Item>
// // // //                     </div>
// // // //                     <Form.Item label="Align"><Segmented block value={selectedElement.text_align} onChange={(v) => updateElementProps(selectedElement.id || selectedElement.tempId, { text_align: v })} options={[{ label: 'L', value: 'left' }, { label: 'C', value: 'center' }, { label: 'R', value: 'right' }]} /></Form.Item>
// // // //                   </>
// // // //                 )}
// // // //                 <Divider />
// // // //                 <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: 8 }}>
// // // //                   <Form.Item label="W"><InputNumber value={selectedElement.width} min={10} max={cardSize.width} style={{ width: '100%' }} onChange={(v) => updateElementProps(selectedElement.id || selectedElement.tempId, { width: v })} /></Form.Item>
// // // //                   <Form.Item label="H"><InputNumber value={selectedElement.height} min={10} max={cardSize.height} style={{ width: '100%' }} onChange={(v) => updateElementProps(selectedElement.id || selectedElement.tempId, { height: v })} /></Form.Item>
// // // //                 </div>
// // // //                 <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: 8 }}>
// // // //                   <Form.Item label="X"><InputNumber value={selectedElement.x_position} min={0} max={cardSize.width} style={{ width: '100%' }} onChange={(v) => updateElementProps(selectedElement.id || selectedElement.tempId, { x_position: v })} /></Form.Item>
// // // //                   <Form.Item label="Y"><InputNumber value={selectedElement.y_position} min={0} max={cardSize.height} style={{ width: '100%' }} onChange={(v) => updateElementProps(selectedElement.id || selectedElement.tempId, { y_position: v })} /></Form.Item>
// // // //                 </div>
// // // //               </Form>
// // // //             </Card>
// // // //           )}
// // // //         </div>
// // // //       </div>

// // // //       {/* Template Modal */}
// // // //       <Modal title={<Space><SettingOutlined />{editingTemplate ? 'Edit' : 'New'} Template</Space>} open={showTemplateModal} onOk={handleTemplateSave} onCancel={() => setShowTemplateModal(false)} confirmLoading={loadingSpin} width={500}>
// // // //         <Form form={templateForm} layout="vertical">
// // // //           <Form.Item name="template_name" label="Name" rules={[{ required: true }]}><Input placeholder="Premium Gold Card" size="large" /></Form.Item>
// // // //           <Divider>Card Size</Divider>
// // // //           <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: 16 }}>
// // // //             <Form.Item label="Width"><InputNumber value={cardSize.width} onChange={(v) => setCardSize({ ...cardSize, width: v })} min={200} max={1200} style={{ width: '100%' }} size="large" /></Form.Item>
// // // //             <Form.Item label="Height"><InputNumber value={cardSize.height} onChange={(v) => setCardSize({ ...cardSize, height: v })} min={150} max={800} style={{ width: '100%' }} size="large" /></Form.Item>
// // // //           </div>
// // // //           <Divider>Presets</Divider>
// // // //           <Space style={{ width: '100%', justifyContent: 'center' }}>
// // // //             <Button type={orientation === 'landscape' ? 'primary' : 'default'} icon={<SwapOutlined />} onClick={() => { setOrientation('landscape'); setCardSize({ width: 540, height: 340 }); }}>Landscape (540×340)</Button>
// // // //             <Button type={orientation === 'portrait' ? 'primary' : 'default'} icon={<SwapOutlined style={{ transform: 'rotate(90deg)' }} />} onClick={() => { setOrientation('portrait'); setCardSize({ width: 340, height: 540 }); }}>Portrait (340×540)</Button>
// // // //           </Space>
// // // //           <div style={{ marginTop: 16, padding: 12, background: '#f5f5f5', borderRadius: 8, textAlign: 'center' }}><span style={{ color: '#666' }}>Size: <strong>{cardSize.width} × {cardSize.height} px</strong></span></div>
// // // //         </Form>
// // // //       </Modal>

// // // //       {/* Preview Modal */}
// // // //       <Modal title={<Space><EyeOutlined />Preview</Space>} open={showPreview} onCancel={() => setShowPreview(false)} footer={<Space><Button onClick={() => setShowPreview(false)}>Close</Button><Button type="primary" icon={<DownloadOutlined />}>Download</Button></Space>} width={cardSize.width + 120} bodyStyle={{ display: 'flex', justifyContent: 'center', padding: 40, background: '#f0f2f5' }}>
// // // //         <div style={{ width: cardSize.width, height: cardSize.height }} />
// // // //       </Modal>
// // // //     </div>
// // // //     );
// // // // };

// // // // export default IDCardDesigner;


// // // // IDCardDesigner.js - Complete Version with Shapes, QR Colors, and Custom Photos
// // // import React, { useState, useEffect, useRef, useCallback } from "react";
// // // import {
// // //   Button, Modal, Form, Input, Select, InputNumber, ColorPicker,
// // //   Space, message, Spin, Card, Slider, Switch, Tooltip,
// // //   Segmented, Upload, Divider, Radio, Tabs
// // // } from "antd";
// // // import {
// // //   PlusOutlined, EditOutlined, DeleteOutlined, SaveOutlined,
// // //   EyeOutlined, SettingOutlined, DownloadOutlined,
// // //   IdcardOutlined, PictureOutlined, FontSizeOutlined,
// // //   SwapOutlined, CheckCircleOutlined,
// // //   QrcodeOutlined, CameraOutlined,
// // //   UserOutlined, PhoneOutlined, BankOutlined, TeamOutlined,
// // //   GlobalOutlined, CrownOutlined, StarOutlined, ThunderboltOutlined,
// // //   UploadOutlined, DeleteOutlined as DeleteIcon,
// // //   BgColorsOutlined, BorderOutlined, RadiusSettingOutlined,
// // //   HighlightOutlined, ShrinkOutlined,
// // // } from "@ant-design/icons";
// // // import { request } from "../../../share/request";
// // // import { getCurrentUser } from "../../../share/getProfile";
// // // import { linkPath } from "../../../share/helper";
// // // 
// // // import "./IDCardDesigner.css";

// // // const { Option } = Select;

// // // const GRADIENT_PRESETS = [
// // //   { name: 'None', color1: null, color2: null, direction: '135deg', type: 'none' },
// // //   { name: 'Ocean Blue', color1: '#1a237e', color2: '#0d47a1', direction: '135deg', type: 'linear' },
// // //   { name: 'Royal Purple', color1: '#4a148c', color2: '#7b1fa2', direction: '135deg', type: 'linear' },
// // //   { name: 'Sunset Gold', color1: '#f57f17', color2: '#e65100', direction: '45deg', type: 'linear' },
// // //   { name: 'Forest Green', color1: '#1b5e20', color2: '#004d40', direction: '135deg', type: 'linear' },
// // //   { name: 'Crimson Red', color1: '#b71c1c', color2: '#880e4f', direction: '135deg', type: 'linear' },
// // //   { name: 'Midnight Sky', color1: '#1a237e', color2: '#000051', direction: '180deg', type: 'linear' },
// // //   { name: 'Rose Gold', color1: '#880e4f', color2: '#e91e63', direction: '45deg', type: 'linear' },
// // //   { name: 'Teal Dream', color1: '#004d40', color2: '#00695c', direction: '135deg', type: 'linear' },
// // // ];

// // // const PATTERNS = [
// // //   { name: 'None', value: 'none' },
// // //   { name: 'Dots', value: 'dots' },
// // //   { name: 'Lines', value: 'lines' },
// // //   { name: 'Grid', value: 'grid' },
// // // ];

// // // const FONT_FAMILIES = [
// // //   { name: 'Content (Khmer)', value: 'Content, sans-serif' },
// // //   { name: 'Noto Sans Khmer', value: "'Noto Sans Khmer', sans-serif" },
// // //   { name: 'Hanuman', value: "'Hanuman', serif" },
// // //   { name: 'Battambang', value: "'Battambang', cursive" },
// // //   { name: 'Siemreap', value: "'Siemreap', cursive" },
// // //   { name: 'Moul', value: "'Moul', cursive" },
// // //   { name: 'Arial', value: 'Arial, sans-serif' },
// // //   { name: 'Times New Roman', value: "'Times New Roman', serif" },
// // //   { name: 'Courier New', value: "'Courier New', monospace" },
// // // ];

// // // const SHAPE_TYPES = [
// // //   { name: 'Rectangle', value: 'rectangle', icon: <BorderOutlined /> },
// // //   { name: 'Circle', value: 'circle', icon: <RadiusSettingOutlined /> },
// // //   { name: 'Rounded Rectangle', value: 'rounded', icon: <ShrinkOutlined /> },
// // // ];

// // // const IDCardDesigner = () => {
// // //   const getProfile = getCurrentUser();
// // //   const [loading, setLoading] = useState(false);
// // //   const [loadingSpin, setLoadingSpin] = useState(false);
// // //   const [templates, setTemplates] = useState([]);
// // //   const [currentTemplate, setCurrentTemplate] = useState(null);
// // //   const [elements, setElements] = useState([]);
// // //   const [selectedElement, setSelectedElement] = useState(null);
// // //   const [previewStaff, setPreviewStaff] = useState(null);
// // //   const [showPreview, setShowPreview] = useState(false);
// // //   const [showTemplateModal, setShowTemplateModal] = useState(false);
// // //   const [editingTemplate, setEditingTemplate] = useState(null);

// // //   const [orientation, setOrientation] = useState('landscape');
// // //   const [cardSize, setCardSize] = useState({ width: 540, height: 340 });

// // //   const [backgroundType, setBackgroundType] = useState('gradient');
// // //   const [bgColor, setBgColor] = useState('#1a237e');
// // //   const [gradientType, setGradientType] = useState('linear');
// // //   const [gradientColor1, setGradientColor1] = useState('#1a237e');
// // //   const [gradientColor2, setGradientColor2] = useState('#4a148c');
// // //   const [gradientDirection, setGradientDirection] = useState('135deg');
// // //   const [bgImage, setBgImage] = useState(null);
// // //   const [bgImageFile, setBgImageFile] = useState(null);
// // //   const [bgImagePreview, setBgImagePreview] = useState(null);
// // //   const [bgImageSize, setBgImageSize] = useState('cover');
// // //   const [bgImagePosition, setBgImagePosition] = useState('center');
// // //   const [bgImageOpacity, setBgImageOpacity] = useState(1);

// // //   const [borderRadius, setBorderRadius] = useState(16);
// // //   const [shadowEnabled, setShadowEnabled] = useState(true);
// // //   const [shadowColor, setShadowColor] = useState('rgba(0,0,0,0.3)');
// // //   const [shadowBlur, setShadowBlur] = useState(20);
// // //   const [shadowSpread, setShadowSpread] = useState(0);
// // //   const [shadowX, setShadowX] = useState(0);
// // //   const [shadowY, setShadowY] = useState(10);
  
// // //   const [overlayEnabled, setOverlayEnabled] = useState(false);
// // //   const [overlayPattern, setOverlayPattern] = useState('none');
// // //   const [overlayOpacity, setOverlayOpacity] = useState(0.1);
// // //   const [chipEnabled, setChipEnabled] = useState(true);
// // //   const [chipColor, setChipColor] = useState('#FFD700');
// // //   const [zoomLevel, setZoomLevel] = useState(1);

// // //   // Shape element properties
// // //   const [shapeFillType, setShapeFillType] = useState('solid'); // solid, gradient
// // //   const [shapeFillColor, setShapeFillColor] = useState('#4CAF50');
// // //   const [shapeGradientColor1, setShapeGradientColor1] = useState('#667eea');
// // //   const [shapeGradientColor2, setShapeGradientColor2] = useState('#764ba2');
// // //   const [shapeGradientDirection, setShapeGradientDirection] = useState('135deg');
// // //   const [shapeBorderRadius, setShapeBorderRadius] = useState(8);
// // //   const [shapeShadowEnabled, setShapeShadowEnabled] = useState(false);
// // //   const [shapeShadowColor, setShapeShadowColor] = useState('rgba(0,0,0,0.3)');
// // //   const [shapeShadowBlur, setShapeShadowBlur] = useState(10);
// // //   const [shapeOpacity, setShapeOpacity] = useState(1);
// // //   const [shapeBorderEnabled, setShapeBorderEnabled] = useState(false);
// // //   const [shapeBorderColor, setShapeBorderColor] = useState('#ffffff');
// // //   const [shapeBorderWidth, setShapeBorderWidth] = useState(1);

// // //   // QR Code style properties
// // //   const [qrBgColor, setQrBgColor] = useState('#FFFFFF');
// // //   const [qrFgColor, setQrFgColor] = useState('#000000');
// // //   const [qrCornerColor, setQrCornerColor] = useState('#000000');
// // //   const [qrStyle, setQrStyle] = useState('square'); // square, dots, rounded
// // //   const [qrEyeStyle, setQrEyeStyle] = useState('square'); // square, circle

// // //   const [signatureImage, setSignatureImage] = useState(null);
// // //   const [signatureFile, setSignatureFile] = useState(null);
// // //   const [signaturePreview, setSignaturePreview] = useState(null);
// // //   const [logoImage, setLogoImage] = useState(null);
// // //   const [logoFile, setLogoFile] = useState(null);
// // //   const [logoPreview, setLogoPreview] = useState(null);
// // //   const [uploadedImages, setUploadedImages] = useState([]);
  
// // //   // Custom photo state
// // //   const [customPhotoFile, setCustomPhotoFile] = useState(null);
// // //   const [customPhotoPreview, setCustomPhotoPreview] = useState(null);
// // //   const [customPhotoImage, setCustomPhotoImage] = useState(null);

// // //   const [isDragging, setIsDragging] = useState(false);
// // //   const [dragElement, setDragElement] = useState(null);
// // //   const [dragStartPos, setDragStartPos] = useState({ x: 0, y: 0 });
// // //   const [elementStartPos, setElementStartPos] = useState({ x: 0, y: 0 });
// // //   const canvasRef = useRef(null);
// // //   const [templateForm] = Form.useForm();

// // //   // ==================== HELPERS ====================
// // //   const getBackgroundStyle = () => {
// // //     let style = {};
// // //     if (backgroundType === 'image' && bgImagePreview) {
// // //       style.backgroundImage = `url(${bgImagePreview})`;
// // //       style.backgroundSize = bgImageSize === 'stretch' ? '100% 100%' : bgImageSize;
// // //       style.backgroundPosition = bgImagePosition;
// // //       style.backgroundRepeat = 'no-repeat';
// // //       if (bgImageOpacity < 1) style.opacity = bgImageOpacity;
// // //       return style;
// // //     }
// // //     if (backgroundType === 'gradient') {
// // //       style.background = gradientType === 'linear'
// // //         ? `linear-gradient(${gradientDirection}, ${gradientColor1}, ${gradientColor2})`
// // //         : `radial-gradient(circle at center, ${gradientColor1}, ${gradientColor2})`;
// // //     } else if (backgroundType === 'color') {
// // //       style.backgroundColor = bgColor;
// // //     } else {
// // //       style.backgroundColor = 'transparent';
// // //     }
// // //     if (overlayEnabled && overlayPattern !== 'none') {
// // //       const o = overlayOpacity;
// // //       if (overlayPattern === 'dots') {
// // //         style.backgroundImage = `radial-gradient(circle, rgba(255,255,255,${o}) 1px, transparent 1px)`;
// // //         style.backgroundSize = '20px 20px';
// // //       } else if (overlayPattern === 'lines') {
// // //         style.backgroundImage = `linear-gradient(90deg, rgba(255,255,255,${o}) 1px, transparent 1px)`;
// // //         style.backgroundSize = '20px 20px';
// // //       } else if (overlayPattern === 'grid') {
// // //         style.backgroundImage = `linear-gradient(90deg, rgba(255,255,255,${o}) 1px, transparent 1px), linear-gradient(0deg, rgba(255,255,255,${o}) 1px, transparent 1px)`;
// // //         style.backgroundSize = '20px 20px';
// // //       }
// // //     }
// // //     return style;
// // //   };

// // //   const getCardShadow = () => shadowEnabled 
// // //     ? `${shadowX}px ${shadowY}px ${shadowBlur}px ${shadowSpread}px ${shadowColor}` 
// // //     : 'none';

// // //   const getShapeStyle = (el) => {
// // //     let style = {
// // //       width: '100%',
// // //       height: '100%',
// // //       opacity: el.shape_opacity || 1,
// // //     };

// // //     // Fill style
// // //     if (el.shape_fill_type === 'gradient') {
// // //       style.background = `linear-gradient(${el.shape_gradient_direction || '135deg'}, ${el.shape_gradient_color1 || '#667eea'}, ${el.shape_gradient_color2 || '#764ba2'})`;
// // //     } else {
// // //       style.backgroundColor = el.shape_fill_color || '#4CAF50';
// // //     }

// // //     // Border radius
// // //     if (el.shape_type === 'circle') {
// // //       style.borderRadius = '50%';
// // //     } else if (el.shape_type === 'rounded') {
// // //       style.borderRadius = `${el.shape_border_radius || 8}px`;
// // //     }

// // //     // Shadow
// // //     if (el.shape_shadow_enabled) {
// // //       style.boxShadow = `0 ${el.shape_shadow_blur || 10}px ${el.shape_shadow_blur * 2 || 20}px ${el.shape_shadow_color || 'rgba(0,0,0,0.3)'}`;
// // //     }

// // //     // Border
// // //     if (el.shape_border_enabled) {
// // //       style.border = `${el.shape_border_width || 1}px solid ${el.shape_border_color || '#ffffff'}`;
// // //     }

// // //     return style;
// // //   };

// // //   const generateQRCode = (text, size, fgColor = '#000000', bgColor = '#FFFFFF') => {
// // //     if (!text) return '';
// // //     return `https://api.qrserver.com/v1/create-qr-code/?size=${size}x${size}&data=${encodeURIComponent(text)}&margin=5&color=${fgColor.replace('#', '')}&bgcolor=${bgColor.replace('#', '')}`;
// // //   };

// // //   // ==================== LOAD DATA ====================
// // //   const loadTemplates = async () => {
// // //     setLoading(true);
// // //     try {
// // //       const param = new URLSearchParams({ org_code: getProfile.org_code });
// // //       const res = await request(`id-card-templates?${param.toString()}`, "get", {});
// // //       if (res?.success) {
// // //         setTemplates(res.data);
// // //         if (res.data.length > 0 && !currentTemplate) loadTemplate(res.data[0].id);
// // //       }
// // //     } catch (e) { console.error(e); }
// // //     finally { setLoading(false); }
// // //   };

// // //   const loadTemplateImages = async (templateId) => {
// // //     try {
// // //       const res = await request(`id-card-images/template/${templateId}`, "get", {});
// // //       if (res?.success) {
// // //         setUploadedImages(res.data);
// // //         res.data.forEach(img => {
// // //           const url = `${linkPath}/${img.image_path}`;
// // //           if (img.image_type === 'signature') { setSignatureImage(img.image_path); setSignaturePreview(url); }
// // //           if (img.image_type === 'logo') { setLogoImage(img.image_path); setLogoPreview(url); }
// // //           if (img.image_type === 'custom_photo') { setCustomPhotoImage(img.image_path); setCustomPhotoPreview(url); }
// // //         });
// // //       }
// // //     } catch (e) { console.error(e); }
// // //   };

// // //   const loadTemplate = async (templateId) => {
// // //     setLoading(true);
// // //     try {
// // //       const res = await request(`id-card-templates/${templateId}`, "get", {});
// // //       if (res?.success) {
// // //         const tpl = res.data;
// // //         setCurrentTemplate(tpl);
// // //         setElements(tpl.elements || []);
// // //         setOrientation(tpl.orientation || 'landscape');
// // //         setCardSize({ width: tpl.width || 540, height: tpl.height || 340 });
// // //         setBackgroundType(tpl.background_type || 'gradient');
// // //         setBgColor(tpl.background_color || '#1a237e');
// // //         setGradientType(tpl.gradient_type || 'linear');
// // //         setGradientColor1(tpl.gradient_color1 || '#1a237e');
// // //         setGradientColor2(tpl.gradient_color2 || '#4a148c');
// // //         setGradientDirection(tpl.gradient_direction || '135deg');
// // //         if (tpl.background_image) {
// // //           setBgImage(tpl.background_image);
// // //           setBgImagePreview(`${linkPath}/${tpl.background_image}`);
// // //         } else { setBgImage(null); setBgImagePreview(null); }
// // //         setBgImageSize(tpl.bg_image_size || 'cover');
// // //         setBgImagePosition(tpl.bg_image_position || 'center');
// // //         setBgImageOpacity(tpl.bg_image_opacity || 1);
// // //         setBorderRadius(tpl.border_radius || 16);
// // //         setShadowEnabled(tpl.shadow_enabled === 1);
// // //         setShadowColor(tpl.shadow_color || 'rgba(0,0,0,0.3)');
// // //         setShadowBlur(tpl.shadow_blur || 20);
// // //         setShadowSpread(tpl.shadow_spread || 0);
// // //         setShadowX(tpl.shadow_x || 0);
// // //         setShadowY(tpl.shadow_y || 10);
// // //         setOverlayEnabled(tpl.overlay_enabled === 1);
// // //         setOverlayPattern(tpl.overlay_pattern || 'none');
// // //         setOverlayOpacity(tpl.overlay_opacity || 0.1);
// // //         setChipEnabled(tpl.chip_enabled === 1);
// // //         setChipColor(tpl.chip_color || '#FFD700');
// // //         setSelectedElement(null);
// // //         loadTemplateImages(templateId);
// // //       }
// // //     } catch (e) { console.error(e); }
// // //     finally { setLoading(false); }
// // //   };

// // //   useEffect(() => { loadTemplates(); }, []);

// // //   // ==================== HANDLERS ====================
// // //   const handleOrientationChange = (v) => {
// // //     setOrientation(v);
// // //     setCardSize(v === 'portrait' ? { width: 340, height: 540 } : { width: 540, height: 340 });
// // //   };

// // //   const handleBgImageUpload = (file) => {
// // //     const r = new FileReader();
// // //     r.onload = (e) => { setBgImagePreview(e.target.result); setBgImageFile(file); };
// // //     r.readAsDataURL(file);
// // //     return false;
// // //   };
// // //   const handleRemoveBgImage = () => { setBgImagePreview(null); setBgImageFile(null); setBgImage(null); };

// // //   const handleSignatureUpload = (file) => {
// // //     const r = new FileReader();
// // //     r.onload = (e) => { setSignaturePreview(e.target.result); setSignatureFile(file); };
// // //     r.readAsDataURL(file);
// // //     return false;
// // //   };
// // //   const handleRemoveSignature = () => { setSignaturePreview(null); setSignatureFile(null); setSignatureImage(null); };

// // //   const handleLogoUpload = (file) => {
// // //     const r = new FileReader();
// // //     r.onload = (e) => { setLogoPreview(e.target.result); setLogoFile(file); };
// // //     r.readAsDataURL(file);
// // //     return false;
// // //   };
// // //   const handleRemoveLogo = () => { setLogoPreview(null); setLogoFile(null); setLogoImage(null); };

// // //   const handleCustomPhotoUpload = (file) => {
// // //     const r = new FileReader();
// // //     r.onload = (e) => { setCustomPhotoPreview(e.target.result); setCustomPhotoFile(file); };
// // //     r.readAsDataURL(file);
// // //     return false;
// // //   };
// // //   const handleRemoveCustomPhoto = () => { setCustomPhotoPreview(null); setCustomPhotoFile(null); setCustomPhotoImage(null); };

// // //   const uploadImageWithType = async (file, imageType) => {
// // //     const fd = new FormData();
// // //     fd.append('idcard_bg', file);
// // //     fd.append('template_id', currentTemplate?.id);
// // //     fd.append('image_type', imageType);
// // //     fd.append('org_code', getProfile.org_code);
// // //     try {
// // //       const res = await request("id-card-images", "POST", fd, true);
// // //       if (res?.success) { message.success(`${imageType} uploaded!`); loadTemplateImages(currentTemplate?.id); return res.data; }
// // //     } catch (e) { message.error("Upload failed"); }
// // //     return null;
// // //   };

// // //   const addElement = (type, key = null, label = '') => {
// // //     const defaults = {
// // //       text: { w: 150, h: 30, fs: 14, fw: 'bold' },
// // //       'custom-text': { w: 150, h: 30, fs: 14, fw: 'normal' },
// // //       image: { w: 80, h: 100, fs: 0, fw: 'normal' },
// // //       qrcode: { w: 80, h: 80, fs: 0, fw: 'normal' },
// // //       shape: { w: 100, h: 80, fs: 0, fw: 'normal' },
// // //     };
// // //     const s = defaults[type] || defaults.text;
// // //     const el = {
// // //       template_id: currentTemplate?.id,
// // //       element_type: type, element_key: key, label: label || type,
// // //       custom_text: type === 'custom-text' ? 'Enter text' : '',
// // //       x_position: 50 + elements.length * 20, y_position: 50 + elements.length * 20,
// // //       width: s.w, height: s.h, font_size: s.fs, font_color: '#FFFFFF',
// // //       font_weight: s.fw, font_family: 'Content, sans-serif', text_align: 'left',
// // //       is_visible: 1, sort_order: elements.length + 1, is_new: true,
// // //       tempId: `t_${Date.now()}_${Math.random().toString(36).substr(2, 9)}`,
// // //       // Shape defaults
// // //       shape_type: 'rounded',
// // //       shape_fill_type: 'solid',
// // //       shape_fill_color: '#4CAF50',
// // //       shape_gradient_color1: '#667eea',
// // //       shape_gradient_color2: '#764ba2',
// // //       shape_gradient_direction: '135deg',
// // //       shape_border_radius: 8,
// // //       shape_shadow_enabled: false,
// // //       shape_shadow_color: 'rgba(0,0,0,0.3)',
// // //       shape_shadow_blur: 10,
// // //       shape_opacity: 1,
// // //       shape_border_enabled: false,
// // //       shape_border_color: '#ffffff',
// // //       shape_border_width: 1,
// // //       // QR Code defaults
// // //       qr_bg_color: '#FFFFFF',
// // //       qr_fg_color: '#000000',
// // //       qr_corner_color: '#000000',
// // //       qr_style: 'square',
// // //       qr_eye_style: 'square',
// // //     };
// // //     setElements([...elements, el]);
// // //     setSelectedElement(el);
// // //   };

// // //   const handleMouseDown = (e, el) => {
// // //     e.preventDefault(); e.stopPropagation();
// // //     setSelectedElement(el);
// // //     // Load element-specific properties
// // //     if (el.element_type === 'shape') {
// // //       setShapeFillType(el.shape_fill_type || 'solid');
// // //       setShapeFillColor(el.shape_fill_color || '#4CAF50');
// // //       setShapeGradientColor1(el.shape_gradient_color1 || '#667eea');
// // //       setShapeGradientColor2(el.shape_gradient_color2 || '#764ba2');
// // //       setShapeGradientDirection(el.shape_gradient_direction || '135deg');
// // //       setShapeBorderRadius(el.shape_border_radius || 8);
// // //       setShapeShadowEnabled(el.shape_shadow_enabled || false);
// // //       setShapeShadowColor(el.shape_shadow_color || 'rgba(0,0,0,0.3)');
// // //       setShapeShadowBlur(el.shape_shadow_blur || 10);
// // //       setShapeOpacity(el.shape_opacity || 1);
// // //       setShapeBorderEnabled(el.shape_border_enabled || false);
// // //       setShapeBorderColor(el.shape_border_color || '#ffffff');
// // //       setShapeBorderWidth(el.shape_border_width || 1);
// // //     }
// // //     if (el.element_type === 'qrcode') {
// // //       setQrBgColor(el.qr_bg_color || '#FFFFFF');
// // //       setQrFgColor(el.qr_fg_color || '#000000');
// // //       setQrCornerColor(el.qr_corner_color || '#000000');
// // //       setQrStyle(el.qr_style || 'square');
// // //       setQrEyeStyle(el.qr_eye_style || 'square');
// // //     }
// // //     setIsDragging(true); setDragElement(el);
// // //     setDragStartPos({ x: e.clientX, y: e.clientY });
// // //     setElementStartPos({ x: el.x_position || 0, y: el.y_position || 0 });
// // //   };

// // //   const handleMouseMove = useCallback((e) => {
// // //     if (!isDragging || !dragElement) return;
// // //     const dx = (e.clientX - dragStartPos.x) / zoomLevel;
// // //     const dy = (e.clientY - dragStartPos.y) / zoomLevel;
// // //     const nx = Math.max(0, Math.min(cardSize.width - (dragElement.width || 100), elementStartPos.x + dx));
// // //     const ny = Math.max(0, Math.min(cardSize.height - (dragElement.height || 30), elementStartPos.y + dy));
// // //     const eid = dragElement.id || dragElement.tempId;
// // //     setElements(prev => prev.map(el => (el.id || el.tempId) === eid ? { ...el, x_position: Math.round(nx), y_position: Math.round(ny) } : el));
// // //   }, [isDragging, dragElement, dragStartPos, elementStartPos, cardSize, zoomLevel]);

// // //   const handleMouseUp = useCallback(() => { setIsDragging(false); setDragElement(null); }, [isDragging]);

// // //   useEffect(() => {
// // //     if (isDragging) { window.addEventListener('mousemove', handleMouseMove); window.addEventListener('mouseup', handleMouseUp); }
// // //     return () => { window.removeEventListener('mousemove', handleMouseMove); window.removeEventListener('mouseup', handleMouseUp); };
// // //   }, [isDragging]);

// // //   const updateElementProps = (eid, props) => {
// // //     setElements(prev => prev.map(el => (el.id || el.tempId) === eid ? { ...el, ...props } : el));
// // //     setSelectedElement(prev => prev && ((prev.id || prev.tempId) === eid) ? { ...prev, ...props } : prev);
// // //   };

// // //   const deleteElement = async (eid) => {
// // //     const el = elements.find(e => (e.id || e.tempId) === eid);
// // //     if (el?.is_new) { setElements(elements.filter(e => (e.id || e.tempId) !== eid)); setSelectedElement(null); return; }
// // //     if (el?.id) {
// // //       try { await request(`id-card-elements/${el.id}`, "DELETE", {}); setElements(elements.filter(e => e.id !== el.id)); setSelectedElement(null); }
// // //       catch (e) { console.error(e); }
// // //     }
// // //   };

// // //   // ==================== SAVE ====================
// // //   const saveElements = async () => {
// // //     if (!currentTemplate) { message.warning("Select a template first"); return; }
// // //     setLoadingSpin(true);
// // //     try {
// // //       if (signatureFile) { const d = await uploadImageWithType(signatureFile, 'signature'); if (d) { setSignatureImage(d.filename); setSignatureFile(null); } }
// // //       if (logoFile) { const d = await uploadImageWithType(logoFile, 'logo'); if (d) { setLogoImage(d.filename); setLogoFile(null); } }
// // //       if (customPhotoFile) { const d = await uploadImageWithType(customPhotoFile, 'custom_photo'); if (d) { setCustomPhotoImage(d.filename); setCustomPhotoFile(null); } }
// // //       let fBg = bgImage;
// // //       if (bgImageFile) {
// // //         const fd = new FormData(); fd.append('idcard_bg', bgImageFile);
// // //         const res = await request("id-card-upload", "POST", fd, true);
// // //         if (res?.success) { fBg = res.data.filename; setBgImage(fBg); setBgImageFile(null); setBgImagePreview(`${linkPath}/${res.data.filename}`); }
// // //       }
// // //       await request(`id-card-templates/${currentTemplate.id}`, "PUT", {
// // //         width: cardSize.width, height: cardSize.height, orientation,
// // //         background_type: backgroundType, background_color: bgColor, background_image: fBg,
// // //         gradient_type: gradientType, gradient_color1: gradientColor1, gradient_color2: gradientColor2, gradient_direction: gradientDirection,
// // //         bg_image_size: bgImageSize, bg_image_position: bgImagePosition, bg_image_opacity: bgImageOpacity,
// // //         border_radius: borderRadius, shadow_enabled: shadowEnabled, shadow_color: shadowColor,
// // //         shadow_blur: shadowBlur, shadow_spread: shadowSpread, shadow_x: shadowX, shadow_y: shadowY,
// // //         overlay_enabled: overlayEnabled, overlay_pattern: overlayPattern, overlay_opacity: overlayOpacity,
// // //         chip_enabled: chipEnabled, chip_color: chipColor,
// // //       });
// // //       for (const el of elements) {
// // //         const data = {
// // //           id: el.id || null, template_id: currentTemplate.id,
// // //           element_type: el.element_type, element_key: el.element_key, label: el.label,
// // //           custom_text: el.custom_text || null,
// // //           x_position: el.x_position, y_position: el.y_position, width: el.width, height: el.height,
// // //           font_size: el.font_size, font_color: el.font_color, font_weight: el.font_weight,
// // //           font_family: el.font_family, text_align: el.text_align,
// // //           is_visible: el.is_visible, sort_order: el.sort_order,
// // //           // Shape properties
// // //           shape_type: el.shape_type, shape_fill_type: el.shape_fill_type,
// // //           shape_fill_color: el.shape_fill_color, shape_gradient_color1: el.shape_gradient_color1,
// // //           shape_gradient_color2: el.shape_gradient_color2, shape_gradient_direction: el.shape_gradient_direction,
// // //           shape_border_radius: el.shape_border_radius, shape_shadow_enabled: el.shape_shadow_enabled,
// // //           shape_shadow_color: el.shape_shadow_color, shape_shadow_blur: el.shape_shadow_blur,
// // //           shape_opacity: el.shape_opacity, shape_border_enabled: el.shape_border_enabled,
// // //           shape_border_color: el.shape_border_color, shape_border_width: el.shape_border_width,
// // //           // QR Code properties
// // //           qr_bg_color: el.qr_bg_color, qr_fg_color: el.qr_fg_color,
// // //           qr_corner_color: el.qr_corner_color, qr_style: el.qr_style, qr_eye_style: el.qr_eye_style,
// // //         };
// // //         const r = await request("id-card-elements", "POST", data);
// // //         if (r?.data?.id && el.is_new) {
// // //           setElements(prev => prev.map(e => e.tempId === el.tempId ? { ...e, id: r.data.id, is_new: false } : e));
// // //         }
// // //       }
// // //       message.success("💾 Saved!");
// // //       loadTemplate(currentTemplate.id);
// // //     } catch (e) { console.error(e); message.error("Save failed"); }
// // //     finally { setLoadingSpin(false); }
// // //   };

// // //   const previewIDCard = async () => {
// // //     setLoadingSpin(true);
// // //     try {
// // //       const res = await request(`id-card-preview?username=${getProfile.username}&org_code=${getProfile.org_code}`, "get", {});
// // //       if (res?.success) { setPreviewStaff(res.data.staff); setShowPreview(true); }
// // //     } catch (e) { console.error(e); }
// // //     finally { setLoadingSpin(false); }
// // //   };

// // //   const handleTemplateSave = async () => {
// // //     try {
// // //       const v = await templateForm.validateFields();
// // //       setLoadingSpin(true);
// // //       const data = { ...v, org_code: getProfile.org_code, usercreate: getProfile.fullname, width: cardSize.width, height: cardSize.height, orientation, background_type: backgroundType, background_color: bgColor, gradient_type: gradientType, gradient_color1: gradientColor1, gradient_color2: gradientColor2, gradient_direction: gradientDirection, border_radius: borderRadius, shadow_enabled: shadowEnabled, shadow_color: shadowColor, overlay_enabled: overlayEnabled, chip_enabled: chipEnabled, chip_color: chipColor };
// // //       const res = editingTemplate ? await request(`id-card-templates/${editingTemplate.id}`, "PUT", data) : await request("id-card-templates", "POST", data);
// // //       if (res?.isOk) { message.success(editingTemplate ? "✅ Updated!" : "✨ Created!"); setShowTemplateModal(false); templateForm.resetFields(); loadTemplates(); }
// // //     } catch (e) { console.error(e); }
// // //     finally { setLoadingSpin(false); }
// // //   };

// // //   const applyGradientPreset = (p) => {
// // //     if (p.type === 'none') { setBackgroundType('none'); return; }
// // //     setBackgroundType('gradient'); setGradientColor1(p.color1); setGradientColor2(p.color2); setGradientDirection(p.direction); setGradientType(p.type);
// // //   };

// // //   // Update shape properties for selected element
// // //   const updateShapeProps = (props) => {
// // //     if (!selectedElement) return;
// // //     updateElementProps(selectedElement.id || selectedElement.tempId, props);
// // //   };

// // //   // Update QR code properties for selected element
// // //   const updateQRProps = (props) => {
// // //     if (!selectedElement) return;
// // //     updateElementProps(selectedElement.id || selectedElement.tempId, props);
// // //   };

// // //   // ==================== RENDER ====================
// // //   const renderIDCard = () => (
// // //     <div ref={canvasRef} style={{
// // //       width: cardSize.width, height: cardSize.height, ...getBackgroundStyle(),
// // //       borderRadius: borderRadius, boxShadow: getCardShadow(),
// // //       position: 'relative', overflow: 'hidden',
// // //       border: backgroundType === 'none' ? '2px dashed #d9d9d9' : '1px solid rgba(255,255,255,0.2)',
// // //       cursor: isDragging ? 'grabbing' : 'default', userSelect: 'none',
// // //     }}>
// // //       {backgroundType !== 'none' && (
// // //         <>
// // //           <div style={{ position: 'absolute', top: -60, right: -60, width: 220, height: 220, borderRadius: '50%', background: 'rgba(255,255,255,0.03)', pointerEvents: 'none' }} />
// // //           <div style={{ position: 'absolute', bottom: -90, left: -40, width: 280, height: 280, borderRadius: '50%', background: 'rgba(255,255,255,0.03)', pointerEvents: 'none' }} />
// // //         </>
// // //       )}
// // //       {chipEnabled && (
// // //         <div style={{ position: 'absolute', top: 20, left: 20, width: 45, height: 32, borderRadius: 6, background: `linear-gradient(135deg, ${chipColor}, ${chipColor}cc)`, boxShadow: '0 2px 8px rgba(0,0,0,0.2)', zIndex: 2, pointerEvents: 'none' }}>
// // //           <div style={{ width: '100%', height: '100%', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
// // //             <div style={{ width: 22, height: 16, borderRadius: 3, background: 'rgba(255,255,255,0.3)', border: '1px solid rgba(255,255,255,0.5)' }} />
// // //           </div>
// // //         </div>
// // //       )}
// // //       {backgroundType === 'none' && (
// // //         <div style={{ position: 'absolute', top: '50%', left: '50%', transform: 'translate(-50%,-50%)', color: '#d9d9d9', textAlign: 'center', pointerEvents: 'none' }}>
// // //           <PictureOutlined style={{ fontSize: 48, display: 'block', marginBottom: 8 }} />
// // //           {cardSize.width} × {cardSize.height}
// // //         </div>
// // //       )}
// // //       {elements.filter(el => el.is_visible !== 0).map((el, i) => {
// // //         const eid = el.id || el.tempId;
// // //         const sel = selectedElement && (selectedElement.id || selectedElement.tempId) === eid;
// // //         return (
// // //           <div key={eid} onMouseDown={(e) => handleMouseDown(e, el)} style={{
// // //             position: 'absolute', left: el.x_position || 0, top: el.y_position || 0,
// // //             width: el.width || 100, height: el.height || 30,
// // //             display: 'flex', alignItems: 'center',
// // //             justifyContent: el.text_align === 'center' ? 'center' : el.text_align === 'right' ? 'flex-end' : 'flex-start',
// // //             fontSize: el.font_size || 12, color: el.font_color || '#FFF',
// // //             fontWeight: el.font_weight || 'normal', fontFamily: el.font_family || 'Content',
// // //             zIndex: sel ? 100 : 2, overflow: 'hidden', cursor: 'move',
// // //             border: sel ? '2px solid #1890ff' : (el.element_type === 'shape' ? 'none' : '1px dashed rgba(255,255,255,0.3)'),
// // //             background: el.element_type === 'shape' ? 'transparent' : (sel ? 'rgba(24,144,255,0.15)' : 'rgba(255,255,255,0.05)'),
// // //             borderRadius: el.element_type === 'shape' ? 0 : 4, padding: el.element_type === 'shape' ? 0 : 2,
// // //           }}>
// // //             {el.element_type === 'shape' ? (
// // //               <div style={getShapeStyle(el)}>
// // //                 {/* Shape content - can have text inside */}
// // //                 {el.label && (
// // //                   <div style={{
// // //                     position: 'absolute',
// // //                     top: '50%',
// // //                     left: '50%',
// // //                     transform: 'translate(-50%, -50%)',
// // //                     color: '#fff',
// // //                     fontSize: el.font_size || 12,
// // //                     fontWeight: el.font_weight || 'bold',
// // //                     textAlign: 'center',
// // //                     width: '100%',
// // //                     padding: '4px',
// // //                   }}>
// // //                     {el.label}
// // //                   </div>
// // //                 )}
// // //               </div>
// // //             ) : el.element_type === 'qrcode' ? (
// // //               <div style={{ 
// // //                 width: '100%', 
// // //                 height: '100%', 
// // //                 display: 'flex', 
// // //                 alignItems: 'center', 
// // //                 justifyContent: 'center', 
// // //                 background: el.qr_bg_color || '#FFFFFF', 
// // //                 borderRadius: 4, 
// // //                 padding: 4 
// // //               }}>
// // //                 <img 
// // //                   src={generateQRCode(
// // //                     el.label || 'QR', 
// // //                     Math.min(el.width, el.height),
// // //                     el.qr_fg_color || '#000000',
// // //                     el.qr_bg_color || '#FFFFFF'
// // //                   )} 
// // //                   alt="QR" 
// // //                   style={{ 
// // //                     width: '100%', 
// // //                     height: '100%', 
// // //                     objectFit: 'contain',
// // //                     borderRadius: el.qr_style === 'rounded' ? '8px' : '0',
// // //                   }} 
// // //                 />
// // //               </div>
// // //             ) : el.element_type === 'image' ? (
// // //               <div style={{ 
// // //                 width: '100%', 
// // //                 height: '100%', 
// // //                 borderRadius: el.element_key === 'photo' ? 6 : 0, 
// // //                 border: el.element_key === 'photo' ? '1px solid rgba(255,255,255,0.3)' : 'none', 
// // //                 overflow: 'hidden', 
// // //                 display: 'flex', 
// // //                 alignItems: 'center', 
// // //                 justifyContent: 'center', 
// // //                 background: 'rgba(255,255,255,0.1)', 
// // //                 color: 'rgba(255,255,255,0.6)', 
// // //                 fontSize: 11 
// // //               }}>
// // //                 {el.element_key === 'signature' ? (signaturePreview ? <img src={signaturePreview} alt="Sig" style={{ width: '100%', height: '100%', objectFit: 'contain' }} /> : <EditOutlined style={{ fontSize: 20 }} />) :
// // //                  el.element_key === 'org_logo' ? (logoPreview ? <img src={logoPreview} alt="Logo" style={{ width: '100%', height: '100%', objectFit: 'contain' }} /> : <BankOutlined style={{ fontSize: 20 }} />) :
// // //                  el.element_key === 'photo' ? <CameraOutlined style={{ fontSize: 20 }} /> :
// // //                  el.element_key === 'custom_photo' ? (customPhotoPreview ? <img src={customPhotoPreview} alt="Custom" style={{ width: '100%', height: '100%', objectFit: 'cover' }} /> : <PictureOutlined style={{ fontSize: 20 }} />) :
// // //                  <PictureOutlined style={{ fontSize: 20 }} />}
// // //               </div>
// // //             ) : (
// // //               <span style={{ width: '100%', textAlign: el.text_align || 'left', fontFamily: el.font_family || 'Content, sans-serif' }}>
// // //                 {el.element_type === 'custom-text' ? (el.custom_text || 'Custom Text') : el.label}
// // //               </span>
// // //             )}
// // //             {sel && <div style={{ position: 'absolute', top: -10, right: -10, width: 20, height: 20, borderRadius: '50%', background: '#ff4d4f', color: 'white', display: 'flex', alignItems: 'center', justifyContent: 'center', cursor: 'pointer', fontSize: 12, zIndex: 101 }} onClick={(e) => { e.stopPropagation(); deleteElement(eid); }}>×</div>}
// // //           </div>
// // //         );
// // //       })}
// // //     </div>
// // //   );

// // //   const elementGroups = [
// // //     { title: '👤 Personal', items: [
// // //       { type: 'text', key: 'fullname', label: 'Full Name', icon: <UserOutlined /> },
// // //       { type: 'text', key: 'frontname', label: 'Title', icon: <StarOutlined /> },
// // //       { type: 'text', key: 'staffname_eng', label: 'Name ENG', icon: <GlobalOutlined /> },
// // //       { type: 'text', key: 'idnumber', label: 'ID Number', icon: <IdcardOutlined /> },
// // //       { type: 'text', key: 'gender', label: 'Gender', icon: <UserOutlined /> },
// // //       { type: 'text', key: 'dob', label: 'DOB', icon: <IdcardOutlined /> },
// // //     ]},
// // //     { title: '💼 Work', items: [
// // //       { type: 'text', key: 'position_name', label: 'Position', icon: <CrownOutlined /> },
// // //       { type: 'text', key: 'department_name', label: 'Department', icon: <TeamOutlined /> },
// // //       { type: 'text', key: 'skill_name', label: 'Skill', icon: <ThunderboltOutlined /> },
// // //       { type: 'text', key: 'jobstatus', label: 'Job Status', icon: <CheckCircleOutlined /> },
// // //       { type: 'text', key: 'stafftype', label: 'Staff Type', icon: <IdcardOutlined /> },
// // //       { type: 'text', key: 'level', label: 'Level', icon: <StarOutlined /> },
// // //       { type: 'text', key: 'joinwork', label: 'Join Date', icon: <IdcardOutlined /> },
// // //     ]},
// // //     { title: '📱 Contact', items: [
// // //       { type: 'text', key: 'username', label: 'Phone', icon: <PhoneOutlined /> },
// // //     ]},
// // //     { title: '🖼️ Media', items: [
// // //       { type: 'image', key: 'photo', label: 'Photo', icon: <CameraOutlined /> },
// // //       { type: 'image', key: 'org_logo', label: 'Org Logo', icon: <BankOutlined /> },
// // //       { type: 'image', key: 'signature', label: 'Signature', icon: <EditOutlined /> },
// // //       { type: 'image', key: 'custom_photo', label: 'Custom Photo', icon: <PictureOutlined /> },
// // //       { type: 'text', key: 'org_name', label: 'Org Name', icon: <GlobalOutlined /> },
// // //     ]},
// // //     { title: '✏️ Custom', items: [
// // //       { type: 'custom-text', key: 'custom_text', label: 'Custom Text', icon: <FontSizeOutlined /> },
// // //     ]},
// // //     { title: '🎨 Shapes', items: [
// // //       { type: 'shape', key: null, label: 'Shape', icon: <HighlightOutlined /> },
// // //     ]},
// // //     { title: '🔢 Extra', items: [
// // //       { type: 'qrcode', key: 'qrcode_id', label: 'QR Code', icon: <QrcodeOutlined /> },
// // //       { type: 'text', key: 'role_name', label: 'Role', icon: <TeamOutlined /> },
// // //     ]},
// // //   ];

// // //   return (
// // //     <div className="id-card-designer" style={{ padding: 24, background: '#f0f2f5', minHeight: '100vh' }}>
// // //       {loadingSpin && <div className="sprinSave"><GetLoading /></div>}
      
// // //       {/* Header */}
// // //       <div style={{ background: 'linear-gradient(135deg, #667eea, #764ba2)', borderRadius: 16, padding: '24px 32px', marginBottom: 24, color: 'white', boxShadow: '0 10px 40px rgba(102,126,234,0.4)' }}>
// // //         <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', flexWrap: 'wrap', gap: 16 }}>
// // //           <div>
// // //             <h1 style={{ color: 'white', margin: 0, fontSize: 28, fontWeight: 700 }}><IdcardOutlined style={{ marginRight: 12 }} />ID Card Designer</h1>
// // //             <p style={{ color: 'rgba(255,255,255,0.8)', margin: '8px 0 0', fontSize: 14 }}>Click & drag elements to position them</p>
// // //           </div>
// // //           <Space>
// // //              <Button icon={<SaveOutlined />} onClick={saveElements} loading={loadingSpin} size="large" style={{ background: 'white', color: '#667eea', border: 'none' }}>Save Design</Button>
// // //           </Space>
// // //         </div>
// // //       </div>

// // //       <div style={{ display: 'grid', gridTemplateColumns: '260px 1fr 350px', gap: 24 }}>
// // //         {/* Left - Elements */}
// // //         <Card title="📦 Elements" style={{ borderRadius: 16, boxShadow: '0 4px 20px rgba(0,0,0,0.08)', position: 'sticky', top: 24 }}>
// // //           <Segmented block value={orientation} onChange={handleOrientationChange} options={[{ label: '🏞️ Landscape', value: 'landscape' }, { label: '📱 Portrait', value: 'portrait' }]} style={{ marginBottom: 16 }} />
// // //           <Divider />
// // //           {elementGroups.map(g => (
// // //             <div key={g.title} style={{ marginBottom: 20 }}>
// // //               <h4 style={{ color: '#666', fontSize: 12, textTransform: 'uppercase', marginBottom: 8 }}>{g.title}</h4>
// // //               <Space direction="vertical" style={{ width: '100%' }}>
// // //                 {g.items.map(item => (
// // //                   <Button key={item.key || item.label} block icon={item.icon} onClick={() => addElement(item.type, item.key, item.label)} style={{ textAlign: 'left', borderRadius: 10, height: 40 }}>{item.label}</Button>
// // //                 ))}
// // //               </Space>
// // //             </div>
// // //           ))}
// // //         </Card>

// // //         {/* Center - Canvas */}
// // //         <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', gap: 16 }}>
// // //           <Card style={{ width: '100%', borderRadius: 16, boxShadow: '0 4px 20px rgba(0,0,0,0.08)' }}>
// // //             <Space style={{ width: '100%', justifyContent: 'space-between' }}>
// // //               <Select style={{ width: 250 }} placeholder="Select template" value={currentTemplate?.id} onChange={loadTemplate} size="large">
// // //                 {templates.map(t => <Option key={t.id} value={t.id}>{t.is_default === 1 && '⭐ '}{t.template_name}</Option>)}
// // //               </Select>
// // //               <Space>
// // //                 <Button icon={<PlusOutlined />} onClick={() => { setEditingTemplate(null); templateForm.resetFields(); setShowTemplateModal(true); }}>New</Button>
// // //                 <Button icon={<SettingOutlined />} onClick={() => { setEditingTemplate(currentTemplate); templateForm.setFieldsValue(currentTemplate); setShowTemplateModal(true); }} disabled={!currentTemplate}>Settings</Button>
// // //               </Space>
// // //             </Space>
// // //           </Card>
// // //           <div style={{ background: '#e8e8e8', borderRadius: 16, padding: 40, boxShadow: 'inset 0 2px 10px rgba(0,0,0,0.1)', overflow: 'auto', maxHeight: 'calc(100vh - 300px)', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
// // //             <div style={{ transform: `scale(${zoomLevel})`, transformOrigin: 'center center', transition: 'transform 0.2s' }}>{renderIDCard()}</div>
// // //           </div>
// // //           <Card size="small" style={{ borderRadius: 12 }}>
// // //             <Space><span>🔍</span><Slider min={0.5} max={1.5} step={0.1} value={zoomLevel} onChange={setZoomLevel} style={{ width: 150 }} /><span>{Math.round(zoomLevel * 100)}%</span></Space>
// // //           </Card>
// // //         </div>

// // //         {/* Right - Settings */}
// // //         <div style={{ maxHeight: 'calc(100vh - 150px)', overflowY: 'auto' }}>
// // //           {/* Background */}
// // //           <Card title="🎨 Background" style={{ borderRadius: 16, boxShadow: '0 4px 20px rgba(0,0,0,0.08)', marginBottom: 16 }}>
// // //             <Radio.Group value={backgroundType} onChange={(e) => setBackgroundType(e.target.value)} style={{ marginBottom: 16, width: '100%' }} size="small">
// // //               <Radio.Button value="none" style={{ width: '25%', textAlign: 'center' }}>None</Radio.Button>
// // //               <Radio.Button value="color" style={{ width: '25%', textAlign: 'center' }}>Color</Radio.Button>
// // //               <Radio.Button value="gradient" style={{ width: '25%', textAlign: 'center' }}>Gradient</Radio.Button>
// // //               <Radio.Button value="image" style={{ width: '25%', textAlign: 'center' }}>Image</Radio.Button>
// // //             </Radio.Group>
// // //             {backgroundType === 'color' && (
// // //               <div style={{ marginBottom: 12 }}>
// // //                 <label style={{ fontSize: 12, color: '#666' }}>Color</label>
// // //                 <ColorPicker value={bgColor} onChange={(c) => setBgColor(c.toHexString())} style={{ width: '100%' }} />
// // //               </div>
// // //             )}
// // //             {backgroundType === 'gradient' && (
// // //               <div>
// // //                 <div style={{ marginBottom: 12 }}>
// // //                   <label style={{ fontSize: 12, color: '#666' }}>Presets</label>
// // //                   <div style={{ display: 'grid', gridTemplateColumns: 'repeat(4, 1fr)', gap: 6 }}>
// // //                     {GRADIENT_PRESETS.filter(p => p.type !== 'none').map((p, i) => (
// // //                       <Tooltip key={i} title={p.name}>
// // //                         <div onClick={() => applyGradientPreset(p)} style={{ height: 30, borderRadius: 6, cursor: 'pointer', background: `linear-gradient(${p.direction}, ${p.color1}, ${p.color2})`, border: gradientColor1 === p.color1 ? '2px solid #1890ff' : '2px solid transparent' }} />
// // //                       </Tooltip>
// // //                     ))}
// // //                   </div>
// // //                 </div>
// // //                 <Select value={gradientType} onChange={setGradientType} style={{ width: '100%', marginBottom: 8 }} size="small">
// // //                   <Option value="linear">Linear</Option>
// // //                   <Option value="radial">Radial</Option>
// // //                 </Select>
// // //                 <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: 8, marginBottom: 8 }}>
// // //                   <ColorPicker value={gradientColor1} onChange={(c) => setGradientColor1(c.toHexString())} />
// // //                   <ColorPicker value={gradientColor2} onChange={(c) => setGradientColor2(c.toHexString())} />
// // //                 </div>
// // //                 <Select value={gradientDirection} onChange={setGradientDirection} style={{ width: '100%' }} size="small">
// // //                   {['0deg','45deg','90deg','135deg','180deg','225deg','270deg','315deg'].map(d => <Option key={d} value={d}>{d}</Option>)}
// // //                 </Select>
// // //               </div>
// // //             )}
// // //             {backgroundType === 'image' && (
// // //               <div>
// // //                 <label style={{ fontSize: 12, color: '#666' }}>Image</label>
// // //                 {bgImagePreview ? (
// // //                   <div style={{ position: 'relative', marginBottom: 8 }}>
// // //                     <img src={bgImagePreview} alt="BG" style={{ width: '100%', height: 120, objectFit: 'cover', borderRadius: 8 }} />
// // //                     <Button icon={<DeleteIcon />} size="small" danger onClick={handleRemoveBgImage} style={{ position: 'absolute', top: 8, right: 8 }} />
// // //                   </div>
// // //                 ) : (
// // //                   <Upload beforeUpload={handleBgImageUpload} showUploadList={false} accept="image/*">
// // //                     <Button icon={<UploadOutlined />} block style={{ borderRadius: 8, height: 80 }}>Upload Background</Button>
// // //                   </Upload>
// // //                 )}
// // //                 <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: 8, marginTop: 8 }}>
// // //                   <Select value={bgImageSize} onChange={setBgImageSize} size="small"><Option value="cover">Cover</Option><Option value="contain">Contain</Option><Option value="stretch">Stretch</Option></Select>
// // //                   <Select value={bgImagePosition} onChange={setBgImagePosition} size="small"><Option value="center">Center</Option><Option value="top">Top</Option><Option value="bottom">Bottom</Option></Select>
// // //                 </div>
// // //                 <div style={{ marginTop: 8 }}><label style={{ fontSize: 12, color: '#666' }}>Opacity: {bgImageOpacity}</label><Slider min={0.1} max={1} step={0.1} value={bgImageOpacity} onChange={setBgImageOpacity} /></div>
// // //               </div>
// // //             )}
// // //           </Card>

// // //           {/* Card Style */}
// // //           <Card title="✨ Card Style" style={{ borderRadius: 16, boxShadow: '0 4px 20px rgba(0,0,0,0.08)', marginBottom: 16 }}>
// // //             <Space direction="vertical" style={{ width: '100%' }} size="small">
// // //               <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
// // //                 <span style={{ fontSize: 12 }}>Border Radius</span>
// // //                 <InputNumber size="small" min={0} max={50} value={borderRadius} onChange={setBorderRadius} style={{ width: 80 }} addonAfter="px" />
// // //               </div>
// // //               <Divider style={{ margin: '8px 0' }} />
// // //               <div style={{ display: 'flex', justifyContent: 'space-between' }}>
// // //                 <span style={{ fontSize: 12, fontWeight: 'bold' }}>Shadow</span>
// // //                 <Switch size="small" checked={shadowEnabled} onChange={setShadowEnabled} />
// // //               </div>
// // //               {shadowEnabled && (
// // //                 <>
// // //                   <div style={{ display: 'flex', justifyContent: 'space-between' }}><span style={{ fontSize: 11 }}>Color</span><ColorPicker value={shadowColor} onChange={(c) => setShadowColor(c.toHexString())} size="small" /></div>
// // //                   <div style={{ display: 'flex', justifyContent: 'space-between' }}><span style={{ fontSize: 11 }}>Blur</span><InputNumber size="small" min={0} max={100} value={shadowBlur} onChange={setShadowBlur} style={{ width: 80 }} /></div>
// // //                   <div style={{ display: 'flex', justifyContent: 'space-between' }}><span style={{ fontSize: 11 }}>Spread</span><InputNumber size="small" min={-50} max={50} value={shadowSpread} onChange={setShadowSpread} style={{ width: 80 }} /></div>
// // //                   <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: 8 }}>
// // //                     <div style={{ display: 'flex', justifyContent: 'space-between' }}><span style={{ fontSize: 11 }}>X</span><InputNumber size="small" min={-50} max={50} value={shadowX} onChange={setShadowX} style={{ width: 70 }} /></div>
// // //                     <div style={{ display: 'flex', justifyContent: 'space-between' }}><span style={{ fontSize: 11 }}>Y</span><InputNumber size="small" min={-50} max={50} value={shadowY} onChange={setShadowY} style={{ width: 70 }} /></div>
// // //                   </div>
// // //                 </>
// // //               )}
// // //               <Divider style={{ margin: '8px 0' }} />
// // //               <div style={{ display: 'flex', justifyContent: 'space-between' }}><span style={{ fontSize: 12 }}>Overlay</span><Select size="small" value={overlayPattern} onChange={setOverlayPattern} style={{ width: 100 }}>{PATTERNS.map(p => <Option key={p.value} value={p.value}>{p.name}</Option>)}</Select></div>
// // //               {overlayPattern !== 'none' && <div style={{ display: 'flex', justifyContent: 'space-between' }}><span style={{ fontSize: 12 }}>Opacity</span><InputNumber size="small" min={0} max={1} step={0.1} value={overlayOpacity} onChange={setOverlayOpacity} style={{ width: 80 }} /></div>}
// // //               <div style={{ display: 'flex', justifyContent: 'space-between' }}><span style={{ fontSize: 12 }}>Gold Chip</span><Space size="small"><Switch size="small" checked={chipEnabled} onChange={setChipEnabled} />{chipEnabled && <ColorPicker value={chipColor} onChange={(c) => setChipColor(c.toHexString())} size="small" />}</Space></div>
// // //             </Space>
// // //           </Card>

// // //           {/* Signature, Logo & Custom Photo */}
// // //           <Card title={<Space><PictureOutlined /> Images</Space>} style={{ borderRadius: 16, boxShadow: '0 4px 20px rgba(0,0,0,0.08)', marginBottom: 16 }}>
// // //             <Tabs size="small" items={[
// // //               {
// // //                 key: 'signature',
// // //                 label: '✍️ Signature',
// // //                 children: (
// // //                   <div>
// // //                     {signaturePreview ? (
// // //                       <div style={{ position: 'relative' }}>
// // //                         <img src={signaturePreview} alt="Sig" style={{ width: '100%', height: 70, objectFit: 'contain', borderRadius: 8, background: '#f5f5f5', padding: 8 }} />
// // //                         <Button icon={<DeleteIcon />} size="small" danger onClick={handleRemoveSignature} style={{ position: 'absolute', top: 4, right: 4 }} />
// // //                       </div>
// // //                     ) : (
// // //                       <Upload beforeUpload={handleSignatureUpload} showUploadList={false} accept="image/*">
// // //                         <Button icon={<UploadOutlined />} block style={{ borderRadius: 8, height: 50 }}>Upload Signature</Button>
// // //                       </Upload>
// // //                     )}
// // //                   </div>
// // //                 )
// // //               },
// // //               {
// // //                 key: 'logo',
// // //                 label: '🏢 Logo',
// // //                 children: (
// // //                   <div>
// // //                     {logoPreview ? (
// // //                       <div style={{ position: 'relative' }}>
// // //                         <img src={logoPreview} alt="Logo" style={{ width: '100%', height: 70, objectFit: 'contain', borderRadius: 8, background: '#f5f5f5', padding: 8 }} />
// // //                         <Button icon={<DeleteIcon />} size="small" danger onClick={handleRemoveLogo} style={{ position: 'absolute', top: 4, right: 4 }} />
// // //                       </div>
// // //                     ) : (
// // //                       <Upload beforeUpload={handleLogoUpload} showUploadList={false} accept="image/*">
// // //                         <Button icon={<UploadOutlined />} block style={{ borderRadius: 8, height: 50 }}>Upload Logo</Button>
// // //                       </Upload>
// // //                     )}
// // //                   </div>
// // //                 )
// // //               },
// // //               {
// // //                 key: 'custom_photo',
// // //                 label: '🖼️ Custom Photo',
// // //                 children: (
// // //                   <div>
// // //                     {customPhotoPreview ? (
// // //                       <div style={{ position: 'relative' }}>
// // //                         <img src={customPhotoPreview} alt="Custom" style={{ width: '100%', height: 70, objectFit: 'cover', borderRadius: 8 }} />
// // //                         <Button icon={<DeleteIcon />} size="small" danger onClick={handleRemoveCustomPhoto} style={{ position: 'absolute', top: 4, right: 4 }} />
// // //                       </div>
// // //                     ) : (
// // //                       <Upload beforeUpload={handleCustomPhotoUpload} showUploadList={false} accept="image/*">
// // //                         <Button icon={<UploadOutlined />} block style={{ borderRadius: 8, height: 50 }}>Upload Photo</Button>
// // //                       </Upload>
// // //                     )}
// // //                   </div>
// // //                 )
// // //               },
// // //             ]} />
// // //           </Card>

// // //           {/* Shape Properties */}
// // //           {selectedElement && selectedElement.element_type === 'shape' && (
// // //             <Card title={<Space><HighlightOutlined /> Shape Properties</Space>} extra={<Button type="text" danger icon={<DeleteOutlined />} size="small" onClick={() => deleteElement(selectedElement.id || selectedElement.tempId)} />} style={{ borderRadius: 16, boxShadow: '0 4px 20px rgba(0,0,0,0.08)', marginBottom: 16 }}>
// // //               <Space direction="vertical" style={{ width: '100%' }} size="small">
// // //                 <div>
// // //                   <label style={{ fontSize: 12, color: '#666' }}>Shape Type</label>
// // //                   <Select value={selectedElement.shape_type} onChange={(v) => updateShapeProps({ shape_type: v })} style={{ width: '100%' }} size="small">
// // //                     {SHAPE_TYPES.map(s => <Option key={s.value} value={s.value}>{s.name}</Option>)}
// // //                   </Select>
// // //                 </div>
// // //                 <Divider style={{ margin: '8px 0' }} />
// // //                 <div>
// // //                   <label style={{ fontSize: 12, color: '#666' }}>Fill Type</label>
// // //                   <Radio.Group value={selectedElement.shape_fill_type} onChange={(e) => updateShapeProps({ shape_fill_type: e.target.value })} size="small" style={{ width: '100%' }}>
// // //                     <Radio.Button value="solid" style={{ width: '50%', textAlign: 'center' }}>Solid</Radio.Button>
// // //                     <Radio.Button value="gradient" style={{ width: '50%', textAlign: 'center' }}>Gradient</Radio.Button>
// // //                   </Radio.Group>
// // //                 </div>
// // //                 {selectedElement.shape_fill_type === 'solid' ? (
// // //                   <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
// // //                     <span style={{ fontSize: 12 }}>Color</span>
// // //                     <ColorPicker value={selectedElement.shape_fill_color} onChange={(c) => updateShapeProps({ shape_fill_color: c.toHexString() })} size="small" />
// // //                   </div>
// // //                 ) : (
// // //                   <>
// // //                     <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: 8 }}>
// // //                       <ColorPicker value={selectedElement.shape_gradient_color1} onChange={(c) => updateShapeProps({ shape_gradient_color1: c.toHexString() })} />
// // //                       <ColorPicker value={selectedElement.shape_gradient_color2} onChange={(c) => updateShapeProps({ shape_gradient_color2: c.toHexString() })} />
// // //                     </div>
// // //                     <Select value={selectedElement.shape_gradient_direction} onChange={(v) => updateShapeProps({ shape_gradient_direction: v })} size="small">
// // //                       {['0deg','45deg','90deg','135deg','180deg','225deg','270deg','315deg'].map(d => <Option key={d} value={d}>{d}</Option>)}
// // //                     </Select>
// // //                   </>
// // //                 )}
// // //                 <Divider style={{ margin: '8px 0' }} />
// // //                 <div style={{ display: 'flex', justifyContent: 'space-between' }}>
// // //                   <span style={{ fontSize: 12 }}>Opacity</span>
// // //                   <InputNumber size="small" min={0} max={1} step={0.1} value={selectedElement.shape_opacity} onChange={(v) => updateShapeProps({ shape_opacity: v })} style={{ width: 80 }} />
// // //                 </div>
// // //                 {selectedElement.shape_type !== 'circle' && (
// // //                   <div style={{ display: 'flex', justifyContent: 'space-between' }}>
// // //                     <span style={{ fontSize: 12 }}>Border Radius</span>
// // //                     <InputNumber size="small" min={0} max={50} value={selectedElement.shape_border_radius} onChange={(v) => updateShapeProps({ shape_border_radius: v })} style={{ width: 80 }} addonAfter="px" />
// // //                   </div>
// // //                 )}
// // //                 <Divider style={{ margin: '8px 0' }} />
// // //                 <div style={{ display: 'flex', justifyContent: 'space-between' }}>
// // //                   <span style={{ fontSize: 12, fontWeight: 'bold' }}>Shadow</span>
// // //                   <Switch size="small" checked={selectedElement.shape_shadow_enabled} onChange={(v) => updateShapeProps({ shape_shadow_enabled: v })} />
// // //                 </div>
// // //                 {selectedElement.shape_shadow_enabled && (
// // //                   <>
// // //                     <div style={{ display: 'flex', justifyContent: 'space-between' }}><span style={{ fontSize: 11 }}>Shadow Color</span><ColorPicker value={selectedElement.shape_shadow_color} onChange={(c) => updateShapeProps({ shape_shadow_color: c.toHexString() })} size="small" /></div>
// // //                     <div style={{ display: 'flex', justifyContent: 'space-between' }}><span style={{ fontSize: 11 }}>Blur</span><InputNumber size="small" min={0} max={100} value={selectedElement.shape_shadow_blur} onChange={(v) => updateShapeProps({ shape_shadow_blur: v })} style={{ width: 80 }} /></div>
// // //                   </>
// // //                 )}
// // //                 <Divider style={{ margin: '8px 0' }} />
// // //                 <div style={{ display: 'flex', justifyContent: 'space-between' }}>
// // //                   <span style={{ fontSize: 12, fontWeight: 'bold' }}>Border</span>
// // //                   <Switch size="small" checked={selectedElement.shape_border_enabled} onChange={(v) => updateShapeProps({ shape_border_enabled: v })} />
// // //                 </div>
// // //                 {selectedElement.shape_border_enabled && (
// // //                   <>
// // //                     <div style={{ display: 'flex', justifyContent: 'space-between' }}><span style={{ fontSize: 11 }}>Border Color</span><ColorPicker value={selectedElement.shape_border_color} onChange={(c) => updateShapeProps({ shape_border_color: c.toHexString() })} size="small" /></div>
// // //                     <div style={{ display: 'flex', justifyContent: 'space-between' }}><span style={{ fontSize: 11 }}>Width</span><InputNumber size="small" min={1} max={10} value={selectedElement.shape_border_width} onChange={(v) => updateShapeProps({ shape_border_width: v })} style={{ width: 80 }} addonAfter="px" /></div>
// // //                   </>
// // //                 )}
// // //                 <Divider style={{ margin: '8px 0' }} />
// // //                 <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: 8 }}>
// // //                   <div>
// // //                     <label style={{ fontSize: 11 }}>Width</label>
// // //                     <InputNumber size="small" min={10} max={cardSize.width} value={selectedElement.width} onChange={(v) => updateElementProps(selectedElement.id || selectedElement.tempId, { width: v })} style={{ width: '100%' }} />
// // //                   </div>
// // //                   <div>
// // //                     <label style={{ fontSize: 11 }}>Height</label>
// // //                     <InputNumber size="small" min={10} max={cardSize.height} value={selectedElement.height} onChange={(v) => updateElementProps(selectedElement.id || selectedElement.tempId, { height: v })} style={{ width: '100%' }} />
// // //                   </div>
// // //                 </div>
// // //               </Space>
// // //             </Card>
// // //           )}

// // //           {/* QR Code Properties */}
// // //           {selectedElement && selectedElement.element_type === 'qrcode' && (
// // //             <Card title={<Space><QrcodeOutlined /> QR Code Style</Space>} extra={<Button type="text" danger icon={<DeleteOutlined />} size="small" onClick={() => deleteElement(selectedElement.id || selectedElement.tempId)} />} style={{ borderRadius: 16, boxShadow: '0 4px 20px rgba(0,0,0,0.08)', marginBottom: 16 }}>
// // //               <Space direction="vertical" style={{ width: '100%' }} size="small">
// // //                 <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
// // //                   <span style={{ fontSize: 12 }}>Background</span>
// // //                   <ColorPicker value={selectedElement.qr_bg_color} onChange={(c) => updateQRProps({ qr_bg_color: c.toHexString() })} size="small" />
// // //                 </div>
// // //                 <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
// // //                   <span style={{ fontSize: 12 }}>Foreground</span>
// // //                   <ColorPicker value={selectedElement.qr_fg_color} onChange={(c) => updateQRProps({ qr_fg_color: c.toHexString() })} size="small" />
// // //                 </div>
// // //                 <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
// // //                   <span style={{ fontSize: 12 }}>Corner Color</span>
// // //                   <ColorPicker value={selectedElement.qr_corner_color} onChange={(c) => updateQRProps({ qr_corner_color: c.toHexString() })} size="small" />
// // //                 </div>
// // //                 <Divider style={{ margin: '8px 0' }} />
// // //                 <div>
// // //                   <label style={{ fontSize: 12, color: '#666' }}>Dot Style</label>
// // //                   <Select value={selectedElement.qr_style} onChange={(v) => updateQRProps({ qr_style: v })} style={{ width: '100%' }} size="small">
// // //                     <Option value="square">Square</Option>
// // //                     <Option value="dots">Dots</Option>
// // //                     <Option value="rounded">Rounded</Option>
// // //                   </Select>
// // //                 </div>
// // //                 <div>
// // //                   <label style={{ fontSize: 12, color: '#666' }}>Eye Style</label>
// // //                   <Select value={selectedElement.qr_eye_style} onChange={(v) => updateQRProps({ qr_eye_style: v })} style={{ width: '100%' }} size="small">
// // //                     <Option value="square">Square</Option>
// // //                     <Option value="circle">Circle</Option>
// // //                   </Select>
// // //                 </div>
// // //                 <Divider style={{ margin: '8px 0' }} />
// // //                 <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: 8 }}>
// // //                   <div>
// // //                     <label style={{ fontSize: 11 }}>Width</label>
// // //                     <InputNumber size="small" min={30} max={cardSize.width} value={selectedElement.width} onChange={(v) => updateElementProps(selectedElement.id || selectedElement.tempId, { width: v })} style={{ width: '100%' }} />
// // //                   </div>
// // //                   <div>
// // //                     <label style={{ fontSize: 11 }}>Height</label>
// // //                     <InputNumber size="small" min={30} max={cardSize.height} value={selectedElement.height} onChange={(v) => updateElementProps(selectedElement.id || selectedElement.tempId, { height: v })} style={{ width: '100%' }} />
// // //                   </div>
// // //                 </div>
// // //                 <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: 8 }}>
// // //                   <div>
// // //                     <label style={{ fontSize: 11 }}>X</label>
// // //                     <InputNumber size="small" min={0} max={cardSize.width} value={selectedElement.x_position} onChange={(v) => updateElementProps(selectedElement.id || selectedElement.tempId, { x_position: v })} style={{ width: '100%' }} />
// // //                   </div>
// // //                   <div>
// // //                     <label style={{ fontSize: 11 }}>Y</label>
// // //                     <InputNumber size="small" min={0} max={cardSize.height} value={selectedElement.y_position} onChange={(v) => updateElementProps(selectedElement.id || selectedElement.tempId, { y_position: v })} style={{ width: '100%' }} />
// // //                   </div>
// // //                 </div>
// // //               </Space>
// // //             </Card>
// // //           )}

// // //           {/* Element Properties */}
// // //           {selectedElement && (selectedElement.element_type === 'text' || selectedElement.element_type === 'custom-text') && (
// // //             <Card title={<Space><EditOutlined /> Properties</Space>} extra={<Button type="text" danger icon={<DeleteOutlined />} size="small" onClick={() => deleteElement(selectedElement.id || selectedElement.tempId)} />} style={{ borderRadius: 16, boxShadow: '0 4px 20px rgba(0,0,0,0.08)' }}>
// // //               <Form layout="vertical" size="small">
// // //                 <Form.Item label="Label"><Input value={selectedElement.label} onChange={(e) => updateElementProps(selectedElement.id || selectedElement.tempId, { label: e.target.value })} /></Form.Item>
// // //                 {selectedElement.element_type === 'custom-text' && <Form.Item label="Custom Text"><Input.TextArea value={selectedElement.custom_text || ''} rows={3} onChange={(e) => updateElementProps(selectedElement.id || selectedElement.tempId, { custom_text: e.target.value })} /></Form.Item>}
// // //                 <Form.Item label="Font"><Select value={selectedElement.font_family || 'Content, sans-serif'} onChange={(v) => updateElementProps(selectedElement.id || selectedElement.tempId, { font_family: v })} size="small">{FONT_FAMILIES.map(f => <Option key={f.value} value={f.value}><span style={{ fontFamily: f.value }}>{f.name}</span></Option>)}</Select></Form.Item>
// // //                 <Form.Item label="Size"><InputNumber value={selectedElement.font_size} min={8} max={72} style={{ width: '100%' }} onChange={(v) => updateElementProps(selectedElement.id || selectedElement.tempId, { font_size: v })} /></Form.Item>
// // //                 <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: 8 }}>
// // //                   <Form.Item label="Color"><ColorPicker value={selectedElement.font_color} onChange={(c) => updateElementProps(selectedElement.id || selectedElement.tempId, { font_color: c.toHexString() })} /></Form.Item>
// // //                   <Form.Item label="Weight"><Select value={selectedElement.font_weight} onChange={(v) => updateElementProps(selectedElement.id || selectedElement.tempId, { font_weight: v })}><Option value="normal">Normal</Option><Option value="bold">Bold</Option></Select></Form.Item>
// // //                 </div>
// // //                 <Form.Item label="Align"><Segmented block value={selectedElement.text_align} onChange={(v) => updateElementProps(selectedElement.id || selectedElement.tempId, { text_align: v })} options={[{ label: 'L', value: 'left' }, { label: 'C', value: 'center' }, { label: 'R', value: 'right' }]} /></Form.Item>
// // //                 <Divider />
// // //                 <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: 8 }}>
// // //                   <Form.Item label="W"><InputNumber value={selectedElement.width} min={10} max={cardSize.width} style={{ width: '100%' }} onChange={(v) => updateElementProps(selectedElement.id || selectedElement.tempId, { width: v })} /></Form.Item>
// // //                   <Form.Item label="H"><InputNumber value={selectedElement.height} min={10} max={cardSize.height} style={{ width: '100%' }} onChange={(v) => updateElementProps(selectedElement.id || selectedElement.tempId, { height: v })} /></Form.Item>
// // //                 </div>
// // //                 <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: 8 }}>
// // //                   <Form.Item label="X"><InputNumber value={selectedElement.x_position} min={0} max={cardSize.width} style={{ width: '100%' }} onChange={(v) => updateElementProps(selectedElement.id || selectedElement.tempId, { x_position: v })} /></Form.Item>
// // //                   <Form.Item label="Y"><InputNumber value={selectedElement.y_position} min={0} max={cardSize.height} style={{ width: '100%' }} onChange={(v) => updateElementProps(selectedElement.id || selectedElement.tempId, { y_position: v })} /></Form.Item>
// // //                 </div>
// // //               </Form>
// // //             </Card>
// // //           )}
// // //         </div>
// // //       </div>

// // //       {/* Template Modal */}
// // //       <Modal title={<Space><SettingOutlined />{editingTemplate ? 'Edit' : 'New'} Template</Space>} open={showTemplateModal} onOk={handleTemplateSave} onCancel={() => setShowTemplateModal(false)} confirmLoading={loadingSpin} width={500}>
// // //         <Form form={templateForm} layout="vertical">
// // //           <Form.Item name="template_name" label="Name" rules={[{ required: true }]}><Input placeholder="Premium Gold Card" size="large" /></Form.Item>
// // //           <Divider>Card Size</Divider>
// // //           <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: 16 }}>
// // //             <Form.Item label="Width"><InputNumber value={cardSize.width} onChange={(v) => setCardSize({ ...cardSize, width: v })} min={200} max={1200} style={{ width: '100%' }} size="large" /></Form.Item>
// // //             <Form.Item label="Height"><InputNumber value={cardSize.height} onChange={(v) => setCardSize({ ...cardSize, height: v })} min={150} max={800} style={{ width: '100%' }} size="large" /></Form.Item>
// // //           </div>
// // //           <Divider>Presets</Divider>
// // //           <Space style={{ width: '100%', justifyContent: 'center' }}>
// // //             <Button type={orientation === 'landscape' ? 'primary' : 'default'} icon={<SwapOutlined />} onClick={() => { setOrientation('landscape'); setCardSize({ width: 540, height: 340 }); }}>Landscape (540×340)</Button>
// // //             <Button type={orientation === 'portrait' ? 'primary' : 'default'} icon={<SwapOutlined style={{ transform: 'rotate(90deg)' }} />} onClick={() => { setOrientation('portrait'); setCardSize({ width: 340, height: 540 }); }}>Portrait (340×540)</Button>
// // //           </Space>
// // //           <div style={{ marginTop: 16, padding: 12, background: '#f5f5f5', borderRadius: 8, textAlign: 'center' }}><span style={{ color: '#666' }}>Size: <strong>{cardSize.width} × {cardSize.height} px</strong></span></div>
// // //         </Form>
// // //       </Modal>

// // //       {/* Preview Modal */}
// // //       <Modal title={<Space><EyeOutlined />Preview</Space>} open={showPreview} onCancel={() => setShowPreview(false)} footer={<Space><Button onClick={() => setShowPreview(false)}>Close</Button><Button type="primary" icon={<DownloadOutlined />}>Download</Button></Space>} width={cardSize.width + 120} bodyStyle={{ display: 'flex', justifyContent: 'center', padding: 40, background: '#f0f2f5' }}>
// // //         <div style={{ width: cardSize.width, height: cardSize.height }} />
// // //       </Modal>
// // //     </div>
// // //   );
// // // };

// // // export default IDCardDesigner;


// // // IDCardDesigner.js - Complete Version with All Features + Image Loading Fix
// // import React, { useState, useEffect, useRef, useCallback } from "react";
// // import {
// //   Button, Modal, Form, Input, Select, InputNumber, ColorPicker,
// //   Space, message, Spin, Card, Slider, Switch, Tooltip,
// //   Segmented, Upload, Divider, Radio, Tabs, Tag
// // } from "antd";
// // import {
// //   PlusOutlined, EditOutlined, DeleteOutlined, SaveOutlined,
// //   EyeOutlined, SettingOutlined, DownloadOutlined,
// //   IdcardOutlined, PictureOutlined, FontSizeOutlined,
// //   SwapOutlined, CheckCircleOutlined,
// //   QrcodeOutlined, CameraOutlined,
// //   UserOutlined, PhoneOutlined, BankOutlined, TeamOutlined,
// //   GlobalOutlined, CrownOutlined, StarOutlined, ThunderboltOutlined,
// //   UploadOutlined, DeleteOutlined as DeleteIcon,
// //   BgColorsOutlined, BorderOutlined, RadiusSettingOutlined,
// //   HighlightOutlined, ShrinkOutlined,
// //   VerticalAlignTopOutlined, VerticalAlignBottomOutlined,
// //   ArrowUpOutlined, ArrowDownOutlined,
// // } from "@ant-design/icons";
// // import { request } from "../../../share/request";
// // import { getCurrentUser } from "../../../share/getProfile";
// // import { linkPath } from "../../../share/helper";
// // 
// // import "./IDCardDesigner.css";

// // const { Option } = Select;

// // const GRADIENT_PRESETS = [
// //   { name: 'None', color1: null, color2: null, direction: '135deg', type: 'none' },
// //   { name: 'Ocean Blue', color1: '#1a237e', color2: '#0d47a1', direction: '135deg', type: 'linear' },
// //   { name: 'Royal Purple', color1: '#4a148c', color2: '#7b1fa2', direction: '135deg', type: 'linear' },
// //   { name: 'Sunset Gold', color1: '#f57f17', color2: '#e65100', direction: '45deg', type: 'linear' },
// //   { name: 'Forest Green', color1: '#1b5e20', color2: '#004d40', direction: '135deg', type: 'linear' },
// //   { name: 'Crimson Red', color1: '#b71c1c', color2: '#880e4f', direction: '135deg', type: 'linear' },
// //   { name: 'Midnight Sky', color1: '#1a237e', color2: '#000051', direction: '180deg', type: 'linear' },
// //   { name: 'Rose Gold', color1: '#880e4f', color2: '#e91e63', direction: '45deg', type: 'linear' },
// //   { name: 'Teal Dream', color1: '#004d40', color2: '#00695c', direction: '135deg', type: 'linear' },
// // ];

// // const PATTERNS = [
// //   { name: 'None', value: 'none' },
// //   { name: 'Dots', value: 'dots' },
// //   { name: 'Lines', value: 'lines' },
// //   { name: 'Grid', value: 'grid' },
// // ];

// // const FONT_FAMILIES = [
// //   { name: 'Content (Khmer)', value: 'Content, sans-serif' },
// //   { name: 'Noto Sans Khmer', value: "'Noto Sans Khmer', sans-serif" },
// //   { name: 'Hanuman', value: "'Hanuman', serif" },
// //   { name: 'Battambang', value: "'Battambang', cursive" },
// //   { name: 'Siemreap', value: "'Siemreap', cursive" },
// //   { name: 'Moul', value: "'Moul', cursive" },
// //   { name: 'Arial', value: 'Arial, sans-serif' },
// //   { name: 'Times New Roman', value: "'Times New Roman', serif" },
// //   { name: 'Courier New', value: "'Courier New', monospace" },
// // ];

// // const SHAPE_TYPES = [
// //   { name: 'Rectangle', value: 'rectangle', icon: <BorderOutlined /> },
// //   { name: 'Circle', value: 'circle', icon: <RadiusSettingOutlined /> },
// //   { name: 'Rounded Rectangle', value: 'rounded', icon: <ShrinkOutlined /> },
// // ];

// // const IDCardDesigner = () => {
// //   const getProfile = getCurrentUser();
// //   const [loading, setLoading] = useState(false);
// //   const [loadingSpin, setLoadingSpin] = useState(false);
// //   const [templates, setTemplates] = useState([]);
// //   const [currentTemplate, setCurrentTemplate] = useState(null);
// //   const [elements, setElements] = useState([]);
// //   const [selectedElement, setSelectedElement] = useState(null);
// //   const [previewStaff, setPreviewStaff] = useState(null);
// //   const [showPreview, setShowPreview] = useState(false);
// //   const [showTemplateModal, setShowTemplateModal] = useState(false);
// //   const [editingTemplate, setEditingTemplate] = useState(null);

// //   const [orientation, setOrientation] = useState('landscape');
// //   const [cardSize, setCardSize] = useState({ width: 540, height: 340 });

// //   const [backgroundType, setBackgroundType] = useState('gradient');
// //   const [bgColor, setBgColor] = useState('#1a237e');
// //   const [gradientType, setGradientType] = useState('linear');
// //   const [gradientColor1, setGradientColor1] = useState('#1a237e');
// //   const [gradientColor2, setGradientColor2] = useState('#4a148c');
// //   const [gradientDirection, setGradientDirection] = useState('135deg');
// //   const [bgImage, setBgImage] = useState(null);
// //   const [bgImageFile, setBgImageFile] = useState(null);
// //   const [bgImagePreview, setBgImagePreview] = useState(null);
// //   const [bgImageSize, setBgImageSize] = useState('cover');
// //   const [bgImagePosition, setBgImagePosition] = useState('center');
// //   const [bgImageOpacity, setBgImageOpacity] = useState(1);

// //   const [borderRadius, setBorderRadius] = useState(16);
// //   const [shadowEnabled, setShadowEnabled] = useState(true);
// //   const [shadowColor, setShadowColor] = useState('rgba(0,0,0,0.3)');
// //   const [shadowBlur, setShadowBlur] = useState(20);
// //   const [shadowSpread, setShadowSpread] = useState(0);
// //   const [shadowX, setShadowX] = useState(0);
// //   const [shadowY, setShadowY] = useState(10);
  
// //   const [overlayEnabled, setOverlayEnabled] = useState(false);
// //   const [overlayPattern, setOverlayPattern] = useState('none');
// //   const [overlayOpacity, setOverlayOpacity] = useState(0.1);
// //   const [chipEnabled, setChipEnabled] = useState(true);
// //   const [chipColor, setChipColor] = useState('#FFD700');
// //   const [zoomLevel, setZoomLevel] = useState(1);

// //   const [shapeFillType, setShapeFillType] = useState('solid');
// //   const [shapeFillColor, setShapeFillColor] = useState('#4CAF50');
// //   const [shapeGradientColor1, setShapeGradientColor1] = useState('#667eea');
// //   const [shapeGradientColor2, setShapeGradientColor2] = useState('#764ba2');
// //   const [shapeGradientDirection, setShapeGradientDirection] = useState('135deg');
// //   const [shapeBorderRadius, setShapeBorderRadius] = useState(8);
// //   const [shapeShadowEnabled, setShapeShadowEnabled] = useState(false);
// //   const [shapeShadowColor, setShapeShadowColor] = useState('rgba(0,0,0,0.3)');
// //   const [shapeShadowBlur, setShapeShadowBlur] = useState(10);
// //   const [shapeOpacity, setShapeOpacity] = useState(1);
// //   const [shapeBorderEnabled, setShapeBorderEnabled] = useState(false);
// //   const [shapeBorderColor, setShapeBorderColor] = useState('#ffffff');
// //   const [shapeBorderWidth, setShapeBorderWidth] = useState(1);

// //   const [qrBgColor, setQrBgColor] = useState('#FFFFFF');
// //   const [qrFgColor, setQrFgColor] = useState('#000000');
// //   const [qrCornerColor, setQrCornerColor] = useState('#000000');
// //   const [qrStyle, setQrStyle] = useState('square');
// //   const [qrEyeStyle, setQrEyeStyle] = useState('square');

// //   const [signatureImage, setSignatureImage] = useState(null);
// //   const [signatureFile, setSignatureFile] = useState(null);
// //   const [signaturePreview, setSignaturePreview] = useState(null);
// //   const [logoImage, setLogoImage] = useState(null);
// //   const [logoFile, setLogoFile] = useState(null);
// //   const [logoPreview, setLogoPreview] = useState(null);
// //   const [uploadedImages, setUploadedImages] = useState([]);
  
// //   const [customPhotoFile, setCustomPhotoFile] = useState(null);
// //   const [customPhotoPreview, setCustomPhotoPreview] = useState(null);
// //   const [customPhotoImage, setCustomPhotoImage] = useState(null);

// //   const [isDragging, setIsDragging] = useState(false);
// //   const [dragElement, setDragElement] = useState(null);
// //   const [dragStartPos, setDragStartPos] = useState({ x: 0, y: 0 });
// //   const [elementStartPos, setElementStartPos] = useState({ x: 0, y: 0 });
// //   const canvasRef = useRef(null);
// //   const [templateForm] = Form.useForm();

// //   // ==================== HELPERS ====================
// //   const getBackgroundStyle = () => {
// //     let style = {};
// //     if (backgroundType === 'image' && bgImagePreview) {
// //       style.backgroundImage = `url(${bgImagePreview})`;
// //       style.backgroundSize = bgImageSize === 'stretch' ? '100% 100%' : bgImageSize;
// //       style.backgroundPosition = bgImagePosition;
// //       style.backgroundRepeat = 'no-repeat';
// //       if (bgImageOpacity < 1) style.opacity = bgImageOpacity;
// //       return style;
// //     }
// //     if (backgroundType === 'gradient') {
// //       style.background = gradientType === 'linear'
// //         ? `linear-gradient(${gradientDirection}, ${gradientColor1}, ${gradientColor2})`
// //         : `radial-gradient(circle at center, ${gradientColor1}, ${gradientColor2})`;
// //     } else if (backgroundType === 'color') {
// //       style.backgroundColor = bgColor;
// //     } else {
// //       style.backgroundColor = 'transparent';
// //     }
// //     if (overlayEnabled && overlayPattern !== 'none') {
// //       const o = overlayOpacity;
// //       if (overlayPattern === 'dots') {
// //         style.backgroundImage = `radial-gradient(circle, rgba(255,255,255,${o}) 1px, transparent 1px)`;
// //         style.backgroundSize = '20px 20px';
// //       } else if (overlayPattern === 'lines') {
// //         style.backgroundImage = `linear-gradient(90deg, rgba(255,255,255,${o}) 1px, transparent 1px)`;
// //         style.backgroundSize = '20px 20px';
// //       } else if (overlayPattern === 'grid') {
// //         style.backgroundImage = `linear-gradient(90deg, rgba(255,255,255,${o}) 1px, transparent 1px), linear-gradient(0deg, rgba(255,255,255,${o}) 1px, transparent 1px)`;
// //         style.backgroundSize = '20px 20px';
// //       }
// //     }
// //     return style;
// //   };

// //   const getCardShadow = () => shadowEnabled 
// //     ? `${shadowX}px ${shadowY}px ${shadowBlur}px ${shadowSpread}px ${shadowColor}` 
// //     : 'none';

// //   const getShapeStyle = (el) => {
// //     let style = {
// //       width: '100%',
// //       height: '100%',
// //       opacity: el.shape_opacity || 1,
// //     };

// //     if (el.shape_fill_type === 'gradient') {
// //       style.background = `linear-gradient(${el.shape_gradient_direction || '135deg'}, ${el.shape_gradient_color1 || '#667eea'}, ${el.shape_gradient_color2 || '#764ba2'})`;
// //     } else {
// //       style.backgroundColor = el.shape_fill_color || '#4CAF50';
// //     }

// //     if (el.shape_type === 'circle') {
// //       style.borderRadius = '50%';
// //     } else if (el.shape_type === 'rounded') {
// //       style.borderRadius = `${el.shape_border_radius || 8}px`;
// //     }

// //     if (el.shape_shadow_enabled) {
// //       style.boxShadow = `0 ${el.shape_shadow_blur || 10}px ${el.shape_shadow_blur * 2 || 20}px ${el.shape_shadow_color || 'rgba(0,0,0,0.3)'}`;
// //     }

// //     if (el.shape_border_enabled) {
// //       style.border = `${el.shape_border_width || 1}px solid ${el.shape_border_color || '#ffffff'}`;
// //     }

// //     return style;
// //   };

// //   const generateQRCode = (text, size, fgColor = '#000000', bgColor = '#FFFFFF') => {
// //     if (!text) return '';
// //     return `https://api.qrserver.com/v1/create-qr-code/?size=${size}x${size}&data=${encodeURIComponent(text)}&margin=5&color=${fgColor.replace('#', '')}&bgcolor=${bgColor.replace('#', '')}`;
// //   };

// //   const bringToFront = (eid) => {
// //     const maxZ = Math.max(...elements.map(el => el.z_index || 2), 2);
// //     updateElementProps(eid, { z_index: maxZ + 1 });
// //     message.success('Moved to front');
// //   };

// //   const sendToBack = (eid) => {
// //     const minZ = Math.min(...elements.map(el => el.z_index || 2), 2);
// //     updateElementProps(eid, { z_index: Math.max(1, minZ - 1) });
// //     message.success('Sent to back');
// //   };

// //   const bringForward = (eid) => {
// //     const el = elements.find(e => (e.id || e.tempId) === eid);
// //     if (el) updateElementProps(eid, { z_index: (el.z_index || 2) + 1 });
// //   };

// //   const sendBackward = (eid) => {
// //     const el = elements.find(e => (e.id || e.tempId) === eid);
// //     if (el) updateElementProps(eid, { z_index: Math.max(1, (el.z_index || 2) - 1) });
// //   };

// //   // ==================== LOAD DATA ====================
// //   const loadTemplates = async () => {
// //     setLoading(true);
// //     try {
// //       const param = new URLSearchParams({ org_code: getProfile.org_code });
// //       const res = await request(`id-card-templates?${param.toString()}`, "get", {});
// //       if (res?.success) {
// //         setTemplates(res.data);
// //         if (res.data.length > 0 && !currentTemplate) loadTemplate(res.data[0].id);
// //       }
// //     } catch (e) { console.error(e); }
// //     finally { setLoading(false); }
// //   };

// //   const loadTemplateImages = async (templateId) => {
// //     try {
// //       const res = await request(`id-card-images/template/${templateId}`, "get", {});
// //       if (res?.success) {
// //         setUploadedImages(res.data);
// //         // Reset images first
// //         setSignatureImage(null);
// //         setSignaturePreview(null);
// //         setLogoImage(null);
// //         setLogoPreview(null);
// //         setCustomPhotoImage(null);
// //         setCustomPhotoPreview(null);
        
// //         // Load from response
// //         res.data.forEach(img => {
// //           const url = `${linkPath}/${img.image_path}`;
// //           if (img.image_type === 'signature') { 
// //             setSignatureImage(img.image_path); 
// //             setSignaturePreview(url); 
// //           }
// //           if (img.image_type === 'logo') { 
// //             setLogoImage(img.image_path); 
// //             setLogoPreview(url); 
// //           }
// //           if (img.image_type === 'custom_photo') { 
// //             setCustomPhotoImage(img.image_path); 
// //             setCustomPhotoPreview(url); 
// //           }
// //         });
// //       }
// //     } catch (e) { console.error(e); }
// //   };

// //   const loadTemplate = async (templateId) => {
// //     setLoading(true);
// //     try {
// //       const res = await request(`id-card-templates/${templateId}`, "get", {});
// //       if (res?.success) {
// //         const tpl = res.data;
// //         setCurrentTemplate(tpl);
// //         setElements(tpl.elements || []);
// //         setOrientation(tpl.orientation || 'landscape');
// //         setCardSize({ width: tpl.width || 540, height: tpl.height || 340 });
// //         setBackgroundType(tpl.background_type || 'gradient');
// //         setBgColor(tpl.background_color || '#1a237e');
// //         setGradientType(tpl.gradient_type || 'linear');
// //         setGradientColor1(tpl.gradient_color1 || '#1a237e');
// //         setGradientColor2(tpl.gradient_color2 || '#4a148c');
// //         setGradientDirection(tpl.gradient_direction || '135deg');
// //         if (tpl.background_image) {
// //           setBgImage(tpl.background_image);
// //           setBgImagePreview(`${linkPath}/${tpl.background_image}`);
// //         } else { setBgImage(null); setBgImagePreview(null); }
// //         setBgImageSize(tpl.bg_image_size || 'cover');
// //         setBgImagePosition(tpl.bg_image_position || 'center');
// //         setBgImageOpacity(tpl.bg_image_opacity || 1);
// //         setBorderRadius(tpl.border_radius || 16);
// //         setShadowEnabled(tpl.shadow_enabled === 1);
// //         setShadowColor(tpl.shadow_color || 'rgba(0,0,0,0.3)');
// //         setShadowBlur(tpl.shadow_blur || 20);
// //         setShadowSpread(tpl.shadow_spread || 0);
// //         setShadowX(tpl.shadow_x || 0);
// //         setShadowY(tpl.shadow_y || 10);
// //         setOverlayEnabled(tpl.overlay_enabled === 1);
// //         setOverlayPattern(tpl.overlay_pattern || 'none');
// //         setOverlayOpacity(tpl.overlay_opacity || 0.1);
// //         setChipEnabled(tpl.chip_enabled === 1);
// //         setChipColor(tpl.chip_color || '#FFD700');
// //         setSelectedElement(null);
// //         loadTemplateImages(templateId);
// //       }
// //     } catch (e) { console.error(e); }
// //     finally { setLoading(false); }
// //   };

// //   useEffect(() => { loadTemplates(); }, []);

// //   // ==================== HANDLERS ====================
// //   const handleOrientationChange = (v) => {
// //     setOrientation(v);
// //     setCardSize(v === 'portrait' ? { width: 340, height: 540 } : { width: 540, height: 340 });
// //   };

// //   const handleBgImageUpload = (file) => {
// //     const reader = new FileReader();
// //     reader.onload = (e) => { setBgImagePreview(e.target.result); setBgImageFile(file); };
// //     reader.readAsDataURL(file);
// //     return false;
// //   };
// //   const handleRemoveBgImage = () => { setBgImagePreview(null); setBgImageFile(null); setBgImage(null); };

// //   const handleSignatureUpload = (file) => {
// //     const reader = new FileReader();
// //     reader.onload = (e) => { setSignaturePreview(e.target.result); setSignatureFile(file); };
// //     reader.readAsDataURL(file);
// //     return false;
// //   };
// //   const handleRemoveSignature = () => { setSignaturePreview(null); setSignatureFile(null); setSignatureImage(null); };

// //   const handleLogoUpload = (file) => {
// //     const reader = new FileReader();
// //     reader.onload = (e) => { setLogoPreview(e.target.result); setLogoFile(file); };
// //     reader.readAsDataURL(file);
// //     return false;
// //   };
// //   const handleRemoveLogo = () => { setLogoPreview(null); setLogoFile(null); setLogoImage(null); };

// //   const handleCustomPhotoUpload = (file) => {
// //     const reader = new FileReader();
// //     reader.onload = (e) => { setCustomPhotoPreview(e.target.result); setCustomPhotoFile(file); };
// //     reader.readAsDataURL(file);
// //     return false;
// //   };
// //   const handleRemoveCustomPhoto = () => { setCustomPhotoPreview(null); setCustomPhotoFile(null); setCustomPhotoImage(null); };

// //   const uploadImageWithType = async (file, imageType) => {
// //     const fd = new FormData();
// //     fd.append('idcard_bg', file);
// //     fd.append('template_id', currentTemplate?.id);
// //     fd.append('image_type', imageType);
// //     fd.append('org_code', getProfile.org_code);
// //     try {
// //       const res = await request("id-card-images", "POST", fd, true);
// //       if (res?.success) { 
// //         message.success(`${imageType} uploaded!`); 
// //         await loadTemplateImages(currentTemplate?.id);
// //         return res.data; 
// //       }
// //     } catch (e) { message.error("Upload failed"); }
// //     return null;
// //   };

// //   const addElement = (type, key = null, label = '') => {
// //     const defaults = {
// //       text: { w: 150, h: 30, fs: 14, fw: 'bold' },
// //       'custom-text': { w: 150, h: 30, fs: 14, fw: 'normal' },
// //       image: { w: 80, h: 100, fs: 0, fw: 'normal' },
// //       qrcode: { w: 80, h: 80, fs: 0, fw: 'normal' },
// //       shape: { w: 100, h: 80, fs: 0, fw: 'normal' },
// //     };
// //     const s = defaults[type] || defaults.text;
// //     const maxZ = Math.max(...elements.map(el => el.z_index || 2), 2);
// //     const el = {
// //       template_id: currentTemplate?.id,
// //       element_type: type, element_key: key, label: label || type,
// //       custom_text: type === 'custom-text' ? 'Enter text' : '',
// //       x_position: 50 + elements.length * 20, y_position: 50 + elements.length * 20,
// //       width: s.w, height: s.h, font_size: s.fs, font_color: '#FFFFFF',
// //       font_weight: s.fw, font_family: 'Content, sans-serif', text_align: 'left',
// //       is_visible: 1, sort_order: elements.length + 1, is_new: true,
// //       tempId: `t_${Date.now()}_${Math.random().toString(36).substr(2, 9)}`,
// //       z_index: maxZ + 1,
// //       shape_type: 'rounded',
// //       shape_fill_type: 'solid',
// //       shape_fill_color: '#4CAF50',
// //       shape_gradient_color1: '#667eea',
// //       shape_gradient_color2: '#764ba2',
// //       shape_gradient_direction: '135deg',
// //       shape_border_radius: 8,
// //       shape_shadow_enabled: false,
// //       shape_shadow_color: 'rgba(0,0,0,0.3)',
// //       shape_shadow_blur: 10,
// //       shape_opacity: 1,
// //       shape_border_enabled: false,
// //       shape_border_color: '#ffffff',
// //       shape_border_width: 1,
// //       qr_bg_color: '#FFFFFF',
// //       qr_fg_color: '#000000',
// //       qr_corner_color: '#000000',
// //       qr_style: 'square',
// //       qr_eye_style: 'square',
// //     };
// //     setElements([...elements, el]);
// //     setSelectedElement(el);
// //   };

// //   const handleMouseDown = (e, el) => {
// //     e.preventDefault(); e.stopPropagation();
// //     setSelectedElement(el);
// //     if (el.element_type === 'shape') {
// //       setShapeFillType(el.shape_fill_type || 'solid');
// //       setShapeFillColor(el.shape_fill_color || '#4CAF50');
// //       setShapeGradientColor1(el.shape_gradient_color1 || '#667eea');
// //       setShapeGradientColor2(el.shape_gradient_color2 || '#764ba2');
// //       setShapeGradientDirection(el.shape_gradient_direction || '135deg');
// //       setShapeBorderRadius(el.shape_border_radius || 8);
// //       setShapeShadowEnabled(el.shape_shadow_enabled || false);
// //       setShapeShadowColor(el.shape_shadow_color || 'rgba(0,0,0,0.3)');
// //       setShapeShadowBlur(el.shape_shadow_blur || 10);
// //       setShapeOpacity(el.shape_opacity || 1);
// //       setShapeBorderEnabled(el.shape_border_enabled || false);
// //       setShapeBorderColor(el.shape_border_color || '#ffffff');
// //       setShapeBorderWidth(el.shape_border_width || 1);
// //     }
// //     if (el.element_type === 'qrcode') {
// //       setQrBgColor(el.qr_bg_color || '#FFFFFF');
// //       setQrFgColor(el.qr_fg_color || '#000000');
// //       setQrCornerColor(el.qr_corner_color || '#000000');
// //       setQrStyle(el.qr_style || 'square');
// //       setQrEyeStyle(el.qr_eye_style || 'square');
// //     }
// //     setIsDragging(true); setDragElement(el);
// //     setDragStartPos({ x: e.clientX, y: e.clientY });
// //     setElementStartPos({ x: el.x_position || 0, y: el.y_position || 0 });
// //   };

// //   const handleMouseMove = useCallback((e) => {
// //     if (!isDragging || !dragElement) return;
// //     const dx = (e.clientX - dragStartPos.x) / zoomLevel;
// //     const dy = (e.clientY - dragStartPos.y) / zoomLevel;
// //     const nx = Math.max(0, Math.min(cardSize.width - (dragElement.width || 100), elementStartPos.x + dx));
// //     const ny = Math.max(0, Math.min(cardSize.height - (dragElement.height || 30), elementStartPos.y + dy));
// //     const eid = dragElement.id || dragElement.tempId;
// //     setElements(prev => prev.map(el => (el.id || el.tempId) === eid ? { ...el, x_position: Math.round(nx), y_position: Math.round(ny) } : el));
// //   }, [isDragging, dragElement, dragStartPos, elementStartPos, cardSize, zoomLevel]);

// //   const handleMouseUp = useCallback(() => { setIsDragging(false); setDragElement(null); }, [isDragging]);

// //   useEffect(() => {
// //     if (isDragging) { window.addEventListener('mousemove', handleMouseMove); window.addEventListener('mouseup', handleMouseUp); }
// //     return () => { window.removeEventListener('mousemove', handleMouseMove); window.removeEventListener('mouseup', handleMouseUp); };
// //   }, [isDragging, handleMouseMove, handleMouseUp]);

// //   const updateElementProps = (eid, props) => {
// //     setElements(prev => prev.map(el => (el.id || el.tempId) === eid ? { ...el, ...props } : el));
// //     setSelectedElement(prev => prev && ((prev.id || prev.tempId) === eid) ? { ...prev, ...props } : prev);
// //   };

// //   const deleteElement = async (eid) => {
// //     const el = elements.find(e => (e.id || e.tempId) === eid);
// //     if (el?.is_new) { setElements(elements.filter(e => (e.id || e.tempId) !== eid)); setSelectedElement(null); return; }
// //     if (el?.id) {
// //       try { await request(`id-card-elements/${el.id}`, "DELETE", {}); setElements(elements.filter(e => e.id !== el.id)); setSelectedElement(null); }
// //       catch (e) { console.error(e); }
// //     }
// //   };

// //   // ==================== SAVE ====================
// //   const saveElements = async () => {
// //     if (!currentTemplate) { message.warning("Select a template first"); return; }
// //     setLoadingSpin(true);
// //     try {
// //       if (signatureFile) { const d = await uploadImageWithType(signatureFile, 'signature'); if (d) { setSignatureImage(d.filename || d.image_path); setSignatureFile(null); } }
// //       if (logoFile) { const d = await uploadImageWithType(logoFile, 'logo'); if (d) { setLogoImage(d.filename || d.image_path); setLogoFile(null); } }
// //       if (customPhotoFile) { const d = await uploadImageWithType(customPhotoFile, 'custom_photo'); if (d) { setCustomPhotoImage(d.filename || d.image_path); setCustomPhotoFile(null); } }
// //       let fBg = bgImage;
// //       if (bgImageFile) {
// //         const fd = new FormData(); fd.append('idcard_bg', bgImageFile);
// //         const res = await request("id-card-upload", "POST", fd, true);
// //         if (res?.success) { fBg = res.data.filename || res.data.image_path; setBgImage(fBg); setBgImageFile(null); setBgImagePreview(`${linkPath}/${fBg}`); }
// //       }
// //       await request(`id-card-templates/${currentTemplate.id}`, "PUT", {
// //         width: cardSize.width, height: cardSize.height, orientation,
// //         background_type: backgroundType, background_color: bgColor, background_image: fBg,
// //         gradient_type: gradientType, gradient_color1: gradientColor1, gradient_color2: gradientColor2, gradient_direction: gradientDirection,
// //         bg_image_size: bgImageSize, bg_image_position: bgImagePosition, bg_image_opacity: bgImageOpacity,
// //         border_radius: borderRadius, shadow_enabled: shadowEnabled, shadow_color: shadowColor,
// //         shadow_blur: shadowBlur, shadow_spread: shadowSpread, shadow_x: shadowX, shadow_y: shadowY,
// //         overlay_enabled: overlayEnabled, overlay_pattern: overlayPattern, overlay_opacity: overlayOpacity,
// //         chip_enabled: chipEnabled, chip_color: chipColor,
// //       });
// //       for (const el of elements) {
// //         const data = {
// //           id: el.id || null, template_id: currentTemplate.id,
// //           element_type: el.element_type, element_key: el.element_key, label: el.label,
// //           custom_text: el.custom_text || null,
// //           x_position: el.x_position, y_position: el.y_position, width: el.width, height: el.height,
// //           font_size: el.font_size, font_color: el.font_color, font_weight: el.font_weight,
// //           font_family: el.font_family, text_align: el.text_align,
// //           is_visible: el.is_visible, sort_order: el.sort_order,
// //           z_index: el.z_index || 2,
// //           shape_type: el.shape_type, shape_fill_type: el.shape_fill_type,
// //           shape_fill_color: el.shape_fill_color, shape_gradient_color1: el.shape_gradient_color1,
// //           shape_gradient_color2: el.shape_gradient_color2, shape_gradient_direction: el.shape_gradient_direction,
// //           shape_border_radius: el.shape_border_radius, shape_shadow_enabled: el.shape_shadow_enabled,
// //           shape_shadow_color: el.shape_shadow_color, shape_shadow_blur: el.shape_shadow_blur,
// //           shape_opacity: el.shape_opacity, shape_border_enabled: el.shape_border_enabled,
// //           shape_border_color: el.shape_border_color, shape_border_width: el.shape_border_width,
// //           qr_bg_color: el.qr_bg_color, qr_fg_color: el.qr_fg_color,
// //           qr_corner_color: el.qr_corner_color, qr_style: el.qr_style, qr_eye_style: el.qr_eye_style,
// //         };
// //         const r = await request("id-card-elements", "POST", data);
// //         if (r?.data?.id && el.is_new) {
// //           setElements(prev => prev.map(e => e.tempId === el.tempId ? { ...e, id: r.data.id, is_new: false } : e));
// //         }
// //       }
// //       message.success("💾 Saved!");
// //       await loadTemplate(currentTemplate.id);
// //     } catch (e) { console.error(e); message.error("Save failed"); }
// //     finally { setLoadingSpin(false); }
// //   };

// //   const previewIDCard = async () => {
// //     setLoadingSpin(true);
// //     try {
// //       const res = await request(`id-card-preview?username=${getProfile.username}&org_code=${getProfile.org_code}`, "get", {});
// //       if (res?.success) { setPreviewStaff(res.data.staff); setShowPreview(true); }
// //     } catch (e) { console.error(e); }
// //     finally { setLoadingSpin(false); }
// //   };

// //   const handleTemplateSave = async () => {
// //     try {
// //       const v = await templateForm.validateFields();
// //       setLoadingSpin(true);
// //       const data = { ...v, org_code: getProfile.org_code, usercreate: getProfile.fullname, width: cardSize.width, height: cardSize.height, orientation, background_type: backgroundType, background_color: bgColor, gradient_type: gradientType, gradient_color1: gradientColor1, gradient_color2: gradientColor2, gradient_direction: gradientDirection, border_radius: borderRadius, shadow_enabled: shadowEnabled, shadow_color: shadowColor, overlay_enabled: overlayEnabled, chip_enabled: chipEnabled, chip_color: chipColor };
// //       const res = editingTemplate ? await request(`id-card-templates/${editingTemplate.id}`, "PUT", data) : await request("id-card-templates", "POST", data);
// //       if (res?.isOk || res?.success) { message.success(editingTemplate ? "✅ Updated!" : "✨ Created!"); setShowTemplateModal(false); templateForm.resetFields(); loadTemplates(); }
// //     } catch (e) { console.error(e); }
// //     finally { setLoadingSpin(false); }
// //   };

// //   const applyGradientPreset = (p) => {
// //     if (p.type === 'none') { setBackgroundType('none'); return; }
// //     setBackgroundType('gradient'); setGradientColor1(p.color1); setGradientColor2(p.color2); setGradientDirection(p.direction); setGradientType(p.type);
// //   };

// //   const updateShapeProps = (props) => {
// //     if (!selectedElement) return;
// //     updateElementProps(selectedElement.id || selectedElement.tempId, props);
// //   };

// //   const updateQRProps = (props) => {
// //     if (!selectedElement) return;
// //     updateElementProps(selectedElement.id || selectedElement.tempId, props);
// //   };

// //   // ==================== RENDER ====================
// //   const renderIDCard = () => (
// //     <div ref={canvasRef} style={{
// //       width: cardSize.width, height: cardSize.height, ...getBackgroundStyle(),
// //       borderRadius: borderRadius, boxShadow: getCardShadow(),
// //       position: 'relative', overflow: 'hidden',
// //       border: backgroundType === 'none' ? '2px dashed #d9d9d9' : '1px solid rgba(255,255,255,0.2)',
// //       cursor: isDragging ? 'grabbing' : 'default', userSelect: 'none',
// //     }}>
// //       {backgroundType !== 'none' && (
// //         <>
// //           <div style={{ position: 'absolute', top: -60, right: -60, width: 220, height: 220, borderRadius: '50%', background: 'rgba(255,255,255,0.03)', pointerEvents: 'none' }} />
// //           <div style={{ position: 'absolute', bottom: -90, left: -40, width: 280, height: 280, borderRadius: '50%', background: 'rgba(255,255,255,0.03)', pointerEvents: 'none' }} />
// //         </>
// //       )}
// //       {chipEnabled && (
// //         <div style={{ position: 'absolute', top: 20, left: 20, width: 45, height: 32, borderRadius: 6, background: `linear-gradient(135deg, ${chipColor}, ${chipColor}cc)`, boxShadow: '0 2px 8px rgba(0,0,0,0.2)', zIndex: 2, pointerEvents: 'none' }}>
// //           <div style={{ width: '100%', height: '100%', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
// //             <div style={{ width: 22, height: 16, borderRadius: 3, background: 'rgba(255,255,255,0.3)', border: '1px solid rgba(255,255,255,0.5)' }} />
// //           </div>
// //         </div>
// //       )}
// //       {backgroundType === 'none' && (
// //         <div style={{ position: 'absolute', top: '50%', left: '50%', transform: 'translate(-50%,-50%)', color: '#d9d9d9', textAlign: 'center', pointerEvents: 'none' }}>
// //           <PictureOutlined style={{ fontSize: 48, display: 'block', marginBottom: 8 }} />
// //           {cardSize.width} × {cardSize.height}
// //         </div>
// //       )}
// //       {elements.filter(el => el.is_visible !== 0)
// //         .sort((a, b) => (a.z_index || 2) - (b.z_index || 2))
// //         .map((el, i) => {
// //         const eid = el.id || el.tempId;
// //         const sel = selectedElement && (selectedElement.id || selectedElement.tempId) === eid;
// //         return (
// //           <div key={eid} onMouseDown={(e) => handleMouseDown(e, el)} style={{
// //             position: 'absolute', left: el.x_position || 0, top: el.y_position || 0,
// //             width: el.width || 100, height: el.height || 30,
// //             display: 'flex', alignItems: 'center',
// //             justifyContent: el.text_align === 'center' ? 'center' : el.text_align === 'right' ? 'flex-end' : 'flex-start',
// //             fontSize: el.font_size || 12, color: el.font_color || '#FFF',
// //             fontWeight: el.font_weight || 'normal', fontFamily: el.font_family || 'Content',
// //             zIndex: sel ? 1000 : (el.z_index || 2), overflow: 'hidden', cursor: 'move',
// //             border: sel ? '2px solid #1890ff' : (el.element_type === 'shape' ? 'none' : '1px dashed rgba(255,255,255,0.3)'),
// //             background: el.element_type === 'shape' ? 'transparent' : (sel ? 'rgba(24,144,255,0.15)' : 'rgba(255,255,255,0.05)'),
// //             borderRadius: el.element_type === 'shape' ? 0 : 4, padding: el.element_type === 'shape' ? 0 : 2,
// //           }}>
// //             {el.element_type === 'shape' ? (
// //               <div style={getShapeStyle(el)}>
// //                 {el.label && el.label !== 'Shape' && (
// //                   <div style={{
// //                     position: 'absolute',
// //                     top: '50%',
// //                     left: '50%',
// //                     transform: 'translate(-50%, -50%)',
// //                     color: '#fff',
// //                     fontSize: el.font_size || 12,
// //                     fontWeight: el.font_weight || 'bold',
// //                     textAlign: 'center',
// //                     width: '100%',
// //                     padding: '4px',
// //                     textShadow: '0 1px 3px rgba(0,0,0,0.3)',
// //                   }}>
// //                     {el.label}
// //                   </div>
// //                 )}
// //               </div>
// //             ) : el.element_type === 'qrcode' ? (
// //               <div style={{ 
// //                 width: '100%', height: '100%', 
// //                 display: 'flex', alignItems: 'center', justifyContent: 'center', 
// //                 background: el.qr_bg_color || '#FFFFFF', borderRadius: 4, padding: 4 
// //               }}>
// //                 <img 
// //                   src={generateQRCode(el.label || 'QR', Math.min(el.width, el.height), el.qr_fg_color || '#000000', el.qr_bg_color || '#FFFFFF')} 
// //                   alt="QR" 
// //                   style={{ width: '100%', height: '100%', objectFit: 'contain', borderRadius: el.qr_style === 'rounded' ? '8px' : '0' }} 
// //                 />
// //               </div>
// //             ) : el.element_type === 'image' ? (
// //               <div style={{ 
// //                 width: '100%', height: '100%', 
// //                 borderRadius: el.element_key === 'photo' ? 6 : 0, 
// //                 border: el.element_key === 'photo' ? '1px solid rgba(255,255,255,0.3)' : 'none', 
// //                 overflow: 'hidden', display: 'flex', alignItems: 'center', justifyContent: 'center', 
// //                 background: 'rgba(255,255,255,0.1)', color: 'rgba(255,255,255,0.6)', fontSize: 11 
// //               }}>
// //                 {el.element_key === 'signature' ? (signaturePreview ? <img src={signaturePreview} alt="Sig" style={{ width: '100%', height: '100%', objectFit: 'contain' }} /> : <EditOutlined style={{ fontSize: 20 }} />) :
// //                  el.element_key === 'org_logo' ? (logoPreview ? <img src={logoPreview} alt="Logo" style={{ width: '100%', height: '100%', objectFit: 'contain' }} /> : <BankOutlined style={{ fontSize: 20 }} />) :
// //                  el.element_key === 'photo' ? <CameraOutlined style={{ fontSize: 20 }} /> :
// //                  el.element_key === 'custom_photo' ? (customPhotoPreview ? <img src={customPhotoPreview} alt="Custom" style={{ width: '100%', height: '100%', objectFit: 'cover' }} /> : <PictureOutlined style={{ fontSize: 20 }} />) :
// //                  <PictureOutlined style={{ fontSize: 20 }} />}
// //               </div>
// //             ) : (
// //               <span style={{ width: '100%', textAlign: el.text_align || 'left', fontFamily: el.font_family || 'Content, sans-serif' }}>
// //                 {el.element_type === 'custom-text' ? (el.custom_text || 'Custom Text') : el.label}
// //               </span>
// //             )}
// //             {sel && <div style={{ position: 'absolute', top: -10, right: -10, width: 20, height: 20, borderRadius: '50%', background: '#ff4d4f', color: 'white', display: 'flex', alignItems: 'center', justifyContent: 'center', cursor: 'pointer', fontSize: 12, zIndex: 1001 }} onClick={(e) => { e.stopPropagation(); deleteElement(eid); }}>×</div>}
// //           </div>
// //         );
// //       })}
// //     </div>
// //   );

// //   const elementGroups = [
// //     { title: '👤 Personal', items: [
// //       { type: 'text', key: 'fullname', label: 'Full Name', icon: <UserOutlined /> },
// //       { type: 'text', key: 'frontname', label: 'Title', icon: <StarOutlined /> },
// //       { type: 'text', key: 'staffname_eng', label: 'Name ENG', icon: <GlobalOutlined /> },
// //       { type: 'text', key: 'idnumber', label: 'ID Number', icon: <IdcardOutlined /> },
// //       { type: 'text', key: 'gender', label: 'Gender', icon: <UserOutlined /> },
// //       { type: 'text', key: 'dob', label: 'DOB', icon: <IdcardOutlined /> },
// //     ]},
// //     { title: '💼 Work', items: [
// //       { type: 'text', key: 'position_name', label: 'Position', icon: <CrownOutlined /> },
// //       { type: 'text', key: 'department_name', label: 'Department', icon: <TeamOutlined /> },
// //       { type: 'text', key: 'skill_name', label: 'Skill', icon: <ThunderboltOutlined /> },
// //       { type: 'text', key: 'jobstatus', label: 'Job Status', icon: <CheckCircleOutlined /> },
// //       { type: 'text', key: 'stafftype', label: 'Staff Type', icon: <IdcardOutlined /> },
// //       { type: 'text', key: 'level', label: 'Level', icon: <StarOutlined /> },
// //       { type: 'text', key: 'joinwork', label: 'Join Date', icon: <IdcardOutlined /> },
// //     ]},
// //     { title: '📱 Contact', items: [
// //       { type: 'text', key: 'username', label: 'Phone', icon: <PhoneOutlined /> },
// //     ]},
// //     { title: '🖼️ Media', items: [
// //       { type: 'image', key: 'photo', label: 'Photo', icon: <CameraOutlined /> },
// //       { type: 'image', key: 'org_logo', label: 'Org Logo', icon: <BankOutlined /> },
// //       { type: 'image', key: 'signature', label: 'Signature', icon: <EditOutlined /> },
// //       { type: 'image', key: 'custom_photo', label: 'Custom Photo', icon: <PictureOutlined /> },
// //       { type: 'text', key: 'org_name', label: 'Org Name', icon: <GlobalOutlined /> },
// //     ]},
// //     { title: '✏️ Custom', items: [
// //       { type: 'custom-text', key: 'custom_text', label: 'Custom Text', icon: <FontSizeOutlined /> },
// //     ]},
// //     { title: '🎨 Shapes', items: [
// //       { type: 'shape', key: null, label: 'Shape', icon: <HighlightOutlined /> },
// //     ]},
// //     { title: '🔢 Extra', items: [
// //       { type: 'qrcode', key: 'qrcode_id', label: 'QR Code', icon: <QrcodeOutlined /> },
// //       { type: 'text', key: 'role_name', label: 'Role', icon: <TeamOutlined /> },
// //     ]},
// //   ];

// //   return (
// //     <div className="id-card-designer" style={{ padding: 24, background: '#f0f2f5', minHeight: '100vh' }}>
// //       {loadingSpin && <div className="sprinSave"><GetLoading /></div>}
      
// //       {/* Header */}
// //       <div style={{ background: 'linear-gradient(135deg, #667eea, #764ba2)', borderRadius: 16, padding: '24px 32px', marginBottom: 24, color: 'white', boxShadow: '0 10px 40px rgba(102,126,234,0.4)' }}>
// //         <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', flexWrap: 'wrap', gap: 16 }}>
// //           <div>
// //             <h1 style={{ color: 'white', margin: 0, fontSize: 28, fontWeight: 700 }}><IdcardOutlined style={{ marginRight: 12 }} />ID Card Designer</h1>
// //             <p style={{ color: 'rgba(255,255,255,0.8)', margin: '8px 0 0', fontSize: 14 }}>Click & drag elements to position them</p>
// //           </div>
// //           <Space>
// //              <Button icon={<SaveOutlined />} onClick={saveElements} loading={loadingSpin} size="large" style={{ background: 'white', color: '#667eea', border: 'none' }}>Save Design</Button>
// //           </Space>
// //         </div>
// //       </div>

// //       <div style={{ display: 'grid', gridTemplateColumns: '260px 1fr 350px', gap: 24 }}>
// //         {/* Left - Elements */}
// //         <Card title="📦 Elements" style={{ borderRadius: 16, boxShadow: '0 4px 20px rgba(0,0,0,0.08)', position: 'sticky', top: 24 }}>
// //           <Segmented block value={orientation} onChange={handleOrientationChange} options={[{ label: '🏞️ Landscape', value: 'landscape' }, { label: '📱 Portrait', value: 'portrait' }]} style={{ marginBottom: 16 }} />
// //           <Divider />
// //           {elementGroups.map(g => (
// //             <div key={g.title} style={{ marginBottom: 20 }}>
// //               <h4 style={{ color: '#666', fontSize: 12, textTransform: 'uppercase', marginBottom: 8 }}>{g.title}</h4>
// //               <Space direction="vertical" style={{ width: '100%' }}>
// //                 {g.items.map(item => (
// //                   <Button key={item.key || item.label} block icon={item.icon} onClick={() => addElement(item.type, item.key, item.label)} style={{ textAlign: 'left', borderRadius: 10, height: 40 }}>{item.label}</Button>
// //                 ))}
// //               </Space>
// //             </div>
// //           ))}
// //         </Card>

// //         {/* Center - Canvas */}
// //         <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', gap: 16 }}>
// //           <Card style={{ width: '100%', borderRadius: 16, boxShadow: '0 4px 20px rgba(0,0,0,0.08)' }}>
// //             <Space style={{ width: '100%', justifyContent: 'space-between' }}>
// //               <Select style={{ width: 250 }} placeholder="Select template" value={currentTemplate?.id} onChange={loadTemplate} size="large">
// //                 {templates.map(t => <Option key={t.id} value={t.id}>{t.is_default === 1 && '⭐ '}{t.template_name}</Option>)}
// //               </Select>
// //               <Space>
// //                 <Button icon={<PlusOutlined />} onClick={() => { setEditingTemplate(null); templateForm.resetFields(); setShowTemplateModal(true); }}>New</Button>
// //                 <Button icon={<SettingOutlined />} onClick={() => { setEditingTemplate(currentTemplate); templateForm.setFieldsValue(currentTemplate); setShowTemplateModal(true); }} disabled={!currentTemplate}>Settings</Button>
// //               </Space>
// //             </Space>
// //           </Card>
// //           <div style={{ background: '#e8e8e8', borderRadius: 16, padding: 40, boxShadow: 'inset 0 2px 10px rgba(0,0,0,0.1)', overflow: 'auto', maxHeight: 'calc(100vh - 300px)', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
// //             <div style={{ transform: `scale(${zoomLevel})`, transformOrigin: 'center center', transition: 'transform 0.2s' }}>{renderIDCard()}</div>
// //           </div>
// //           <Card size="small" style={{ borderRadius: 12 }}>
// //             <Space><span>🔍</span><Slider min={0.5} max={1.5} step={0.1} value={zoomLevel} onChange={setZoomLevel} style={{ width: 150 }} /><span>{Math.round(zoomLevel * 100)}%</span></Space>
// //           </Card>
// //         </div>

// //         {/* Right - Settings */}
// //         <div style={{ maxHeight: 'calc(100vh - 150px)', overflowY: 'auto' }}>
// //           {/* Background */}
// //           <Card title="🎨 Background" style={{ borderRadius: 16, boxShadow: '0 4px 20px rgba(0,0,0,0.08)', marginBottom: 16 }}>
// //             <Radio.Group value={backgroundType} onChange={(e) => setBackgroundType(e.target.value)} style={{ marginBottom: 16, width: '100%' }} size="small">
// //               <Radio.Button value="none" style={{ width: '25%', textAlign: 'center' }}>None</Radio.Button>
// //               <Radio.Button value="color" style={{ width: '25%', textAlign: 'center' }}>Color</Radio.Button>
// //               <Radio.Button value="gradient" style={{ width: '25%', textAlign: 'center' }}>Gradient</Radio.Button>
// //               <Radio.Button value="image" style={{ width: '25%', textAlign: 'center' }}>Image</Radio.Button>
// //             </Radio.Group>
// //             {backgroundType === 'color' && (
// //               <div style={{ marginBottom: 12 }}>
// //                 <label style={{ fontSize: 12, color: '#666' }}>Color</label>
// //                 <ColorPicker value={bgColor} onChange={(c) => setBgColor(c.toHexString())} style={{ width: '100%' }} />
// //               </div>
// //             )}
// //             {backgroundType === 'gradient' && (
// //               <div>
// //                 <div style={{ marginBottom: 12 }}>
// //                   <label style={{ fontSize: 12, color: '#666' }}>Presets</label>
// //                   <div style={{ display: 'grid', gridTemplateColumns: 'repeat(4, 1fr)', gap: 6 }}>
// //                     {GRADIENT_PRESETS.filter(p => p.type !== 'none').map((p, i) => (
// //                       <Tooltip key={i} title={p.name}>
// //                         <div onClick={() => applyGradientPreset(p)} style={{ height: 30, borderRadius: 6, cursor: 'pointer', background: `linear-gradient(${p.direction}, ${p.color1}, ${p.color2})`, border: gradientColor1 === p.color1 ? '2px solid #1890ff' : '2px solid transparent' }} />
// //                       </Tooltip>
// //                     ))}
// //                   </div>
// //                 </div>
// //                 <Select value={gradientType} onChange={setGradientType} style={{ width: '100%', marginBottom: 8 }} size="small">
// //                   <Option value="linear">Linear</Option>
// //                   <Option value="radial">Radial</Option>
// //                 </Select>
// //                 <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: 8, marginBottom: 8 }}>
// //                   <ColorPicker value={gradientColor1} onChange={(c) => setGradientColor1(c.toHexString())} />
// //                   <ColorPicker value={gradientColor2} onChange={(c) => setGradientColor2(c.toHexString())} />
// //                 </div>
// //                 <Select value={gradientDirection} onChange={setGradientDirection} style={{ width: '100%' }} size="small">
// //                   {['0deg','45deg','90deg','135deg','180deg','225deg','270deg','315deg'].map(d => <Option key={d} value={d}>{d}</Option>)}
// //                 </Select>
// //               </div>
// //             )}
// //             {backgroundType === 'image' && (
// //               <div>
// //                 <label style={{ fontSize: 12, color: '#666' }}>Image</label>
// //                 {bgImagePreview ? (
// //                   <div style={{ position: 'relative', marginBottom: 8 }}>
// //                     <img src={bgImagePreview} alt="BG" style={{ width: '100%', height: 120, objectFit: 'cover', borderRadius: 8 }} />
// //                     <Button icon={<DeleteIcon />} size="small" danger onClick={handleRemoveBgImage} style={{ position: 'absolute', top: 8, right: 8 }} />
// //                   </div>
// //                 ) : (
// //                   <Upload beforeUpload={handleBgImageUpload} showUploadList={false} accept="image/*">
// //                     <Button icon={<UploadOutlined />} block style={{ borderRadius: 8, height: 80 }}>Upload Background</Button>
// //                   </Upload>
// //                 )}
// //                 <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: 8, marginTop: 8 }}>
// //                   <Select value={bgImageSize} onChange={setBgImageSize} size="small"><Option value="cover">Cover</Option><Option value="contain">Contain</Option><Option value="stretch">Stretch</Option></Select>
// //                   <Select value={bgImagePosition} onChange={setBgImagePosition} size="small"><Option value="center">Center</Option><Option value="top">Top</Option><Option value="bottom">Bottom</Option></Select>
// //                 </div>
// //                 <div style={{ marginTop: 8 }}><label style={{ fontSize: 12, color: '#666' }}>Opacity: {bgImageOpacity}</label><Slider min={0.1} max={1} step={0.1} value={bgImageOpacity} onChange={setBgImageOpacity} /></div>
// //               </div>
// //             )}
// //           </Card>

// //           {/* Card Style */}
// //           <Card title="✨ Card Style" style={{ borderRadius: 16, boxShadow: '0 4px 20px rgba(0,0,0,0.08)', marginBottom: 16 }}>
// //             <Space direction="vertical" style={{ width: '100%' }} size="small">
// //               <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
// //                 <span style={{ fontSize: 12 }}>Border Radius</span>
// //                 <InputNumber size="small" min={0} max={50} value={borderRadius} onChange={setBorderRadius} style={{ width: 80 }} addonAfter="px" />
// //               </div>
// //               <Divider style={{ margin: '8px 0' }} />
// //               <div style={{ display: 'flex', justifyContent: 'space-between' }}>
// //                 <span style={{ fontSize: 12, fontWeight: 'bold' }}>Shadow</span>
// //                 <Switch size="small" checked={shadowEnabled} onChange={setShadowEnabled} />
// //               </div>
// //               {shadowEnabled && (
// //                 <>
// //                   <div style={{ display: 'flex', justifyContent: 'space-between' }}><span style={{ fontSize: 11 }}>Color</span><ColorPicker value={shadowColor} onChange={(c) => setShadowColor(c.toHexString())} size="small" /></div>
// //                   <div style={{ display: 'flex', justifyContent: 'space-between' }}><span style={{ fontSize: 11 }}>Blur</span><InputNumber size="small" min={0} max={100} value={shadowBlur} onChange={setShadowBlur} style={{ width: 80 }} /></div>
// //                   <div style={{ display: 'flex', justifyContent: 'space-between' }}><span style={{ fontSize: 11 }}>Spread</span><InputNumber size="small" min={-50} max={50} value={shadowSpread} onChange={setShadowSpread} style={{ width: 80 }} /></div>
// //                   <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: 8 }}>
// //                     <div style={{ display: 'flex', justifyContent: 'space-between' }}><span style={{ fontSize: 11 }}>X</span><InputNumber size="small" min={-50} max={50} value={shadowX} onChange={setShadowX} style={{ width: 70 }} /></div>
// //                     <div style={{ display: 'flex', justifyContent: 'space-between' }}><span style={{ fontSize: 11 }}>Y</span><InputNumber size="small" min={-50} max={50} value={shadowY} onChange={setShadowY} style={{ width: 70 }} /></div>
// //                   </div>
// //                 </>
// //               )}
// //               <Divider style={{ margin: '8px 0' }} />
// //               <div style={{ display: 'flex', justifyContent: 'space-between' }}><span style={{ fontSize: 12 }}>Overlay</span><Select size="small" value={overlayPattern} onChange={setOverlayPattern} style={{ width: 100 }}>{PATTERNS.map(p => <Option key={p.value} value={p.value}>{p.name}</Option>)}</Select></div>
// //               {overlayPattern !== 'none' && <div style={{ display: 'flex', justifyContent: 'space-between' }}><span style={{ fontSize: 12 }}>Opacity</span><InputNumber size="small" min={0} max={1} step={0.1} value={overlayOpacity} onChange={setOverlayOpacity} style={{ width: 80 }} /></div>}
// //               <div style={{ display: 'flex', justifyContent: 'space-between' }}><span style={{ fontSize: 12 }}>Gold Chip</span><Space size="small"><Switch size="small" checked={chipEnabled} onChange={setChipEnabled} />{chipEnabled && <ColorPicker value={chipColor} onChange={(c) => setChipColor(c.toHexString())} size="small" />}</Space></div>
// //             </Space>
// //           </Card>

// //           {/* Signature, Logo & Custom Photo */}
// //           <Card title={<Space><PictureOutlined /> Images</Space>} style={{ borderRadius: 16, boxShadow: '0 4px 20px rgba(0,0,0,0.08)', marginBottom: 16 }}>
// //             <Tabs size="small" items={[
// //               {
// //                 key: 'signature',
// //                 label: '✍️ Signature',
// //                 children: (
// //                   <div>
// //                     {signaturePreview ? (
// //                       <div style={{ position: 'relative' }}>
// //                         <img src={signaturePreview} alt="Sig" style={{ width: '100%', height: 70, objectFit: 'contain', borderRadius: 8, background: '#f5f5f5', padding: 8 }} />
// //                         <Button icon={<DeleteIcon />} size="small" danger onClick={handleRemoveSignature} style={{ position: 'absolute', top: 4, right: 4 }} />
// //                       </div>
// //                     ) : (
// //                       <Upload beforeUpload={handleSignatureUpload} showUploadList={false} accept="image/*">
// //                         <Button icon={<UploadOutlined />} block style={{ borderRadius: 8, height: 50 }}>Upload Signature</Button>
// //                       </Upload>
// //                     )}
// //                   </div>
// //                 )
// //               },
// //               {
// //                 key: 'logo',
// //                 label: '🏢 Logo',
// //                 children: (
// //                   <div>
// //                     {logoPreview ? (
// //                       <div style={{ position: 'relative' }}>
// //                         <img src={logoPreview} alt="Logo" style={{ width: '100%', height: 70, objectFit: 'contain', borderRadius: 8, background: '#f5f5f5', padding: 8 }} />
// //                         <Button icon={<DeleteIcon />} size="small" danger onClick={handleRemoveLogo} style={{ position: 'absolute', top: 4, right: 4 }} />
// //                       </div>
// //                     ) : (
// //                       <Upload beforeUpload={handleLogoUpload} showUploadList={false} accept="image/*">
// //                         <Button icon={<UploadOutlined />} block style={{ borderRadius: 8, height: 50 }}>Upload Logo</Button>
// //                       </Upload>
// //                     )}
// //                   </div>
// //                 )
// //               },
// //               {
// //                 key: 'custom_photo',
// //                 label: '🖼️ Custom Photo',
// //                 children: (
// //                   <div>
// //                     {customPhotoPreview ? (
// //                       <div style={{ position: 'relative' }}>
// //                         <img src={customPhotoPreview} alt="Custom" style={{ width: '100%', height: 70, objectFit: 'cover', borderRadius: 8 }} />
// //                         <Button icon={<DeleteIcon />} size="small" danger onClick={handleRemoveCustomPhoto} style={{ position: 'absolute', top: 4, right: 4 }} />
// //                       </div>
// //                     ) : (
// //                       <Upload beforeUpload={handleCustomPhotoUpload} showUploadList={false} accept="image/*">
// //                         <Button icon={<UploadOutlined />} block style={{ borderRadius: 8, height: 50 }}>Upload Photo</Button>
// //                       </Upload>
// //                     )}
// //                   </div>
// //                 )
// //               },
// //             ]} />
// //           </Card>

// //           {/* Layer Management */}
// //           {selectedElement && (
// //             <Card title={<Space><VerticalAlignTopOutlined /> Layer Order</Space>} style={{ borderRadius: 16, boxShadow: '0 4px 20px rgba(0,0,0,0.08)', marginBottom: 16 }} size="small">
// //               <div style={{ background: '#f5f5f5', padding: '12px', borderRadius: '8px', marginBottom: '12px' }}>
// //                 <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
// //                   <span style={{ fontSize: '12px', color: '#666' }}>Current Layer:</span>
// //                   <Tag color="blue" style={{ fontSize: '12px' }}>Z-Index: {selectedElement.z_index || 2}</Tag>
// //                 </div>
// //               </div>
// //               <Space direction="vertical" style={{ width: '100%' }} size="small">
// //                 <Button block icon={<VerticalAlignTopOutlined />} onClick={() => bringToFront(selectedElement.id || selectedElement.tempId)} style={{ background: 'linear-gradient(135deg, #667eea, #764ba2)', color: 'white', border: 'none', borderRadius: '8px' }}>Bring to Front</Button>
// //                 <Button block icon={<ArrowUpOutlined />} onClick={() => bringForward(selectedElement.id || selectedElement.tempId)} style={{ borderRadius: '8px' }}>Bring Forward</Button>
// //                 <Button block icon={<ArrowDownOutlined />} onClick={() => sendBackward(selectedElement.id || selectedElement.tempId)} style={{ borderRadius: '8px' }}>Send Backward</Button>
// //                 <Button block icon={<VerticalAlignBottomOutlined />} onClick={() => sendToBack(selectedElement.id || selectedElement.tempId)} style={{ background: 'linear-gradient(135deg, #ff4d4f, #ff7875)', color: 'white', border: 'none', borderRadius: '8px' }}>Send to Back</Button>
// //               </Space>
// //               <Divider style={{ margin: '12px 0' }} />
// //               <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
// //                 <span style={{ fontSize: '12px', color: '#666' }}>Manual Z-Index:</span>
// //                 <InputNumber size="small" min={1} max={999} value={selectedElement.z_index || 2} onChange={(v) => updateElementProps(selectedElement.id || selectedElement.tempId, { z_index: v })} style={{ width: '80px' }} />
// //               </div>
// //             </Card>
// //           )}

// //           {/* Shape Properties */}
// //           {selectedElement && selectedElement.element_type === 'shape' && (
// //             <Card title={<Space><HighlightOutlined /> Shape Properties</Space>} extra={<Space size="small"><Tooltip title="Front"><Button type="text" size="small" icon={<VerticalAlignTopOutlined />} onClick={() => bringToFront(selectedElement.id || selectedElement.tempId)} /></Tooltip><Tooltip title="Back"><Button type="text" size="small" icon={<VerticalAlignBottomOutlined />} onClick={() => sendToBack(selectedElement.id || selectedElement.tempId)} /></Tooltip><Button type="text" danger icon={<DeleteOutlined />} size="small" onClick={() => deleteElement(selectedElement.id || selectedElement.tempId)} /></Space>} style={{ borderRadius: 16, boxShadow: '0 4px 20px rgba(0,0,0,0.08)', marginBottom: 16 }}>
// //               <Space direction="vertical" style={{ width: '100%' }} size="small">
// //                 <div><label style={{ fontSize: 12, color: '#666' }}>Shape Type</label><Select value={selectedElement.shape_type} onChange={(v) => updateShapeProps({ shape_type: v })} style={{ width: '100%' }} size="small">{SHAPE_TYPES.map(s => <Option key={s.value} value={s.value}>{s.name}</Option>)}</Select></div>
// //                 <Divider style={{ margin: '8px 0' }} />
// //                 <div><label style={{ fontSize: 12, color: '#666' }}>Fill Type</label><Radio.Group value={selectedElement.shape_fill_type} onChange={(e) => updateShapeProps({ shape_fill_type: e.target.value })} size="small" style={{ width: '100%' }}><Radio.Button value="solid" style={{ width: '50%', textAlign: 'center' }}>Solid</Radio.Button><Radio.Button value="gradient" style={{ width: '50%', textAlign: 'center' }}>Gradient</Radio.Button></Radio.Group></div>
// //                 {selectedElement.shape_fill_type === 'solid' ? (
// //                   <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}><span style={{ fontSize: 12 }}>Color</span><ColorPicker value={selectedElement.shape_fill_color} onChange={(c) => updateShapeProps({ shape_fill_color: c.toHexString() })} size="small" /></div>
// //                 ) : (
// //                   <>
// //                     <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: 8 }}><ColorPicker value={selectedElement.shape_gradient_color1} onChange={(c) => updateShapeProps({ shape_gradient_color1: c.toHexString() })} /><ColorPicker value={selectedElement.shape_gradient_color2} onChange={(c) => updateShapeProps({ shape_gradient_color2: c.toHexString() })} /></div>
// //                     <Select value={selectedElement.shape_gradient_direction} onChange={(v) => updateShapeProps({ shape_gradient_direction: v })} size="small">{['0deg','45deg','90deg','135deg','180deg','225deg','270deg','315deg'].map(d => <Option key={d} value={d}>{d}</Option>)}</Select>
// //                   </>
// //                 )}
// //                 <Divider style={{ margin: '8px 0' }} />
// //                 <div style={{ display: 'flex', justifyContent: 'space-between' }}><span style={{ fontSize: 12 }}>Opacity</span><InputNumber size="small" min={0} max={1} step={0.1} value={selectedElement.shape_opacity} onChange={(v) => updateShapeProps({ shape_opacity: v })} style={{ width: 80 }} /></div>
// //                 {selectedElement.shape_type !== 'circle' && <div style={{ display: 'flex', justifyContent: 'space-between' }}><span style={{ fontSize: 12 }}>Border Radius</span><InputNumber size="small" min={0} max={50} value={selectedElement.shape_border_radius} onChange={(v) => updateShapeProps({ shape_border_radius: v })} style={{ width: 80 }} addonAfter="px" /></div>}
// //                 <Divider style={{ margin: '8px 0' }} />
// //                 <div style={{ display: 'flex', justifyContent: 'space-between' }}><span style={{ fontSize: 12, fontWeight: 'bold' }}>Shadow</span><Switch size="small" checked={selectedElement.shape_shadow_enabled} onChange={(v) => updateShapeProps({ shape_shadow_enabled: v })} /></div>
// //                 {selectedElement.shape_shadow_enabled && (<><div style={{ display: 'flex', justifyContent: 'space-between' }}><span style={{ fontSize: 11 }}>Color</span><ColorPicker value={selectedElement.shape_shadow_color} onChange={(c) => updateShapeProps({ shape_shadow_color: c.toHexString() })} size="small" /></div><div style={{ display: 'flex', justifyContent: 'space-between' }}><span style={{ fontSize: 11 }}>Blur</span><InputNumber size="small" min={0} max={100} value={selectedElement.shape_shadow_blur} onChange={(v) => updateShapeProps({ shape_shadow_blur: v })} style={{ width: 80 }} /></div></>)}
// //                 <Divider style={{ margin: '8px 0' }} />
// //                 <div style={{ display: 'flex', justifyContent: 'space-between' }}><span style={{ fontSize: 12, fontWeight: 'bold' }}>Border</span><Switch size="small" checked={selectedElement.shape_border_enabled} onChange={(v) => updateShapeProps({ shape_border_enabled: v })} /></div>
// //                 {selectedElement.shape_border_enabled && (<><div style={{ display: 'flex', justifyContent: 'space-between' }}><span style={{ fontSize: 11 }}>Color</span><ColorPicker value={selectedElement.shape_border_color} onChange={(c) => updateShapeProps({ shape_border_color: c.toHexString() })} size="small" /></div><div style={{ display: 'flex', justifyContent: 'space-between' }}><span style={{ fontSize: 11 }}>Width</span><InputNumber size="small" min={1} max={10} value={selectedElement.shape_border_width} onChange={(v) => updateShapeProps({ shape_border_width: v })} style={{ width: 80 }} addonAfter="px" /></div></>)}
// //                 <Divider style={{ margin: '8px 0' }} />
// //                 <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: 8 }}>
// //                   <div><label style={{ fontSize: 11 }}>W</label><InputNumber size="small" min={10} max={cardSize.width} value={selectedElement.width} onChange={(v) => updateElementProps(selectedElement.id || selectedElement.tempId, { width: v })} style={{ width: '100%' }} /></div>
// //                   <div><label style={{ fontSize: 11 }}>H</label><InputNumber size="small" min={10} max={cardSize.height} value={selectedElement.height} onChange={(v) => updateElementProps(selectedElement.id || selectedElement.tempId, { height: v })} style={{ width: '100%' }} /></div>
// //                 </div>
// //                 <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: 8 }}>
// //                   <div><label style={{ fontSize: 11 }}>X</label><InputNumber size="small" min={0} max={cardSize.width} value={selectedElement.x_position} onChange={(v) => updateElementProps(selectedElement.id || selectedElement.tempId, { x_position: v })} style={{ width: '100%' }} /></div>
// //                   <div><label style={{ fontSize: 11 }}>Y</label><InputNumber size="small" min={0} max={cardSize.height} value={selectedElement.y_position} onChange={(v) => updateElementProps(selectedElement.id || selectedElement.tempId, { y_position: v })} style={{ width: '100%' }} /></div>
// //                 </div>
// //               </Space>
// //             </Card>
// //           )}

// //           {/* QR Code Properties */}
// //           {selectedElement && selectedElement.element_type === 'qrcode' && (
// //             <Card title={<Space><QrcodeOutlined /> QR Code Style</Space>} extra={<Space size="small"><Tooltip title="Front"><Button type="text" size="small" icon={<VerticalAlignTopOutlined />} onClick={() => bringToFront(selectedElement.id || selectedElement.tempId)} /></Tooltip><Tooltip title="Back"><Button type="text" size="small" icon={<VerticalAlignBottomOutlined />} onClick={() => sendToBack(selectedElement.id || selectedElement.tempId)} /></Tooltip><Button type="text" danger icon={<DeleteOutlined />} size="small" onClick={() => deleteElement(selectedElement.id || selectedElement.tempId)} /></Space>} style={{ borderRadius: 16, boxShadow: '0 4px 20px rgba(0,0,0,0.08)', marginBottom: 16 }}>
// //               <Space direction="vertical" style={{ width: '100%' }} size="small">
// //                 <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}><span style={{ fontSize: 12 }}>Background</span><ColorPicker value={selectedElement.qr_bg_color} onChange={(c) => updateQRProps({ qr_bg_color: c.toHexString() })} size="small" /></div>
// //                 <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}><span style={{ fontSize: 12 }}>Foreground</span><ColorPicker value={selectedElement.qr_fg_color} onChange={(c) => updateQRProps({ qr_fg_color: c.toHexString() })} size="small" /></div>
// //                 <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}><span style={{ fontSize: 12 }}>Corner</span><ColorPicker value={selectedElement.qr_corner_color} onChange={(c) => updateQRProps({ qr_corner_color: c.toHexString() })} size="small" /></div>
// //                 <Divider style={{ margin: '8px 0' }} />
// //                 <div><label style={{ fontSize: 12, color: '#666' }}>Dot Style</label><Select value={selectedElement.qr_style} onChange={(v) => updateQRProps({ qr_style: v })} style={{ width: '100%' }} size="small"><Option value="square">Square</Option><Option value="dots">Dots</Option><Option value="rounded">Rounded</Option></Select></div>
// //                 <div><label style={{ fontSize: 12, color: '#666' }}>Eye Style</label><Select value={selectedElement.qr_eye_style} onChange={(v) => updateQRProps({ qr_eye_style: v })} style={{ width: '100%' }} size="small"><Option value="square">Square</Option><Option value="circle">Circle</Option></Select></div>
// //                 <Divider style={{ margin: '8px 0' }} />
// //                 <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: 8 }}>
// //                   <div><label style={{ fontSize: 11 }}>W</label><InputNumber size="small" min={30} max={cardSize.width} value={selectedElement.width} onChange={(v) => updateElementProps(selectedElement.id || selectedElement.tempId, { width: v })} style={{ width: '100%' }} /></div>
// //                   <div><label style={{ fontSize: 11 }}>H</label><InputNumber size="small" min={30} max={cardSize.height} value={selectedElement.height} onChange={(v) => updateElementProps(selectedElement.id || selectedElement.tempId, { height: v })} style={{ width: '100%' }} /></div>
// //                 </div>
// //                 <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: 8 }}>
// //                   <div><label style={{ fontSize: 11 }}>X</label><InputNumber size="small" min={0} max={cardSize.width} value={selectedElement.x_position} onChange={(v) => updateElementProps(selectedElement.id || selectedElement.tempId, { x_position: v })} style={{ width: '100%' }} /></div>
// //                   <div><label style={{ fontSize: 11 }}>Y</label><InputNumber size="small" min={0} max={cardSize.height} value={selectedElement.y_position} onChange={(v) => updateElementProps(selectedElement.id || selectedElement.tempId, { y_position: v })} style={{ width: '100%' }} /></div>
// //                 </div>
// //               </Space>
// //             </Card>
// //           )}

// //           {/* Text Element Properties */}
// //           {selectedElement && (selectedElement.element_type === 'text' || selectedElement.element_type === 'custom-text') && (
// //             <Card title={<Space><EditOutlined /> Properties</Space>} extra={<Button type="text" danger icon={<DeleteOutlined />} size="small" onClick={() => deleteElement(selectedElement.id || selectedElement.tempId)} />} style={{ borderRadius: 16, boxShadow: '0 4px 20px rgba(0,0,0,0.08)' }}>
// //               <Form layout="vertical" size="small">
// //                 <Form.Item label="Label"><Input value={selectedElement.label} onChange={(e) => updateElementProps(selectedElement.id || selectedElement.tempId, { label: e.target.value })} /></Form.Item>
// //                 {selectedElement.element_type === 'custom-text' && <Form.Item label="Custom Text"><Input.TextArea value={selectedElement.custom_text || ''} rows={3} onChange={(e) => updateElementProps(selectedElement.id || selectedElement.tempId, { custom_text: e.target.value })} /></Form.Item>}
// //                 <Form.Item label="Font"><Select value={selectedElement.font_family || 'Content, sans-serif'} onChange={(v) => updateElementProps(selectedElement.id || selectedElement.tempId, { font_family: v })} size="small">{FONT_FAMILIES.map(f => <Option key={f.value} value={f.value}><span style={{ fontFamily: f.value }}>{f.name}</span></Option>)}</Select></Form.Item>
// //                 <Form.Item label="Size"><InputNumber value={selectedElement.font_size} min={8} max={72} style={{ width: '100%' }} onChange={(v) => updateElementProps(selectedElement.id || selectedElement.tempId, { font_size: v })} /></Form.Item>
// //                 <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: 8 }}>
// //                   <Form.Item label="Color"><ColorPicker value={selectedElement.font_color} onChange={(c) => updateElementProps(selectedElement.id || selectedElement.tempId, { font_color: c.toHexString() })} /></Form.Item>
// //                   <Form.Item label="Weight"><Select value={selectedElement.font_weight} onChange={(v) => updateElementProps(selectedElement.id || selectedElement.tempId, { font_weight: v })}><Option value="normal">Normal</Option><Option value="bold">Bold</Option></Select></Form.Item>
// //                 </div>
// //                 <Form.Item label="Align"><Segmented block value={selectedElement.text_align} onChange={(v) => updateElementProps(selectedElement.id || selectedElement.tempId, { text_align: v })} options={[{ label: 'L', value: 'left' }, { label: 'C', value: 'center' }, { label: 'R', value: 'right' }]} /></Form.Item>
// //                 <Divider />
// //                 <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: 8 }}>
// //                   <Form.Item label="W"><InputNumber value={selectedElement.width} min={10} max={cardSize.width} style={{ width: '100%' }} onChange={(v) => updateElementProps(selectedElement.id || selectedElement.tempId, { width: v })} /></Form.Item>
// //                   <Form.Item label="H"><InputNumber value={selectedElement.height} min={10} max={cardSize.height} style={{ width: '100%' }} onChange={(v) => updateElementProps(selectedElement.id || selectedElement.tempId, { height: v })} /></Form.Item>
// //                 </div>
// //                 <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: 8 }}>
// //                   <Form.Item label="X"><InputNumber value={selectedElement.x_position} min={0} max={cardSize.width} style={{ width: '100%' }} onChange={(v) => updateElementProps(selectedElement.id || selectedElement.tempId, { x_position: v })} /></Form.Item>
// //                   <Form.Item label="Y"><InputNumber value={selectedElement.y_position} min={0} max={cardSize.height} style={{ width: '100%' }} onChange={(v) => updateElementProps(selectedElement.id || selectedElement.tempId, { y_position: v })} /></Form.Item>
// //                 </div>
// //               </Form>
// //             </Card>
// //           )}
// //         </div>
// //       </div>

// //       {/* Template Modal */}
// //       <Modal title={<Space><SettingOutlined />{editingTemplate ? 'Edit' : 'New'} Template</Space>} open={showTemplateModal} onOk={handleTemplateSave} onCancel={() => setShowTemplateModal(false)} confirmLoading={loadingSpin} width={500}>
// //         <Form form={templateForm} layout="vertical">
// //           <Form.Item name="template_name" label="Name" rules={[{ required: true }]}><Input placeholder="Premium Gold Card" size="large" /></Form.Item>
// //           <Divider>Card Size</Divider>
// //           <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: 16 }}>
// //             <Form.Item label="Width"><InputNumber value={cardSize.width} onChange={(v) => setCardSize({ ...cardSize, width: v })} min={200} max={1200} style={{ width: '100%' }} size="large" /></Form.Item>
// //             <Form.Item label="Height"><InputNumber value={cardSize.height} onChange={(v) => setCardSize({ ...cardSize, height: v })} min={150} max={800} style={{ width: '100%' }} size="large" /></Form.Item>
// //           </div>
// //           <Divider>Presets</Divider>
// //           <Space style={{ width: '100%', justifyContent: 'center' }}>
// //             <Button type={orientation === 'landscape' ? 'primary' : 'default'} icon={<SwapOutlined />} onClick={() => { setOrientation('landscape'); setCardSize({ width: 540, height: 340 }); }}>Landscape (540×340)</Button>
// //             <Button type={orientation === 'portrait' ? 'primary' : 'default'} icon={<SwapOutlined style={{ transform: 'rotate(90deg)' }} />} onClick={() => { setOrientation('portrait'); setCardSize({ width: 340, height: 540 }); }}>Portrait (340×540)</Button>
// //           </Space>
// //           <div style={{ marginTop: 16, padding: 12, background: '#f5f5f5', borderRadius: 8, textAlign: 'center' }}><span style={{ color: '#666' }}>Size: <strong>{cardSize.width} × {cardSize.height} px</strong></span></div>
// //         </Form>
// //       </Modal>

// //       {/* Preview Modal */}
// //       <Modal title={<Space><EyeOutlined />Preview</Space>} open={showPreview} onCancel={() => setShowPreview(false)} footer={<Space><Button onClick={() => setShowPreview(false)}>Close</Button><Button type="primary" icon={<DownloadOutlined />}>Download</Button></Space>} width={cardSize.width + 120} bodyStyle={{ display: 'flex', justifyContent: 'center', padding: 40, background: '#f0f2f5' }}>
// //         <div style={{ width: cardSize.width, height: cardSize.height }} />
// //       </Modal>
// //     </div>
// //   );
// // };

// // export default IDCardDesigner;


// // IDCardDesigner.js - Complete Version with All Fixes
// import React, { useState, useEffect, useRef, useCallback } from "react";
// import {
//   Button, Modal, Form, Input, Select, InputNumber, ColorPicker,
//   Space, message, Spin, Card, Slider, Switch, Tooltip,
//   Segmented, Upload, Divider, Radio, Tabs, Tag
// } from "antd";
// import {
//   PlusOutlined, EditOutlined, DeleteOutlined, SaveOutlined,
//   EyeOutlined, SettingOutlined, DownloadOutlined,
//   IdcardOutlined, PictureOutlined, FontSizeOutlined,
//   SwapOutlined, CheckCircleOutlined,
//   QrcodeOutlined, CameraOutlined,
//   UserOutlined, PhoneOutlined, BankOutlined, TeamOutlined,
//   GlobalOutlined, CrownOutlined, StarOutlined, ThunderboltOutlined,
//   UploadOutlined, DeleteOutlined as DeleteIcon,
//   BgColorsOutlined, BorderOutlined, RadiusSettingOutlined,
//   HighlightOutlined, ShrinkOutlined,
//   VerticalAlignTopOutlined, VerticalAlignBottomOutlined,
//   ArrowUpOutlined, ArrowDownOutlined, FolderOpenOutlined,
// } from "@ant-design/icons";
// import { request } from "../../../share/request";
// import { getCurrentUser } from "../../../share/getProfile";
// import { linkPath } from "../../../share/helper";
// 
// import "./IDCardDesigner.css";

// const { Option } = Select;

// const GRADIENT_PRESETS = [
//   { name: 'None', color1: null, color2: null, direction: '135deg', type: 'none' },
//   { name: 'Ocean Blue', color1: '#1a237e', color2: '#0d47a1', direction: '135deg', type: 'linear' },
//   { name: 'Royal Purple', color1: '#4a148c', color2: '#7b1fa2', direction: '135deg', type: 'linear' },
//   { name: 'Sunset Gold', color1: '#f57f17', color2: '#e65100', direction: '45deg', type: 'linear' },
//   { name: 'Forest Green', color1: '#1b5e20', color2: '#004d40', direction: '135deg', type: 'linear' },
//   { name: 'Crimson Red', color1: '#b71c1c', color2: '#880e4f', direction: '135deg', type: 'linear' },
//   { name: 'Midnight Sky', color1: '#1a237e', color2: '#000051', direction: '180deg', type: 'linear' },
//   { name: 'Rose Gold', color1: '#880e4f', color2: '#e91e63', direction: '45deg', type: 'linear' },
//   { name: 'Teal Dream', color1: '#004d40', color2: '#00695c', direction: '135deg', type: 'linear' },
// ];

// const PATTERNS = [
//   { name: 'None', value: 'none' },
//   { name: 'Dots', value: 'dots' },
//   { name: 'Lines', value: 'lines' },
//   { name: 'Grid', value: 'grid' },
// ];

// const FONT_FAMILIES = [
//   { name: 'Content (Khmer)', value: 'Content, sans-serif' },
//   { name: 'Noto Sans Khmer', value: "'Noto Sans Khmer', sans-serif" },
//   { name: 'Hanuman', value: "'Hanuman', serif" },
//   { name: 'Battambang', value: "'Battambang', cursive" },
//   { name: 'Siemreap', value: "'Siemreap', cursive" },
//   { name: 'Moul', value: "'Moul', cursive" },
//   { name: 'Arial', value: 'Arial, sans-serif' },
//   { name: 'Times New Roman', value: "'Times New Roman', serif" },
//   { name: 'Courier New', value: "'Courier New', monospace" },
// ];

// const SHAPE_TYPES = [
//   { name: 'Rectangle', value: 'rectangle', icon: <BorderOutlined /> },
//   { name: 'Circle', value: 'circle', icon: <RadiusSettingOutlined /> },
//   { name: 'Rounded Rectangle', value: 'rounded', icon: <ShrinkOutlined /> },
// ];

// const IDCardDesigner = () => {
//   const getProfile = getCurrentUser();
//   const [loading, setLoading] = useState(false);
//   const [loadingSpin, setLoadingSpin] = useState(false);
//   const [templates, setTemplates] = useState([]);
//   const [currentTemplate, setCurrentTemplate] = useState(null);
//   const [elements, setElements] = useState([]);
//   const [selectedElement, setSelectedElement] = useState(null);
//   const [previewStaff, setPreviewStaff] = useState(null);
//   const [showPreview, setShowPreview] = useState(false);
//   const [showTemplateModal, setShowTemplateModal] = useState(false);
//   const [editingTemplate, setEditingTemplate] = useState(null);

//   const [orientation, setOrientation] = useState('landscape');
//   const [cardSize, setCardSize] = useState({ width: 540, height: 340 });

//   const [backgroundType, setBackgroundType] = useState('gradient');
//   const [bgColor, setBgColor] = useState('#1a237e');
//   const [gradientType, setGradientType] = useState('linear');
//   const [gradientColor1, setGradientColor1] = useState('#1a237e');
//   const [gradientColor2, setGradientColor2] = useState('#4a148c');
//   const [gradientDirection, setGradientDirection] = useState('135deg');
//   const [bgImage, setBgImage] = useState(null);
//   const [bgImageFile, setBgImageFile] = useState(null);
//   const [bgImagePreview, setBgImagePreview] = useState(null);
//   const [bgImageSize, setBgImageSize] = useState('cover');
//   const [bgImagePosition, setBgImagePosition] = useState('center');
//   const [bgImageOpacity, setBgImageOpacity] = useState(1);

//   const [borderRadius, setBorderRadius] = useState(16);
//   const [shadowEnabled, setShadowEnabled] = useState(true);
//   const [shadowColor, setShadowColor] = useState('rgba(0,0,0,0.3)');
//   const [shadowBlur, setShadowBlur] = useState(20);
//   const [shadowSpread, setShadowSpread] = useState(0);
//   const [shadowX, setShadowX] = useState(0);
//   const [shadowY, setShadowY] = useState(10);
  
//   const [overlayEnabled, setOverlayEnabled] = useState(false);
//   const [overlayPattern, setOverlayPattern] = useState('none');
//   const [overlayOpacity, setOverlayOpacity] = useState(0.1);
//   const [chipEnabled, setChipEnabled] = useState(true);
//   const [chipColor, setChipColor] = useState('#FFD700');
//   const [zoomLevel, setZoomLevel] = useState(1);

//   const [shapeFillType, setShapeFillType] = useState('solid');
//   const [shapeFillColor, setShapeFillColor] = useState('#4CAF50');
//   const [shapeGradientColor1, setShapeGradientColor1] = useState('#667eea');
//   const [shapeGradientColor2, setShapeGradientColor2] = useState('#764ba2');
//   const [shapeGradientDirection, setShapeGradientDirection] = useState('135deg');
//   const [shapeBorderRadius, setShapeBorderRadius] = useState(8);
//   const [shapeShadowEnabled, setShapeShadowEnabled] = useState(false);
//   const [shapeShadowColor, setShapeShadowColor] = useState('rgba(0,0,0,0.3)');
//   const [shapeShadowBlur, setShapeShadowBlur] = useState(10);
//   const [shapeOpacity, setShapeOpacity] = useState(1);
//   const [shapeBorderEnabled, setShapeBorderEnabled] = useState(false);
//   const [shapeBorderColor, setShapeBorderColor] = useState('#ffffff');
//   const [shapeBorderWidth, setShapeBorderWidth] = useState(1);

//   const [qrBgColor, setQrBgColor] = useState('#FFFFFF');
//   const [qrFgColor, setQrFgColor] = useState('#000000');
//   const [qrCornerColor, setQrCornerColor] = useState('#000000');
//   const [qrStyle, setQrStyle] = useState('square');
//   const [qrEyeStyle, setQrEyeStyle] = useState('square');

//   // Image states
//   const [signatureImage, setSignatureImage] = useState(null);
//   const [signatureFile, setSignatureFile] = useState(null);
//   const [signaturePreview, setSignaturePreview] = useState(null);
//   const [signatureSize, setSignatureSize] = useState({ width: 150, height: 60 });
  
//   const [logoImage, setLogoImage] = useState(null);
//   const [logoFile, setLogoFile] = useState(null);
//   const [logoPreview, setLogoPreview] = useState(null);
//   const [logoSize, setLogoSize] = useState({ width: 80, height: 80 });
  
//   // Multiple custom photos
//   const [customPhotos, setCustomPhotos] = useState([]);
//   const [uploadedImages, setUploadedImages] = useState([]);

//   const [isDragging, setIsDragging] = useState(false);
//   const [dragElement, setDragElement] = useState(null);
//   const [dragStartPos, setDragStartPos] = useState({ x: 0, y: 0 });
//   const [elementStartPos, setElementStartPos] = useState({ x: 0, y: 0 });
//   const canvasRef = useRef(null);
//   const [templateForm] = Form.useForm();

//   // ==================== HELPERS ====================
//   const getBackgroundStyle = () => {
//     let style = {};
//     if (backgroundType === 'image' && bgImagePreview) {
//       style.backgroundImage = `url(${bgImagePreview})`;
//       style.backgroundSize = bgImageSize === 'stretch' ? '100% 100%' : bgImageSize;
//       style.backgroundPosition = bgImagePosition;
//       style.backgroundRepeat = 'no-repeat';
//       if (bgImageOpacity < 1) style.opacity = bgImageOpacity;
//       return style;
//     }
//     if (backgroundType === 'gradient') {
//       style.background = gradientType === 'linear'
//         ? `linear-gradient(${gradientDirection}, ${gradientColor1}, ${gradientColor2})`
//         : `radial-gradient(circle at center, ${gradientColor1}, ${gradientColor2})`;
//     } else if (backgroundType === 'color') {
//       style.backgroundColor = bgColor;
//     } else {
//       style.backgroundColor = 'transparent';
//     }
//     if (overlayEnabled && overlayPattern !== 'none') {
//       const o = overlayOpacity;
//       if (overlayPattern === 'dots') {
//         style.backgroundImage = `radial-gradient(circle, rgba(255,255,255,${o}) 1px, transparent 1px)`;
//         style.backgroundSize = '20px 20px';
//       } else if (overlayPattern === 'lines') {
//         style.backgroundImage = `linear-gradient(90deg, rgba(255,255,255,${o}) 1px, transparent 1px)`;
//         style.backgroundSize = '20px 20px';
//       } else if (overlayPattern === 'grid') {
//         style.backgroundImage = `linear-gradient(90deg, rgba(255,255,255,${o}) 1px, transparent 1px), linear-gradient(0deg, rgba(255,255,255,${o}) 1px, transparent 1px)`;
//         style.backgroundSize = '20px 20px';
//       }
//     }
//     return style;
//   };

//   const getCardShadow = () => shadowEnabled 
//     ? `${shadowX}px ${shadowY}px ${shadowBlur}px ${shadowSpread}px ${shadowColor}` 
//     : 'none';

//   const getShapeStyle = (el) => {
//     let style = {
//       width: '100%',
//       height: '100%',
//       opacity: el.shape_opacity || 1,
//     };
//     if (el.shape_fill_type === 'gradient') {
//       style.background = `linear-gradient(${el.shape_gradient_direction || '135deg'}, ${el.shape_gradient_color1 || '#667eea'}, ${el.shape_gradient_color2 || '#764ba2'})`;
//     } else {
//       style.backgroundColor = el.shape_fill_color || '#4CAF50';
//     }
//     if (el.shape_type === 'circle') {
//       style.borderRadius = '50%';
//     } else if (el.shape_type === 'rounded') {
//       style.borderRadius = `${el.shape_border_radius || 8}px`;
//     }
//     if (el.shape_shadow_enabled) {
//       style.boxShadow = `0 ${el.shape_shadow_blur || 10}px ${el.shape_shadow_blur * 2 || 20}px ${el.shape_shadow_color || 'rgba(0,0,0,0.3)'}`;
//     }
//     if (el.shape_border_enabled) {
//       style.border = `${el.shape_border_width || 1}px solid ${el.shape_border_color || '#ffffff'}`;
//     }
//     return style;
//   };

//   const generateQRCode = (text, size, fgColor = '#000000', bgColor = '#FFFFFF') => {
//     if (!text) return '';
//     return `https://api.qrserver.com/v1/create-qr-code/?size=${size}x${size}&data=${encodeURIComponent(text)}&margin=5&color=${fgColor.replace('#', '')}&bgcolor=${bgColor.replace('#', '')}`;
//   };

//   const bringToFront = (eid) => {
//     const maxZ = Math.max(...elements.map(el => el.z_index || 2), 2);
//     updateElementProps(eid, { z_index: maxZ + 1 });
//   };
//   const sendToBack = (eid) => {
//     const minZ = Math.min(...elements.map(el => el.z_index || 2), 2);
//     updateElementProps(eid, { z_index: Math.max(1, minZ - 1) });
//   };
//   const bringForward = (eid) => {
//     const el = elements.find(e => (e.id || e.tempId) === eid);
//     if (el) updateElementProps(eid, { z_index: (el.z_index || 2) + 1 });
//   };
//   const sendBackward = (eid) => {
//     const el = elements.find(e => (e.id || e.tempId) === eid);
//     if (el) updateElementProps(eid, { z_index: Math.max(1, (el.z_index || 2) - 1) });
//   };

//   const getCustomPhotoByIndex = (index) => {
//     if (index !== undefined && index !== null && index >= 0 && customPhotos[index]) {
//       return customPhotos[index];
//     }
//     return null;
//   };

//   // ✅ NEW: Update all elements that reference a specific image type with new size
//   const updateImageElementsSize = (imageKey, newSize) => {
//     setElements(prev => prev.map(el => {
//       if (el.element_type === 'image' && el.element_key === imageKey) {
//         return { ...el, width: newSize.width, height: newSize.height };
//       }
//       return el;
//     }));
//   };

//   // ✅ NEW: Update custom photo elements for a specific photo index
//   const updateCustomPhotoElementsSize = (photoIndex, newSize) => {
//     setElements(prev => prev.map(el => {
//       if (el.element_type === 'image' && el.element_key === 'custom_photo' && el.custom_photo_index === photoIndex) {
//         return { ...el, width: newSize.width, height: newSize.height };
//       }
//       return el;
//     }));
//   };

//   // ==================== LOAD DATA ====================
//   const loadTemplates = async () => {
//     setLoading(true);
//     try {
//       const param = new URLSearchParams({ org_code: getProfile.org_code });
//       const res = await request(`id-card-templates?${param.toString()}`, "get", {});
//       if (res?.success) {
//         setTemplates(res.data);
//         if (res.data.length > 0 && !currentTemplate) loadTemplate(res.data[0].id);
//       }
//     } catch (e) { console.error(e); }
//     finally { setLoading(false); }
//   };

//   const loadTemplateImages = async (templateId) => {
//     try {
//       const res = await request(`id-card-images/template/${templateId}`, "get", {});
//       if (res?.success) {
//         setUploadedImages(res.data);
//         // Reset
//         setSignatureImage(null);
//         setSignaturePreview(null);
//         setLogoImage(null);
//         setLogoPreview(null);
//         const photos = [];
        
//         res.data.forEach(img => {
//           const url = `${linkPath}/${img.image_path}`;
//           if (img.image_type === 'signature') { 
//             setSignatureImage(img.image_path); 
//             setSignaturePreview(url);
//             if (img.width) setSignatureSize({ width: parseInt(img.width) || 150, height: parseInt(img.height) || 60 });
//           }
//           if (img.image_type === 'logo') { 
//             setLogoImage(img.image_path); 
//             setLogoPreview(url);
//             if (img.width) setLogoSize({ width: parseInt(img.width) || 80, height: parseInt(img.height) || 80 });
//           }
//           if (img.image_type === 'custom_photo') { 
//             photos.push({
//               id: img.id,
//               image_path: img.image_path,
//               preview: url,
//               size: { width: parseInt(img.width) || 80, height: parseInt(img.height) || 100 },
//               file: null,
//               tempId: null
//             });
//           }
//         });
//         setCustomPhotos(photos);
//       }
//     } catch (e) { console.error(e); }
//   };

//   const loadTemplate = async (templateId) => {
//     setLoading(true);
//     try {
//       const res = await request(`id-card-templates/${templateId}`, "get", {});
//       if (res?.success) {
//         const tpl = res.data;
//         setCurrentTemplate(tpl);
//         setElements(tpl.elements || []);
//         setOrientation(tpl.orientation || 'landscape');
//         setCardSize({ width: tpl.width || 540, height: tpl.height || 340 });
//         setBackgroundType(tpl.background_type || 'gradient');
//         setBgColor(tpl.background_color || '#1a237e');
//         setGradientType(tpl.gradient_type || 'linear');
//         setGradientColor1(tpl.gradient_color1 || '#1a237e');
//         setGradientColor2(tpl.gradient_color2 || '#4a148c');
//         setGradientDirection(tpl.gradient_direction || '135deg');
//         if (tpl.background_image) {
//           setBgImage(tpl.background_image);
//           setBgImagePreview(`${linkPath}/${tpl.background_image}`);
//         } else { setBgImage(null); setBgImagePreview(null); }
//         setBgImageSize(tpl.bg_image_size || 'cover');
//         setBgImagePosition(tpl.bg_image_position || 'center');
//         setBgImageOpacity(tpl.bg_image_opacity || 1);
//         setBorderRadius(tpl.border_radius || 16);
//         setShadowEnabled(tpl.shadow_enabled === 1);
//         setShadowColor(tpl.shadow_color || 'rgba(0,0,0,0.3)');
//         setShadowBlur(tpl.shadow_blur || 20);
//         setShadowSpread(tpl.shadow_spread || 0);
//         setShadowX(tpl.shadow_x || 0);
//         setShadowY(tpl.shadow_y || 10);
//         setOverlayEnabled(tpl.overlay_enabled === 1);
//         setOverlayPattern(tpl.overlay_pattern || 'none');
//         setOverlayOpacity(tpl.overlay_opacity || 0.1);
//         setChipEnabled(tpl.chip_enabled === 1);
//         setChipColor(tpl.chip_color || '#FFD700');
//         setSelectedElement(null);
//         await loadTemplateImages(templateId);
//       }
//     } catch (e) { console.error(e); }
//     finally { setLoading(false); }
//   };

//   useEffect(() => { loadTemplates(); }, []);

//   // ==================== HANDLERS ====================
//   const handleOrientationChange = (v) => {
//     setOrientation(v);
//     setCardSize(v === 'portrait' ? { width: 340, height: 540 } : { width: 540, height: 340 });
//   };

//   const handleBgImageUpload = (file) => {
//     const reader = new FileReader();
//     reader.onload = (e) => { setBgImagePreview(e.target.result); setBgImageFile(file); };
//     reader.readAsDataURL(file);
//     return false;
//   };
//   const handleRemoveBgImage = () => { setBgImagePreview(null); setBgImageFile(null); setBgImage(null); };

//   const handleSignatureUpload = (file) => {
//     const reader = new FileReader();
//     reader.onload = (e) => { setSignaturePreview(e.target.result); setSignatureFile(file); };
//     reader.readAsDataURL(file);
//     return false;
//   };
//   const handleRemoveSignature = () => { setSignaturePreview(null); setSignatureFile(null); setSignatureImage(null); };

//   const handleLogoUpload = (file) => {
//     const reader = new FileReader();
//     reader.onload = (e) => { setLogoPreview(e.target.result); setLogoFile(file); };
//     reader.readAsDataURL(file);
//     return false;
//   };
//   const handleRemoveLogo = () => { setLogoPreview(null); setLogoFile(null); setLogoImage(null); };

//   // Multiple custom photo handlers
//   const handleCustomPhotoUpload = (file) => {
//     const reader = new FileReader();
//     reader.onload = (e) => {
//       const newPhoto = {
//         tempId: `cp_${Date.now()}_${Math.random().toString(36).substr(2, 5)}`,
//         preview: e.target.result,
//         file: file,
//         size: { width: 80, height: 100 },
//         id: null,
//         image_path: null
//       };
//       setCustomPhotos(prev => [...prev, newPhoto]);
//     };
//     reader.readAsDataURL(file);
//     return false;
//   };

//   const handleRemoveCustomPhoto = (index) => {
//     setCustomPhotos(prev => prev.filter((_, i) => i !== index));
//   };

//   // ✅ FIXED: Update photo size AND all elements using that photo
//   const handleSignatureSizeChange = (newSize) => {
//     setSignatureSize(newSize);
//     updateImageElementsSize('signature', newSize);
//   };

//   const handleLogoSizeChange = (newSize) => {
//     setLogoSize(newSize);
//     updateImageElementsSize('org_logo', newSize);
//   };

//   const handleCustomPhotoSizeChange = (index, newSize) => {
//     setCustomPhotos(prev => prev.map((p, i) => i === index ? { ...p, size: newSize } : p));
//     updateCustomPhotoElementsSize(index, newSize);
//   };

//   const uploadImageWithType = async (file, imageType, extraData = {}) => {
//     const fd = new FormData();
//     fd.append('idcard_bg', file);
//     fd.append('template_id', currentTemplate?.id);
//     fd.append('image_type', imageType);
//     fd.append('org_code', getProfile.org_code);
//     if (extraData.width) fd.append('width', extraData.width);
//     if (extraData.height) fd.append('height', extraData.height);
//     try {
//       const res = await request("id-card-images", "POST", fd, true);
//       if (res?.success) { 
//         message.success(`${imageType} uploaded!`); 
//         return res.data; 
//       }
//     } catch (e) { message.error("Upload failed"); }
//     return null;
//   };

//   const addElement = (type, key = null, label = '', extraData = {}) => {
//     // ✅ Get size from image settings if applicable
//     let defaultW = 150, defaultH = 30;
//     if (type === 'image') {
//       if (key === 'signature') { defaultW = signatureSize.width; defaultH = signatureSize.height; }
//       else if (key === 'org_logo') { defaultW = logoSize.width; defaultH = logoSize.height; }
//       else if (key === 'custom_photo' && extraData.photoIndex !== undefined) {
//         const photo = customPhotos[extraData.photoIndex];
//         if (photo) { defaultW = photo.size.width; defaultH = photo.size.height; }
//       }
//       else if (key === 'photo') { defaultW = 80; defaultH = 100; }
//       else { defaultW = extraData.width || 80; defaultH = extraData.height || 100; }
//     } else if (type === 'qrcode') { defaultW = 80; defaultH = 80; }
//     else if (type === 'shape') { defaultW = 100; defaultH = 80; }

//     const maxZ = Math.max(...elements.map(el => el.z_index || 2), 2);
//     const el = {
//       template_id: currentTemplate?.id,
//       element_type: type, element_key: key, label: label || type,
//       custom_text: type === 'custom-text' ? 'Enter text' : '',
//       x_position: 50 + elements.length * 20, y_position: 50 + elements.length * 20,
//       width: defaultW, height: defaultH, font_size: 14, font_color: '#FFFFFF',
//       font_weight: 'bold', font_family: 'Content, sans-serif', text_align: 'left',
//       is_visible: 1, sort_order: elements.length + 1, is_new: true,
//       tempId: `t_${Date.now()}_${Math.random().toString(36).substr(2, 9)}`,
//       z_index: maxZ + 1,
//       custom_photo_index: extraData.photoIndex !== undefined ? extraData.photoIndex : null,
//       // Shape defaults
//       shape_type: 'rounded', shape_fill_type: 'solid', shape_fill_color: '#4CAF50',
//       shape_gradient_color1: '#667eea', shape_gradient_color2: '#764ba2', shape_gradient_direction: '135deg',
//       shape_border_radius: 8, shape_shadow_enabled: false, shape_shadow_color: 'rgba(0,0,0,0.3)',
//       shape_shadow_blur: 10, shape_opacity: 1, shape_border_enabled: false,
//       shape_border_color: '#ffffff', shape_border_width: 1,
//       // QR Code defaults
//       qr_bg_color: '#FFFFFF', qr_fg_color: '#000000', qr_corner_color: '#000000',
//       qr_style: 'square', qr_eye_style: 'square',
//     };
//     if (type === 'image' || type === 'qrcode' || type === 'shape') {
//       el.font_size = 0;
//       el.font_weight = 'normal';
//     }
//     setElements([...elements, el]);
//     setSelectedElement(el);
//   };

//   const handleMouseDown = (e, el) => {
//     e.preventDefault(); e.stopPropagation();
//     setSelectedElement(el);
//     if (el.element_type === 'shape') {
//       setShapeFillType(el.shape_fill_type || 'solid');
//       setShapeFillColor(el.shape_fill_color || '#4CAF50');
//       setShapeGradientColor1(el.shape_gradient_color1 || '#667eea');
//       setShapeGradientColor2(el.shape_gradient_color2 || '#764ba2');
//       setShapeGradientDirection(el.shape_gradient_direction || '135deg');
//       setShapeBorderRadius(el.shape_border_radius || 8);
//       setShapeShadowEnabled(el.shape_shadow_enabled || false);
//       setShapeShadowColor(el.shape_shadow_color || 'rgba(0,0,0,0.3)');
//       setShapeShadowBlur(el.shape_shadow_blur || 10);
//       setShapeOpacity(el.shape_opacity || 1);
//       setShapeBorderEnabled(el.shape_border_enabled || false);
//       setShapeBorderColor(el.shape_border_color || '#ffffff');
//       setShapeBorderWidth(el.shape_border_width || 1);
//     }
//     if (el.element_type === 'qrcode') {
//       setQrBgColor(el.qr_bg_color || '#FFFFFF');
//       setQrFgColor(el.qr_fg_color || '#000000');
//       setQrCornerColor(el.qr_corner_color || '#000000');
//       setQrStyle(el.qr_style || 'square');
//       setQrEyeStyle(el.qr_eye_style || 'square');
//     }
//     setIsDragging(true); setDragElement(el);
//     setDragStartPos({ x: e.clientX, y: e.clientY });
//     setElementStartPos({ x: el.x_position || 0, y: el.y_position || 0 });
//   };

//   const handleMouseMove = useCallback((e) => {
//     if (!isDragging || !dragElement) return;
//     const dx = (e.clientX - dragStartPos.x) / zoomLevel;
//     const dy = (e.clientY - dragStartPos.y) / zoomLevel;
//     const nx = Math.max(0, Math.min(cardSize.width - (dragElement.width || 100), elementStartPos.x + dx));
//     const ny = Math.max(0, Math.min(cardSize.height - (dragElement.height || 30), elementStartPos.y + dy));
//     const eid = dragElement.id || dragElement.tempId;
//     setElements(prev => prev.map(el => (el.id || el.tempId) === eid ? { ...el, x_position: Math.round(nx), y_position: Math.round(ny) } : el));
//   }, [isDragging, dragElement, dragStartPos, elementStartPos, cardSize, zoomLevel]);

//   const handleMouseUp = useCallback(() => { setIsDragging(false); setDragElement(null); }, [isDragging]);

//   useEffect(() => {
//     if (isDragging) { window.addEventListener('mousemove', handleMouseMove); window.addEventListener('mouseup', handleMouseUp); }
//     return () => { window.removeEventListener('mousemove', handleMouseMove); window.removeEventListener('mouseup', handleMouseUp); };
//   }, [isDragging, handleMouseMove, handleMouseUp]);

//   const updateElementProps = (eid, props) => {
//     setElements(prev => prev.map(el => (el.id || el.tempId) === eid ? { ...el, ...props } : el));
//     setSelectedElement(prev => prev && ((prev.id || prev.tempId) === eid) ? { ...prev, ...props } : prev);
//   };

//   const deleteElement = async (eid) => {
//     const el = elements.find(e => (e.id || e.tempId) === eid);
//     if (el?.is_new) { setElements(elements.filter(e => (e.id || e.tempId) !== eid)); setSelectedElement(null); return; }
//     if (el?.id) {
//       try { await request(`id-card-elements/${el.id}`, "DELETE", {}); setElements(elements.filter(e => e.id !== el.id)); setSelectedElement(null); }
//       catch (e) { console.error(e); }
//     }
//   };

//   // ==================== SAVE ====================
//   const saveElements = async () => {
//     if (!currentTemplate) { message.warning("Select a template first"); return; }
//     setLoadingSpin(true);
//     try {
//       // Upload signature
//       if (signatureFile) { 
//         const d = await uploadImageWithType(signatureFile, 'signature', signatureSize); 
//         if (d) { setSignatureImage(d.filename || d.image_path); setSignatureFile(null); } 
//       }
//       // Upload logo
//       if (logoFile) { 
//         const d = await uploadImageWithType(logoFile, 'logo', logoSize); 
//         if (d) { setLogoImage(d.filename || d.image_path); setLogoFile(null); } 
//       }
      
//       // Upload multiple custom photos
//       for (let i = 0; i < customPhotos.length; i++) {
//         const photo = customPhotos[i];
//         if (photo.file) {
//           const d = await uploadImageWithType(photo.file, 'custom_photo', photo.size);
//           if (d) {
//             setCustomPhotos(prev => prev.map((p, idx) => 
//               idx === i ? { ...p, image_path: d.filename || d.image_path, file: null, id: d.id, tempId: null } : p
//             ));
//           }
//         }
//       }
      
//       let fBg = bgImage;
//       if (bgImageFile) {
//         const fd = new FormData(); fd.append('idcard_bg', bgImageFile);
//         const res = await request("id-card-upload", "POST", fd, true);
//         if (res?.success) { fBg = res.data.filename || res.data.image_path; setBgImage(fBg); setBgImageFile(null); setBgImagePreview(`${linkPath}/${fBg}`); }
//       }
      
//       // Save template
//       await request(`id-card-templates/${currentTemplate.id}`, "PUT", {
//         width: cardSize.width, height: cardSize.height, orientation,
//         background_type: backgroundType, background_color: bgColor, background_image: fBg,
//         gradient_type: gradientType, gradient_color1: gradientColor1, gradient_color2: gradientColor2, gradient_direction: gradientDirection,
//         bg_image_size: bgImageSize, bg_image_position: bgImagePosition, bg_image_opacity: bgImageOpacity,
//         border_radius: borderRadius, shadow_enabled: shadowEnabled, shadow_color: shadowColor,
//         shadow_blur: shadowBlur, shadow_spread: shadowSpread, shadow_x: shadowX, shadow_y: shadowY,
//         overlay_enabled: overlayEnabled, overlay_pattern: overlayPattern, overlay_opacity: overlayOpacity,
//         chip_enabled: chipEnabled, chip_color: chipColor,
//       });
      
//       // Save elements
//       for (const el of elements) {
//         const data = {
//           id: el.id || null, template_id: currentTemplate.id,
//           element_type: el.element_type, element_key: el.element_key, label: el.label,
//           custom_text: el.custom_text || null,
//           x_position: el.x_position, y_position: el.y_position, width: el.width, height: el.height,
//           font_size: el.font_size, font_color: el.font_color, font_weight: el.font_weight,
//           font_family: el.font_family, text_align: el.text_align,
//           is_visible: el.is_visible, sort_order: el.sort_order,
//           z_index: el.z_index || 2,
//           custom_photo_index: el.custom_photo_index,
//           shape_type: el.shape_type, shape_fill_type: el.shape_fill_type,
//           shape_fill_color: el.shape_fill_color, shape_gradient_color1: el.shape_gradient_color1,
//           shape_gradient_color2: el.shape_gradient_color2, shape_gradient_direction: el.shape_gradient_direction,
//           shape_border_radius: el.shape_border_radius, shape_shadow_enabled: el.shape_shadow_enabled,
//           shape_shadow_color: el.shape_shadow_color, shape_shadow_blur: el.shape_shadow_blur,
//           shape_opacity: el.shape_opacity, shape_border_enabled: el.shape_border_enabled,
//           shape_border_color: el.shape_border_color, shape_border_width: el.shape_border_width,
//           qr_bg_color: el.qr_bg_color, qr_fg_color: el.qr_fg_color,
//           qr_corner_color: el.qr_corner_color, qr_style: el.qr_style, qr_eye_style: el.qr_eye_style,
//         };
//         const r = await request("id-card-elements", "POST", data);
//         if (r?.data?.id && el.is_new) {
//           setElements(prev => prev.map(e => e.tempId === el.tempId ? { ...e, id: r.data.id, is_new: false } : e));
//         }
//       }
//       message.success("💾 Saved!");
//       // ✅ Reload template to get fresh data with proper previews
//       await loadTemplate(currentTemplate.id);
//     } catch (e) { console.error(e); message.error("Save failed"); }
//     finally { setLoadingSpin(false); }
//   };

//   const previewIDCard = async () => {
//     setLoadingSpin(true);
//     try {
//       const res = await request(`id-card-preview?username=${getProfile.username}&org_code=${getProfile.org_code}`, "get", {});
//       if (res?.success) { setPreviewStaff(res.data.staff); setShowPreview(true); }
//     } catch (e) { console.error(e); }
//     finally { setLoadingSpin(false); }
//   };

//   const handleTemplateSave = async () => {
//     try {
//       const v = await templateForm.validateFields();
//       setLoadingSpin(true);
//       const data = { ...v, org_code: getProfile.org_code, usercreate: getProfile.fullname, width: cardSize.width, height: cardSize.height, orientation, background_type: backgroundType, background_color: bgColor, gradient_type: gradientType, gradient_color1: gradientColor1, gradient_color2: gradientColor2, gradient_direction: gradientDirection, border_radius: borderRadius, shadow_enabled: shadowEnabled, shadow_color: shadowColor, overlay_enabled: overlayEnabled, chip_enabled: chipEnabled, chip_color: chipColor };
//       const res = editingTemplate ? await request(`id-card-templates/${editingTemplate.id}`, "PUT", data) : await request("id-card-templates", "POST", data);
//       if (res?.isOk || res?.success) { message.success(editingTemplate ? "✅ Updated!" : "✨ Created!"); setShowTemplateModal(false); templateForm.resetFields(); loadTemplates(); }
//     } catch (e) { console.error(e); }
//     finally { setLoadingSpin(false); }
//   };

//   const applyGradientPreset = (p) => {
//     if (p.type === 'none') { setBackgroundType('none'); return; }
//     setBackgroundType('gradient'); setGradientColor1(p.color1); setGradientColor2(p.color2); setGradientDirection(p.direction); setGradientType(p.type);
//   };

//   const updateShapeProps = (props) => {
//     if (!selectedElement) return;
//     updateElementProps(selectedElement.id || selectedElement.tempId, props);
//   };

//   const updateQRProps = (props) => {
//     if (!selectedElement) return;
//     updateElementProps(selectedElement.id || selectedElement.tempId, props);
//   };

//   // ==================== RENDER ====================
//   const renderIDCard = () => (
//     <div ref={canvasRef} style={{
//       width: cardSize.width, height: cardSize.height, ...getBackgroundStyle(),
//       borderRadius: borderRadius, boxShadow: getCardShadow(),
//       position: 'relative', overflow: 'hidden',
//       border: backgroundType === 'none' ? '2px dashed #d9d9d9' : '1px solid rgba(255,255,255,0.2)',
//       cursor: isDragging ? 'grabbing' : 'default', userSelect: 'none',
//     }}>
//       {backgroundType !== 'none' && (
//         <>
//           <div style={{ position: 'absolute', top: -60, right: -60, width: 220, height: 220, borderRadius: '50%', background: 'rgba(255,255,255,0.03)', pointerEvents: 'none' }} />
//           <div style={{ position: 'absolute', bottom: -90, left: -40, width: 280, height: 280, borderRadius: '50%', background: 'rgba(255,255,255,0.03)', pointerEvents: 'none' }} />
//         </>
//       )}
//       {chipEnabled && (
//         <div style={{ position: 'absolute', top: 20, left: 20, width: 45, height: 32, borderRadius: 6, background: `linear-gradient(135deg, ${chipColor}, ${chipColor}cc)`, boxShadow: '0 2px 8px rgba(0,0,0,0.2)', zIndex: 2, pointerEvents: 'none' }}>
//           <div style={{ width: '100%', height: '100%', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
//             <div style={{ width: 22, height: 16, borderRadius: 3, background: 'rgba(255,255,255,0.3)', border: '1px solid rgba(255,255,255,0.5)' }} />
//           </div>
//         </div>
//       )}
//       {backgroundType === 'none' && (
//         <div style={{ position: 'absolute', top: '50%', left: '50%', transform: 'translate(-50%,-50%)', color: '#d9d9d9', textAlign: 'center', pointerEvents: 'none' }}>
//           <PictureOutlined style={{ fontSize: 48, display: 'block', marginBottom: 8 }} />
//           {cardSize.width} × {cardSize.height}
//         </div>
//       )}
//       {elements.filter(el => el.is_visible !== 0)
//         .sort((a, b) => (a.z_index || 2) - (b.z_index || 2))
//         .map((el, i) => {
//         const eid = el.id || el.tempId;
//         const sel = selectedElement && (selectedElement.id || selectedElement.tempId) === eid;
//         const customPhoto = el.element_key === 'custom_photo' ? getCustomPhotoByIndex(el.custom_photo_index) : null;
        
//         return (
//           <div key={eid} onMouseDown={(e) => handleMouseDown(e, el)} style={{
//             position: 'absolute', left: el.x_position || 0, top: el.y_position || 0,
//             width: el.width || 100, height: el.height || 30,
//             display: 'flex', alignItems: 'center',
//             justifyContent: el.text_align === 'center' ? 'center' : el.text_align === 'right' ? 'flex-end' : 'flex-start',
//             fontSize: el.font_size || 12, color: el.font_color || '#FFF',
//             fontWeight: el.font_weight || 'normal', fontFamily: el.font_family || 'Content',
//             zIndex: sel ? 1000 : (el.z_index || 2), overflow: 'hidden', cursor: 'move',
//             border: sel ? '2px solid #1890ff' : (el.element_type === 'shape' ? 'none' : '1px dashed rgba(255,255,255,0.3)'),
//             background: el.element_type === 'shape' ? 'transparent' : (sel ? 'rgba(24,144,255,0.15)' : 'rgba(255,255,255,0.05)'),
//             borderRadius: el.element_type === 'shape' ? 0 : 4, padding: el.element_type === 'shape' ? 0 : 2,
//           }}>
//             {el.element_type === 'shape' ? (
//               <div style={getShapeStyle(el)}>
//                 {el.label && el.label !== 'Shape' && (
//                   <div style={{ position: 'absolute', top: '50%', left: '50%', transform: 'translate(-50%, -50%)', color: '#fff', fontSize: el.font_size || 12, fontWeight: el.font_weight || 'bold', textAlign: 'center', width: '100%', padding: '4px', textShadow: '0 1px 3px rgba(0,0,0,0.3)' }}>{el.label}</div>
//                 )}
//               </div>
//             ) : el.element_type === 'qrcode' ? (
//               <div style={{ width: '100%', height: '100%', display: 'flex', alignItems: 'center', justifyContent: 'center', background: el.qr_bg_color || '#FFFFFF', borderRadius: 4, padding: 4 }}>
//                 <img src={generateQRCode(el.label || 'QR', Math.min(el.width, el.height), el.qr_fg_color || '#000000', el.qr_bg_color || '#FFFFFF')} alt="QR" style={{ width: '100%', height: '100%', objectFit: 'contain', borderRadius: el.qr_style === 'rounded' ? '8px' : '0' }} />
//               </div>
//             ) : el.element_type === 'image' ? (
//               <div style={{ width: '100%', height: '100%', borderRadius: el.element_key === 'photo' ? 6 : 0, border: el.element_key === 'photo' ? '1px solid rgba(255,255,255,0.3)' : 'none', overflow: 'hidden', display: 'flex', alignItems: 'center', justifyContent: 'center', background: 'rgba(255,255,255,0.1)', color: 'rgba(255,255,255,0.6)', fontSize: 11 }}>
//                 {el.element_key === 'signature' ? (
//                   signaturePreview ? <img src={signaturePreview} alt="Sig" style={{ width: '100%', height: '100%', objectFit: 'contain' }} /> : <EditOutlined style={{ fontSize: 20 }} />
//                 ) : el.element_key === 'org_logo' ? (
//                   logoPreview ? <img src={logoPreview} alt="Logo" style={{ width: '100%', height: '100%', objectFit: 'contain' }} /> : <BankOutlined style={{ fontSize: 20 }} />
//                 ) : el.element_key === 'photo' ? (
//                   <CameraOutlined style={{ fontSize: 20 }} />
//                 ) : el.element_key === 'custom_photo' ? (
//                   customPhoto?.preview ? <img src={customPhoto.preview} alt="Custom" style={{ width: '100%', height: '100%', objectFit: 'cover' }} /> : <PictureOutlined style={{ fontSize: 20 }} />
//                 ) : <PictureOutlined style={{ fontSize: 20 }} />}
//               </div>
//             ) : (
//               <span style={{ width: '100%', textAlign: el.text_align || 'left', fontFamily: el.font_family || 'Content, sans-serif' }}>
//                 {el.element_type === 'custom-text' ? (el.custom_text || 'Custom Text') : el.label}
//               </span>
//             )}
//             {sel && <div style={{ position: 'absolute', top: -10, right: -10, width: 20, height: 20, borderRadius: '50%', background: '#ff4d4f', color: 'white', display: 'flex', alignItems: 'center', justifyContent: 'center', cursor: 'pointer', fontSize: 12, zIndex: 1001 }} onClick={(e) => { e.stopPropagation(); deleteElement(eid); }}>×</div>}
//           </div>
//         );
//       })}
//     </div>
//   );

//   const elementGroups = [
//     { title: '👤 Personal', items: [
//       { type: 'text', key: 'fullname', label: 'Full Name', icon: <UserOutlined /> },
//       { type: 'text', key: 'frontname', label: 'Title', icon: <StarOutlined /> },
//       { type: 'text', key: 'staffname_eng', label: 'Name ENG', icon: <GlobalOutlined /> },
//       { type: 'text', key: 'idnumber', label: 'ID Number', icon: <IdcardOutlined /> },
//       { type: 'text', key: 'gender', label: 'Gender', icon: <UserOutlined /> },
//       { type: 'text', key: 'dob', label: 'DOB', icon: <IdcardOutlined /> },
//     ]},
//     { title: '💼 Work', items: [
//       { type: 'text', key: 'position_name', label: 'Position', icon: <CrownOutlined /> },
//       { type: 'text', key: 'department_name', label: 'Department', icon: <TeamOutlined /> },
//       { type: 'text', key: 'skill_name', label: 'Skill', icon: <ThunderboltOutlined /> },
//       { type: 'text', key: 'jobstatus', label: 'Job Status', icon: <CheckCircleOutlined /> },
//       { type: 'text', key: 'stafftype', label: 'Staff Type', icon: <IdcardOutlined /> },
//       { type: 'text', key: 'level', label: 'Level', icon: <StarOutlined /> },
//       { type: 'text', key: 'joinwork', label: 'Join Date', icon: <IdcardOutlined /> },
//     ]},
//     { title: '📱 Contact', items: [
//       { type: 'text', key: 'username', label: 'Phone', icon: <PhoneOutlined /> },
//     ]},
//     { title: '🖼️ Media', items: [
//       { type: 'image', key: 'photo', label: 'Staff Photo', icon: <CameraOutlined /> },
//       { type: 'image', key: 'org_logo', label: 'Org Logo', icon: <BankOutlined /> },
//       { type: 'image', key: 'signature', label: 'Signature', icon: <EditOutlined /> },
//       { type: 'text', key: 'org_name', label: 'Org Name', icon: <GlobalOutlined /> },
//     ]},
//     { title: '📸 Custom Photos', items: [] },
//     { title: '✏️ Custom', items: [
//       { type: 'custom-text', key: 'custom_text', label: 'Custom Text', icon: <FontSizeOutlined /> },
//     ]},
//     { title: '🎨 Shapes', items: [
//       { type: 'shape', key: null, label: 'Shape', icon: <HighlightOutlined /> },
//     ]},
//     { title: '🔢 Extra', items: [
//       { type: 'qrcode', key: 'qrcode_id', label: 'QR Code', icon: <QrcodeOutlined /> },
//       { type: 'text', key: 'role_name', label: 'Role', icon: <TeamOutlined /> },
//     ]},
//   ];

//   const customPhotoItems = customPhotos.map((photo, index) => ({
//     type: 'image',
//     key: 'custom_photo',
//     label: `Custom Photo ${index + 1}`,
//     icon: <PictureOutlined />,
//     photoIndex: index,
//   }));

//   return (
//     <div className="id-card-designer" style={{ padding: 24, background: '#f0f2f5', minHeight: '100vh' }}>
//       {loadingSpin && <div className="sprinSave"><GetLoading /></div>}
      
//       {/* Header */}
//       <div style={{ background: 'linear-gradient(135deg, #667eea, #764ba2)', borderRadius: 16, padding: '24px 32px', marginBottom: 24, color: 'white', boxShadow: '0 10px 40px rgba(102,126,234,0.4)' }}>
//         <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', flexWrap: 'wrap', gap: 16 }}>
//           <div>
//             <h1 style={{ color: 'white', margin: 0, fontSize: 28, fontWeight: 700 }}><IdcardOutlined style={{ marginRight: 12 }} />ID Card Designer</h1>
//             <p style={{ color: 'rgba(255,255,255,0.8)', margin: '8px 0 0', fontSize: 14 }}>Click & drag elements to position them</p>
//           </div>
//           <Space>
//              <Button icon={<SaveOutlined />} onClick={saveElements} loading={loadingSpin} size="large" style={{ background: 'white', color: '#667eea', border: 'none' }}>Save Design</Button>
//           </Space>
//         </div>
//       </div>

//       <div style={{ display: 'grid', gridTemplateColumns: '260px 1fr 350px', gap: 24 }}>
//         {/* Left - Elements */}
//         <Card title="📦 Elements" style={{ borderRadius: 16, boxShadow: '0 4px 20px rgba(0,0,0,0.08)', position: 'sticky', top: 24 }}>
//           <Segmented block value={orientation} onChange={handleOrientationChange} options={[{ label: '🏞️ Landscape', value: 'landscape' }, { label: '📱 Portrait', value: 'portrait' }]} style={{ marginBottom: 16 }} />
//           <Divider />
//           {elementGroups.map(g => (
//             <div key={g.title} style={{ marginBottom: 20 }}>
//               <h4 style={{ color: '#666', fontSize: 12, textTransform: 'uppercase', marginBottom: 8 }}>{g.title}</h4>
//               <Space direction="vertical" style={{ width: '100%' }}>
//                 {g.title === '📸 Custom Photos' ? (
//                   customPhotoItems.length > 0 ? customPhotoItems.map((item, i) => (
//                     <Button key={i} block icon={item.icon} onClick={() => addElement(item.type, item.key, item.label, { photoIndex: item.photoIndex })} style={{ textAlign: 'left', borderRadius: 10, height: 40 }}>{item.label}</Button>
//                   )) : (
//                     <div style={{ color: '#999', fontSize: 11, padding: '8px', textAlign: 'center' }}>Upload photos in Images tab</div>
//                   )
//                 ) : (
//                   g.items.map(item => (
//                     <Button key={item.key || item.label} block icon={item.icon} onClick={() => addElement(item.type, item.key, item.label)} style={{ textAlign: 'left', borderRadius: 10, height: 40 }}>{item.label}</Button>
//                   ))
//                 )}
//               </Space>
//             </div>
//           ))}
//         </Card>

//         {/* Center - Canvas */}
//         <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', gap: 16 }}>
//           <Card style={{ width: '100%', borderRadius: 16, boxShadow: '0 4px 20px rgba(0,0,0,0.08)' }}>
//             <Space style={{ width: '100%', justifyContent: 'space-between' }}>
//               <Select style={{ width: 250 }} placeholder="Select template" value={currentTemplate?.id} onChange={loadTemplate} size="large">
//                 {templates.map(t => <Option key={t.id} value={t.id}>{t.is_default === 1 && ''}{t.template_name}</Option>)}
//               </Select>
//               <Space>
//                 <Button icon={<PlusOutlined />} onClick={() => { setEditingTemplate(null); templateForm.resetFields(); setShowTemplateModal(true); }}>New</Button>
//                 <Button icon={<SettingOutlined />} onClick={() => { setEditingTemplate(currentTemplate); templateForm.setFieldsValue(currentTemplate); setShowTemplateModal(true); }} disabled={!currentTemplate}>Settings</Button>
//               </Space>
//             </Space>
//           </Card>
//           <div style={{ background: '#e8e8e8', borderRadius: 16, padding: 40, boxShadow: 'inset 0 2px 10px rgba(0,0,0,0.1)', overflow: 'auto', maxHeight: 'calc(100vh - 300px)', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
//             <div style={{ transform: `scale(${zoomLevel})`, transformOrigin: 'center center', transition: 'transform 0.2s' }}>{renderIDCard()}</div>
//           </div>
//           <Card size="small" style={{ borderRadius: 12 }}>
//             <Space><span>🔍</span><Slider min={0.5} max={1.5} step={0.1} value={zoomLevel} onChange={setZoomLevel} style={{ width: 150 }} /><span>{Math.round(zoomLevel * 100)}%</span></Space>
//           </Card>
//         </div>

//         {/* Right - Settings */}
//         <div style={{ maxHeight: 'calc(100vh - 150px)', overflowY: 'auto' }}>
//           {/* Background */}
//           <Card title="🎨 Background" style={{ borderRadius: 16, boxShadow: '0 4px 20px rgba(0,0,0,0.08)', marginBottom: 16 }}>
//             <Radio.Group value={backgroundType} onChange={(e) => setBackgroundType(e.target.value)} style={{ marginBottom: 16, width: '100%' }} size="small">
//               <Radio.Button value="none" style={{ width: '25%', textAlign: 'center' }}>None</Radio.Button>
//               <Radio.Button value="color" style={{ width: '25%', textAlign: 'center' }}>Color</Radio.Button>
//               <Radio.Button value="gradient" style={{ width: '25%', textAlign: 'center' }}>Gradient</Radio.Button>
//               <Radio.Button value="image" style={{ width: '25%', textAlign: 'center' }}>Image</Radio.Button>
//             </Radio.Group>
//             {backgroundType === 'color' && <div style={{ marginBottom: 12 }}><label style={{ fontSize: 12, color: '#666' }}>Color</label><ColorPicker value={bgColor} onChange={(c) => setBgColor(c.toHexString())} style={{ width: '100%' }} /></div>}
//             {backgroundType === 'gradient' && (
//               <div>
//                 <div style={{ marginBottom: 12 }}><label style={{ fontSize: 12, color: '#666' }}>Presets</label><div style={{ display: 'grid', gridTemplateColumns: 'repeat(4, 1fr)', gap: 6 }}>{GRADIENT_PRESETS.filter(p => p.type !== 'none').map((p, i) => (<Tooltip key={i} title={p.name}><div onClick={() => applyGradientPreset(p)} style={{ height: 30, borderRadius: 6, cursor: 'pointer', background: `linear-gradient(${p.direction}, ${p.color1}, ${p.color2})`, border: gradientColor1 === p.color1 ? '2px solid #1890ff' : '2px solid transparent' }} /></Tooltip>))}</div></div>
//                 <Select value={gradientType} onChange={setGradientType} style={{ width: '100%', marginBottom: 8 }} size="small"><Option value="linear">Linear</Option><Option value="radial">Radial</Option></Select>
//                 <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: 8, marginBottom: 8 }}><ColorPicker value={gradientColor1} onChange={(c) => setGradientColor1(c.toHexString())} /><ColorPicker value={gradientColor2} onChange={(c) => setGradientColor2(c.toHexString())} /></div>
//                 <Select value={gradientDirection} onChange={setGradientDirection} style={{ width: '100%' }} size="small">{['0deg','45deg','90deg','135deg','180deg','225deg','270deg','315deg'].map(d => <Option key={d} value={d}>{d}</Option>)}</Select>
//               </div>
//             )}
//             {backgroundType === 'image' && (
//               <div>
//                 <label style={{ fontSize: 12, color: '#666' }}>Image</label>
//                 {bgImagePreview ? (<div style={{ position: 'relative', marginBottom: 8 }}><img src={bgImagePreview} alt="BG" style={{ width: '100%', height: 120, objectFit: 'cover', borderRadius: 8 }} /><Button icon={<DeleteIcon />} size="small" danger onClick={handleRemoveBgImage} style={{ position: 'absolute', top: 8, right: 8 }} /></div>) : (<Upload beforeUpload={handleBgImageUpload} showUploadList={false} accept="image/*"><Button icon={<UploadOutlined />} block style={{ borderRadius: 8, height: 80 }}>Upload Background</Button></Upload>)}
//                 <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: 8, marginTop: 8 }}><Select value={bgImageSize} onChange={setBgImageSize} size="small"><Option value="cover">Cover</Option><Option value="contain">Contain</Option><Option value="stretch">Stretch</Option></Select><Select value={bgImagePosition} onChange={setBgImagePosition} size="small"><Option value="center">Center</Option><Option value="top">Top</Option><Option value="bottom">Bottom</Option></Select></div>
//                 <div style={{ marginTop: 8 }}><label style={{ fontSize: 12, color: '#666' }}>Opacity: {bgImageOpacity}</label><Slider min={0.1} max={1} step={0.1} value={bgImageOpacity} onChange={setBgImageOpacity} /></div>
//               </div>
//             )}
//           </Card>

//           {/* Card Style */}
//           <Card title="✨ Card Style" style={{ borderRadius: 16, boxShadow: '0 4px 20px rgba(0,0,0,0.08)', marginBottom: 16 }}>
//             <Space direction="vertical" style={{ width: '100%' }} size="small">
//               <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}><span style={{ fontSize: 12 }}>Border Radius</span><InputNumber size="small" min={0} max={50} value={borderRadius} onChange={setBorderRadius} style={{ width: 80 }} addonAfter="px" /></div>
//               <Divider style={{ margin: '8px 0' }} />
//               <div style={{ display: 'flex', justifyContent: 'space-between' }}><span style={{ fontSize: 12, fontWeight: 'bold' }}>Shadow</span><Switch size="small" checked={shadowEnabled} onChange={setShadowEnabled} /></div>
//               {shadowEnabled && (<><div style={{ display: 'flex', justifyContent: 'space-between' }}><span style={{ fontSize: 11 }}>Color</span><ColorPicker value={shadowColor} onChange={(c) => setShadowColor(c.toHexString())} size="small" /></div><div style={{ display: 'flex', justifyContent: 'space-between' }}><span style={{ fontSize: 11 }}>Blur</span><InputNumber size="small" min={0} max={100} value={shadowBlur} onChange={setShadowBlur} style={{ width: 80 }} /></div><div style={{ display: 'flex', justifyContent: 'space-between' }}><span style={{ fontSize: 11 }}>Spread</span><InputNumber size="small" min={-50} max={50} value={shadowSpread} onChange={setShadowSpread} style={{ width: 80 }} /></div><div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: 8 }}><div style={{ display: 'flex', justifyContent: 'space-between' }}><span style={{ fontSize: 11 }}>X</span><InputNumber size="small" min={-50} max={50} value={shadowX} onChange={setShadowX} style={{ width: 70 }} /></div><div style={{ display: 'flex', justifyContent: 'space-between' }}><span style={{ fontSize: 11 }}>Y</span><InputNumber size="small" min={-50} max={50} value={shadowY} onChange={setShadowY} style={{ width: 70 }} /></div></div></>)}
//               <Divider style={{ margin: '8px 0' }} />
//               <div style={{ display: 'flex', justifyContent: 'space-between' }}><span style={{ fontSize: 12 }}>Overlay</span><Select size="small" value={overlayPattern} onChange={setOverlayPattern} style={{ width: 100 }}>{PATTERNS.map(p => <Option key={p.value} value={p.value}>{p.name}</Option>)}</Select></div>
//               {overlayPattern !== 'none' && <div style={{ display: 'flex', justifyContent: 'space-between' }}><span style={{ fontSize: 12 }}>Opacity</span><InputNumber size="small" min={0} max={1} step={0.1} value={overlayOpacity} onChange={setOverlayOpacity} style={{ width: 80 }} /></div>}
//               <div style={{ display: 'flex', justifyContent: 'space-between' }}><span style={{ fontSize: 12 }}>Gold Chip</span><Space size="small"><Switch size="small" checked={chipEnabled} onChange={setChipEnabled} />{chipEnabled && <ColorPicker value={chipColor} onChange={(c) => setChipColor(c.toHexString())} size="small" />}</Space></div>
//             </Space>
//           </Card>

//           {/* Images Section */}
//           <Card title={<Space><FolderOpenOutlined /> Images</Space>} style={{ borderRadius: 16, boxShadow: '0 4px 20px rgba(0,0,0,0.08)', marginBottom: 16 }}>
//             <Tabs size="small" items={[
//               {
//                 key: 'signature', label: '✍️ Signature', children: (
//                   <div>
//                     {signaturePreview ? (<div style={{ position: 'relative', marginBottom: 12 }}><img src={signaturePreview} alt="Sig" style={{ width: '100%', height: 70, objectFit: 'contain', borderRadius: 8, background: '#f5f5f5', padding: 8 }} /><Button icon={<DeleteIcon />} size="small" danger onClick={handleRemoveSignature} style={{ position: 'absolute', top: 4, right: 4 }} /></div>) : (<Upload beforeUpload={handleSignatureUpload} showUploadList={false} accept="image/*"><Button icon={<UploadOutlined />} block style={{ borderRadius: 8, height: 50 }}>Upload Signature</Button></Upload>)}
//                     <Divider style={{ margin: '8px 0' }} />
//                     <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
//                       <span style={{ fontSize: 11, color: '#666' }}>Size:</span>
//                       <Space size="small">
//                         <InputNumber size="small" min={20} max={cardSize.width} value={signatureSize.width} onChange={(v) => handleSignatureSizeChange({...signatureSize, width: v})} style={{ width: 120 }} addonAfter="W" />
//                         <InputNumber size="small" min={20} max={cardSize.height} value={signatureSize.height} onChange={(v) => handleSignatureSizeChange({...signatureSize, height: v})} style={{ width: 120 }} addonAfter="H" />
//                         </Space></div>
//                   </div>
//                 )
//               },
//               {
//                 key: 'logo', label: '🏢 Logo', children: (
//                   <div>
//                     {logoPreview ? (<div style={{ position: 'relative', marginBottom: 12 }}><img src={logoPreview} alt="Logo" style={{ width: '100%', height: 70, objectFit: 'contain', borderRadius: 8, background: '#f5f5f5', padding: 8 }} /><Button icon={<DeleteIcon />} size="small" danger onClick={handleRemoveLogo} style={{ position: 'absolute', top: 4, right: 4 }} /></div>) : (<Upload beforeUpload={handleLogoUpload} showUploadList={false} accept="image/*"><Button icon={<UploadOutlined />} block style={{ borderRadius: 8, height: 50 }}>Upload Logo</Button></Upload>)}
//                     <Divider style={{ margin: '8px 0' }} />
//                     <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
//                       <span style={{ fontSize: 11, color: '#666' }}>Size:</span>
                       
//                       <InputNumber style={{ width: 120 }} size="small" min={20} max={cardSize.width} value={logoSize.width} onChange={(v) => handleLogoSizeChange({...logoSize, width: v})} addonAfter="W" />
//                       <InputNumber style={{ width: 120 }} size="small" min={20} max={cardSize.height} value={logoSize.height} onChange={(v) => handleLogoSizeChange({...logoSize, height: v})} addonAfter="H" />
                      
//                       </div>
//                   </div>
//                 )
//               },
//               {
//                 key: 'custom_photos', label: `🖼️ Photos (${customPhotos.length})`, children: (
//                   <div>
//                     <Upload beforeUpload={handleCustomPhotoUpload} showUploadList={false} accept="image/*" multiple><Button icon={<UploadOutlined />} block style={{ borderRadius: 8, height: 40, marginBottom: 12 }}>Add Photo</Button></Upload>
//                     {customPhotos.map((photo, index) => (
//                       <div key={photo.tempId || photo.id || index} style={{ position: 'relative', marginBottom: 12, padding: 8, background: '#fafafa', borderRadius: 8, border: '1px solid #f0f0f0' }}>
//                         <div style={{ display: 'flex', gap: 8, alignItems: 'center' }}>
//                           <img src={photo.preview} alt={`Custom ${index + 1}`} style={{ width: 50, height: 50, objectFit: 'cover', borderRadius: 6 }} />
//                           <div style={{ flex: 1 }}>
//                             <div style={{ fontSize: 11, fontWeight: 'bold', marginBottom: 4 }}>Photo {index + 1}</div>
                            
//                               <InputNumber size="small" style={{ width: 120 }} min={20} max={cardSize.width} value={photo.size.width} onChange={(v) => handleCustomPhotoSizeChange(index, {...photo.size, width: v})} addonAfter="W" />
//                               <InputNumber size="small" style={{ width: 120 }} min={20} max={cardSize.height} value={photo.size.height} onChange={(v) => handleCustomPhotoSizeChange(index, {...photo.size, height: v})} addonAfter="H" />
                           
//                           </div>
//                           <Button icon={<DeleteIcon />} size="small" danger onClick={() => handleRemoveCustomPhoto(index)} />
//                         </div>
//                       </div>
//                     ))}
//                   </div>
//                 )
//               },
//             ]} />
//           </Card>

//           {/* Layer Management */}
//           {selectedElement && (
//             <Card title={<Space><VerticalAlignTopOutlined /> Layer Order</Space>} style={{ borderRadius: 16, boxShadow: '0 4px 20px rgba(0,0,0,0.08)', marginBottom: 16 }} size="small">
//               <div style={{ background: '#f5f5f5', padding: '12px', borderRadius: '8px', marginBottom: '12px' }}><div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}><span style={{ fontSize: '12px', color: '#666' }}>Current Layer:</span><Tag color="blue" style={{ fontSize: '12px' }}>Z-Index: {selectedElement.z_index || 2}</Tag></div></div>
//               <Space direction="vertical" style={{ width: '100%' }} size="small">
//                 <Button block icon={<VerticalAlignTopOutlined />} onClick={() => bringToFront(selectedElement.id || selectedElement.tempId)} style={{ background: 'linear-gradient(135deg, #667eea, #764ba2)', color: 'white', border: 'none', borderRadius: '8px' }}>Bring to Front</Button>
//                 <Button block icon={<ArrowUpOutlined />} onClick={() => bringForward(selectedElement.id || selectedElement.tempId)} style={{ borderRadius: '8px' }}>Bring Forward</Button>
//                 <Button block icon={<ArrowDownOutlined />} onClick={() => sendBackward(selectedElement.id || selectedElement.tempId)} style={{ borderRadius: '8px' }}>Send Backward</Button>
//                 <Button block icon={<VerticalAlignBottomOutlined />} onClick={() => sendToBack(selectedElement.id || selectedElement.tempId)} style={{ background: 'linear-gradient(135deg, #ff4d4f, #ff7875)', color: 'white', border: 'none', borderRadius: '8px' }}>Send to Back</Button>
//               </Space>
//               <Divider style={{ margin: '12px 0' }} />
//               <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}><span style={{ fontSize: '12px', color: '#666' }}>Manual Z-Index:</span><InputNumber size="small" min={1} max={999} value={selectedElement.z_index || 2} onChange={(v) => updateElementProps(selectedElement.id || selectedElement.tempId, { z_index: v })} style={{ width: '80px' }} /></div>
//             </Card>
//           )}

//           {/* Shape Properties */}
//           {selectedElement && selectedElement.element_type === 'shape' && (
//             <Card title={<Space><HighlightOutlined /> Shape Properties</Space>} extra={<Space size="small"><Tooltip title="Front"><Button type="text" size="small" icon={<VerticalAlignTopOutlined />} onClick={() => bringToFront(selectedElement.id || selectedElement.tempId)} /></Tooltip><Tooltip title="Back"><Button type="text" size="small" icon={<VerticalAlignBottomOutlined />} onClick={() => sendToBack(selectedElement.id || selectedElement.tempId)} /></Tooltip><Button type="text" danger icon={<DeleteOutlined />} size="small" onClick={() => deleteElement(selectedElement.id || selectedElement.tempId)} /></Space>} style={{ borderRadius: 16, boxShadow: '0 4px 20px rgba(0,0,0,0.08)', marginBottom: 16 }}>
//               <Space direction="vertical" style={{ width: '100%' }} size="small">
//                 <div><label style={{ fontSize: 12, color: '#666' }}>Shape Type</label><Select value={selectedElement.shape_type} onChange={(v) => updateShapeProps({ shape_type: v })} style={{ width: '100%' }} size="small">{SHAPE_TYPES.map(s => <Option key={s.value} value={s.value}>{s.name}</Option>)}</Select></div>
//                 <Divider style={{ margin: '8px 0' }} />
//                 <div><label style={{ fontSize: 12, color: '#666' }}>Fill Type</label><Radio.Group value={selectedElement.shape_fill_type} onChange={(e) => updateShapeProps({ shape_fill_type: e.target.value })} size="small" style={{ width: '100%' }}><Radio.Button value="solid" style={{ width: '50%', textAlign: 'center' }}>Solid</Radio.Button><Radio.Button value="gradient" style={{ width: '50%', textAlign: 'center' }}>Gradient</Radio.Button></Radio.Group></div>
//                 {selectedElement.shape_fill_type === 'solid' ? (<div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}><span style={{ fontSize: 12 }}>Color</span><ColorPicker value={selectedElement.shape_fill_color} onChange={(c) => updateShapeProps({ shape_fill_color: c.toHexString() })} size="small" /></div>) : (<><div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: 8 }}><ColorPicker value={selectedElement.shape_gradient_color1} onChange={(c) => updateShapeProps({ shape_gradient_color1: c.toHexString() })} /><ColorPicker value={selectedElement.shape_gradient_color2} onChange={(c) => updateShapeProps({ shape_gradient_color2: c.toHexString() })} /></div><Select value={selectedElement.shape_gradient_direction} onChange={(v) => updateShapeProps({ shape_gradient_direction: v })} size="small">{['0deg','45deg','90deg','135deg','180deg','225deg','270deg','315deg'].map(d => <Option key={d} value={d}>{d}</Option>)}</Select></>)}
//                 <Divider style={{ margin: '8px 0' }} />
//                 <div style={{ display: 'flex', justifyContent: 'space-between' }}><span style={{ fontSize: 12 }}>Opacity</span><InputNumber size="small" min={0} max={1} step={0.1} value={selectedElement.shape_opacity} onChange={(v) => updateShapeProps({ shape_opacity: v })} style={{ width: 80 }} /></div>
//                 {selectedElement.shape_type !== 'circle' && <div style={{ display: 'flex', justifyContent: 'space-between' }}><span style={{ fontSize: 12 }}>Border Radius</span><InputNumber size="small" min={0} max={50} value={selectedElement.shape_border_radius} onChange={(v) => updateShapeProps({ shape_border_radius: v })} style={{ width: 80 }} addonAfter="px" /></div>}
//                 <Divider style={{ margin: '8px 0' }} />
//                 <div style={{ display: 'flex', justifyContent: 'space-between' }}><span style={{ fontSize: 12, fontWeight: 'bold' }}>Shadow</span><Switch size="small" checked={selectedElement.shape_shadow_enabled} onChange={(v) => updateShapeProps({ shape_shadow_enabled: v })} /></div>
//                 {selectedElement.shape_shadow_enabled && (<><div style={{ display: 'flex', justifyContent: 'space-between' }}><span style={{ fontSize: 11 }}>Color</span><ColorPicker value={selectedElement.shape_shadow_color} onChange={(c) => updateShapeProps({ shape_shadow_color: c.toHexString() })} size="small" /></div><div style={{ display: 'flex', justifyContent: 'space-between' }}><span style={{ fontSize: 11 }}>Blur</span><InputNumber size="small" min={0} max={100} value={selectedElement.shape_shadow_blur} onChange={(v) => updateShapeProps({ shape_shadow_blur: v })} style={{ width: 80 }} /></div></>)}
//                 <Divider style={{ margin: '8px 0' }} />
//                 <div style={{ display: 'flex', justifyContent: 'space-between' }}><span style={{ fontSize: 12, fontWeight: 'bold' }}>Border</span><Switch size="small" checked={selectedElement.shape_border_enabled} onChange={(v) => updateShapeProps({ shape_border_enabled: v })} /></div>
//                 {selectedElement.shape_border_enabled && (<><div style={{ display: 'flex', justifyContent: 'space-between' }}><span style={{ fontSize: 11 }}>Color</span><ColorPicker value={selectedElement.shape_border_color} onChange={(c) => updateShapeProps({ shape_border_color: c.toHexString() })} size="small" /></div><div style={{ display: 'flex', justifyContent: 'space-between' }}><span style={{ fontSize: 11 }}>Width</span><InputNumber size="small" min={1} max={10} value={selectedElement.shape_border_width} onChange={(v) => updateShapeProps({ shape_border_width: v })} style={{ width: 80 }} addonAfter="px" /></div></>)}
//                 <Divider style={{ margin: '8px 0' }} />
//                 <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: 8 }}><div><label style={{ fontSize: 11 }}>W</label><InputNumber size="small" min={10} max={cardSize.width} value={selectedElement.width} onChange={(v) => updateElementProps(selectedElement.id || selectedElement.tempId, { width: v })} style={{ width: '100%' }} /></div><div><label style={{ fontSize: 11 }}>H</label><InputNumber size="small" min={10} max={cardSize.height} value={selectedElement.height} onChange={(v) => updateElementProps(selectedElement.id || selectedElement.tempId, { height: v })} style={{ width: '100%' }} /></div></div>
//                 <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: 8 }}><div><label style={{ fontSize: 11 }}>X</label><InputNumber size="small" min={0} max={cardSize.width} value={selectedElement.x_position} onChange={(v) => updateElementProps(selectedElement.id || selectedElement.tempId, { x_position: v })} style={{ width: '100%' }} /></div><div><label style={{ fontSize: 11 }}>Y</label><InputNumber size="small" min={0} max={cardSize.height} value={selectedElement.y_position} onChange={(v) => updateElementProps(selectedElement.id || selectedElement.tempId, { y_position: v })} style={{ width: '100%' }} /></div></div>
//               </Space>
//             </Card>
//           )}

//           {/* QR Code Properties */}
//           {selectedElement && selectedElement.element_type === 'qrcode' && (
//             <Card title={<Space><QrcodeOutlined /> QR Code Style</Space>} extra={<Space size="small"><Tooltip title="Front"><Button type="text" size="small" icon={<VerticalAlignTopOutlined />} onClick={() => bringToFront(selectedElement.id || selectedElement.tempId)} /></Tooltip><Tooltip title="Back"><Button type="text" size="small" icon={<VerticalAlignBottomOutlined />} onClick={() => sendToBack(selectedElement.id || selectedElement.tempId)} /></Tooltip><Button type="text" danger icon={<DeleteOutlined />} size="small" onClick={() => deleteElement(selectedElement.id || selectedElement.tempId)} /></Space>} style={{ borderRadius: 16, boxShadow: '0 4px 20px rgba(0,0,0,0.08)', marginBottom: 16 }}>
//               <Space direction="vertical" style={{ width: '100%' }} size="small">
//                 <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}><span style={{ fontSize: 12 }}>Background</span><ColorPicker value={selectedElement.qr_bg_color} onChange={(c) => updateQRProps({ qr_bg_color: c.toHexString() })} size="small" /></div>
//                 <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}><span style={{ fontSize: 12 }}>Foreground</span><ColorPicker value={selectedElement.qr_fg_color} onChange={(c) => updateQRProps({ qr_fg_color: c.toHexString() })} size="small" /></div>
//                 <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}><span style={{ fontSize: 12 }}>Corner</span><ColorPicker value={selectedElement.qr_corner_color} onChange={(c) => updateQRProps({ qr_corner_color: c.toHexString() })} size="small" /></div>
//                 <Divider style={{ margin: '8px 0' }} />
//                 <div><label style={{ fontSize: 12, color: '#666' }}>Dot Style</label><Select value={selectedElement.qr_style} onChange={(v) => updateQRProps({ qr_style: v })} style={{ width: '100%' }} size="small"><Option value="square">Square</Option><Option value="dots">Dots</Option><Option value="rounded">Rounded</Option></Select></div>
//                 <div><label style={{ fontSize: 12, color: '#666' }}>Eye Style</label><Select value={selectedElement.qr_eye_style} onChange={(v) => updateQRProps({ qr_eye_style: v })} style={{ width: '100%' }} size="small"><Option value="square">Square</Option><Option value="circle">Circle</Option></Select></div>
//                 <Divider style={{ margin: '8px 0' }} />
//                 <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: 8 }}><div><label style={{ fontSize: 11 }}>W</label><InputNumber size="small" min={30} max={cardSize.width} value={selectedElement.width} onChange={(v) => updateElementProps(selectedElement.id || selectedElement.tempId, { width: v })} style={{ width: '100%' }} /></div><div><label style={{ fontSize: 11 }}>H</label><InputNumber size="small" min={30} max={cardSize.height} value={selectedElement.height} onChange={(v) => updateElementProps(selectedElement.id || selectedElement.tempId, { height: v })} style={{ width: '100%' }} /></div></div>
//                 <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: 8 }}><div><label style={{ fontSize: 11 }}>X</label><InputNumber size="small" min={0} max={cardSize.width} value={selectedElement.x_position} onChange={(v) => updateElementProps(selectedElement.id || selectedElement.tempId, { x_position: v })} style={{ width: '100%' }} /></div><div><label style={{ fontSize: 11 }}>Y</label><InputNumber size="small" min={0} max={cardSize.height} value={selectedElement.y_position} onChange={(v) => updateElementProps(selectedElement.id || selectedElement.tempId, { y_position: v })} style={{ width: '100%' }} /></div></div>
//               </Space>
//             </Card>
//           )}

//           {/* Text Element Properties */}
//           {selectedElement && (selectedElement.element_type === 'text' || selectedElement.element_type === 'custom-text') && (
//             <Card title={<Space><EditOutlined /> Properties</Space>} extra={<Button type="text" danger icon={<DeleteOutlined />} size="small" onClick={() => deleteElement(selectedElement.id || selectedElement.tempId)} />} style={{ borderRadius: 16, boxShadow: '0 4px 20px rgba(0,0,0,0.08)' }}>
//               <Form layout="vertical" size="small">
//                 <Form.Item label="Label"><Input value={selectedElement.label} onChange={(e) => updateElementProps(selectedElement.id || selectedElement.tempId, { label: e.target.value })} /></Form.Item>
//                 {selectedElement.element_type === 'custom-text' && <Form.Item label="Custom Text"><Input.TextArea value={selectedElement.custom_text || ''} rows={3} onChange={(e) => updateElementProps(selectedElement.id || selectedElement.tempId, { custom_text: e.target.value })} /></Form.Item>}
//                 <Form.Item label="Font"><Select value={selectedElement.font_family || 'Content, sans-serif'} onChange={(v) => updateElementProps(selectedElement.id || selectedElement.tempId, { font_family: v })} size="small">{FONT_FAMILIES.map(f => <Option key={f.value} value={f.value}><span style={{ fontFamily: f.value }}>{f.name}</span></Option>)}</Select></Form.Item>
//                 <Form.Item label="Size"><InputNumber value={selectedElement.font_size} min={8} max={72} style={{ width: '100%' }} onChange={(v) => updateElementProps(selectedElement.id || selectedElement.tempId, { font_size: v })} /></Form.Item>
//                 <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: 8 }}><Form.Item label="Color"><ColorPicker value={selectedElement.font_color} onChange={(c) => updateElementProps(selectedElement.id || selectedElement.tempId, { font_color: c.toHexString() })} /></Form.Item><Form.Item label="Weight"><Select value={selectedElement.font_weight} onChange={(v) => updateElementProps(selectedElement.id || selectedElement.tempId, { font_weight: v })}><Option value="normal">Normal</Option><Option value="bold">Bold</Option></Select></Form.Item></div>
//                 <Form.Item label="Align"><Segmented block value={selectedElement.text_align} onChange={(v) => updateElementProps(selectedElement.id || selectedElement.tempId, { text_align: v })} options={[{ label: 'L', value: 'left' }, { label: 'C', value: 'center' }, { label: 'R', value: 'right' }]} /></Form.Item>
//                 <Divider />
//                 <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: 8 }}><Form.Item label="W"><InputNumber value={selectedElement.width} min={10} max={cardSize.width} style={{ width: '100%' }} onChange={(v) => updateElementProps(selectedElement.id || selectedElement.tempId, { width: v })} /></Form.Item><Form.Item label="H"><InputNumber value={selectedElement.height} min={10} max={cardSize.height} style={{ width: '100%' }} onChange={(v) => updateElementProps(selectedElement.id || selectedElement.tempId, { height: v })} /></Form.Item></div>
//                 <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: 8 }}><Form.Item label="X"><InputNumber value={selectedElement.x_position} min={0} max={cardSize.width} style={{ width: '100%' }} onChange={(v) => updateElementProps(selectedElement.id || selectedElement.tempId, { x_position: v })} /></Form.Item><Form.Item label="Y"><InputNumber value={selectedElement.y_position} min={0} max={cardSize.height} style={{ width: '100%' }} onChange={(v) => updateElementProps(selectedElement.id || selectedElement.tempId, { y_position: v })} /></Form.Item></div>
//               </Form>
//             </Card>
//           )}
//         </div>
//       </div>

//       {/* Template Modal */}
//       <Modal title={<Space><SettingOutlined />{editingTemplate ? 'Edit' : 'New'} Template</Space>} open={showTemplateModal} onOk={handleTemplateSave} onCancel={() => setShowTemplateModal(false)} confirmLoading={loadingSpin} width={500}>
//         <Form form={templateForm} layout="vertical">
//           <Form.Item name="template_name" label="Name" rules={[{ required: true }]}><Input placeholder="Premium Gold Card" size="large" /></Form.Item>
//           <Divider>Card Size</Divider>
//           <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: 16 }}><Form.Item label="Width"><InputNumber value={cardSize.width} onChange={(v) => setCardSize({ ...cardSize, width: v })} min={200} max={1200} style={{ width: '100%' }} size="large" /></Form.Item><Form.Item label="Height"><InputNumber value={cardSize.height} onChange={(v) => setCardSize({ ...cardSize, height: v })} min={150} max={800} style={{ width: '100%' }} size="large" /></Form.Item></div>
//           <Divider>Presets</Divider>
//           <Space style={{ width: '100%', justifyContent: 'center' }}><Button type={orientation === 'landscape' ? 'primary' : 'default'} icon={<SwapOutlined />} onClick={() => { setOrientation('landscape'); setCardSize({ width: 540, height: 340 }); }}>Landscape (540×340)</Button><Button type={orientation === 'portrait' ? 'primary' : 'default'} icon={<SwapOutlined style={{ transform: 'rotate(90deg)' }} />} onClick={() => { setOrientation('portrait'); setCardSize({ width: 340, height: 540 }); }}>Portrait (340×540)</Button></Space>
//           <div style={{ marginTop: 16, padding: 12, background: '#f5f5f5', borderRadius: 8, textAlign: 'center' }}><span style={{ color: '#666' }}>Size: <strong>{cardSize.width} × {cardSize.height} px</strong></span></div>
//         </Form>
//       </Modal>

//       {/* Preview Modal */}
//       <Modal title={<Space><EyeOutlined />Preview</Space>} open={showPreview} onCancel={() => setShowPreview(false)} footer={<Space><Button onClick={() => setShowPreview(false)}>Close</Button><Button type="primary" icon={<DownloadOutlined />}>Download</Button></Space>} width={cardSize.width + 120} bodyStyle={{ display: 'flex', justifyContent: 'center', padding: 40, background: '#f0f2f5' }}><div style={{ width: cardSize.width, height: cardSize.height }} /></Modal>
//     </div>
//   );
// };

// export default IDCardDesigner;


// IDCardDesigner.js - Complete Version (All Emoji Replaced with Ant Design Icons)
import React, { useState, useEffect, useRef, useCallback } from "react";
import {
  Button, Modal, Form, Input, Select, InputNumber, ColorPicker,
  Space, message, Spin, Card, Slider, Switch, Tooltip,
  Segmented, Upload, Divider, Radio, Tabs, Tag
} from "antd";
import {
  PlusOutlined, EditOutlined, DeleteOutlined, SaveOutlined,
  EyeOutlined, SettingOutlined, DownloadOutlined,
  IdcardOutlined, PictureOutlined, FontSizeOutlined,
  SwapOutlined, CheckCircleOutlined,
  QrcodeOutlined, CameraOutlined,
  UserOutlined, PhoneOutlined, BankOutlined, TeamOutlined,
  GlobalOutlined, CrownOutlined, StarOutlined, ThunderboltOutlined,
  UploadOutlined, DeleteOutlined as DeleteIcon,
  BgColorsOutlined, BorderOutlined, RadiusSettingOutlined,
  HighlightOutlined, ShrinkOutlined,
  VerticalAlignTopOutlined, VerticalAlignBottomOutlined,
  ArrowUpOutlined, ArrowDownOutlined, FolderOpenOutlined,
  SearchOutlined, AppstoreOutlined, FileImageOutlined,
  SolutionOutlined, FormatPainterOutlined,
} from "@ant-design/icons";
import { request } from "../../../share/request";
import { getCurrentUser } from "../../../share/getProfile";
import { linkPath } from "../../../share/helper";

import "./IDCardDesigner.css";
import { ImCheckmark2 } from "react-icons/im";

const { Option } = Select;

const GRADIENT_PRESETS = [
  { name: 'None', color1: null, color2: null, direction: '135deg', type: 'none' },
  { name: 'Ocean Blue', color1: '#1a237e', color2: '#0d47a1', direction: '135deg', type: 'linear' },
  { name: 'Royal Purple', color1: '#4a148c', color2: '#7b1fa2', direction: '135deg', type: 'linear' },
  { name: 'Sunset Gold', color1: '#f57f17', color2: '#e65100', direction: '45deg', type: 'linear' },
  { name: 'Forest Green', color1: '#1b5e20', color2: '#004d40', direction: '135deg', type: 'linear' },
  { name: 'Crimson Red', color1: '#b71c1c', color2: '#880e4f', direction: '135deg', type: 'linear' },
  { name: 'Midnight Sky', color1: '#1a237e', color2: '#000051', direction: '180deg', type: 'linear' },
  { name: 'Rose Gold', color1: '#880e4f', color2: '#e91e63', direction: '45deg', type: 'linear' },
  { name: 'Teal Dream', color1: '#004d40', color2: '#00695c', direction: '135deg', type: 'linear' },
];

const PATTERNS = [
  { name: 'None', value: 'none' },
  { name: 'Dots', value: 'dots' },
  { name: 'Lines', value: 'lines' },
  { name: 'Grid', value: 'grid' },
];

const FONT_FAMILIES = [
  { name: 'Content (Khmer)', value: 'Content, sans-serif' },
  { name: 'Noto Sans Khmer', value: "'Noto Sans Khmer', sans-serif" },
  { name: 'Hanuman', value: "'Hanuman', serif" },
  { name: 'Battambang', value: "'Battambang', cursive" },
  { name: 'Siemreap', value: "'Siemreap', cursive" },
  { name: 'Moul', value: "'Moul', cursive" },
  { name: 'Arial', value: 'Arial, sans-serif' },
  { name: 'Times New Roman', value: "'Times New Roman', serif" },
  { name: 'Courier New', value: "'Courier New', monospace" },
];

const SHAPE_TYPES = [
  { name: 'Rectangle', value: 'rectangle', icon: <BorderOutlined /> },
  { name: 'Circle', value: 'circle', icon: <RadiusSettingOutlined /> },
  { name: 'Rounded Rectangle', value: 'rounded', icon: <ShrinkOutlined /> },
];

const IDCardDesigner = () => {
  const getProfile = getCurrentUser();
  const [loading, setLoading] = useState(false);
  const [loadingSpin, setLoadingSpin] = useState(false);
  const [templates, setTemplates] = useState([]);
  const [currentTemplate, setCurrentTemplate] = useState(null);
  const [elements, setElements] = useState([]);
  const [selectedElement, setSelectedElement] = useState(null);
  const [previewStaff, setPreviewStaff] = useState(null);
  const [showPreview, setShowPreview] = useState(false);
  const [showTemplateModal, setShowTemplateModal] = useState(false);
  const [editingTemplate, setEditingTemplate] = useState(null);

  const [orientation, setOrientation] = useState('landscape');
  const [cardSize, setCardSize] = useState({ width: 540, height: 340 });

  const [backgroundType, setBackgroundType] = useState('gradient');
  const [bgColor, setBgColor] = useState('#1a237e');
  const [gradientType, setGradientType] = useState('linear');
  const [gradientColor1, setGradientColor1] = useState('#1a237e');
  const [gradientColor2, setGradientColor2] = useState('#4a148c');
  const [gradientDirection, setGradientDirection] = useState('135deg');
  const [bgImage, setBgImage] = useState(null);
  const [bgImageFile, setBgImageFile] = useState(null);
  const [bgImagePreview, setBgImagePreview] = useState(null);
  const [bgImageSize, setBgImageSize] = useState('cover');
  const [bgImagePosition, setBgImagePosition] = useState('center');
  const [bgImageOpacity, setBgImageOpacity] = useState(1);

  const [borderRadius, setBorderRadius] = useState(16);
  const [shadowEnabled, setShadowEnabled] = useState(true);
  const [shadowColor, setShadowColor] = useState('rgba(0,0,0,0.3)');
  const [shadowBlur, setShadowBlur] = useState(20);
  const [shadowSpread, setShadowSpread] = useState(0);
  const [shadowX, setShadowX] = useState(0);
  const [shadowY, setShadowY] = useState(10);
  
  const [overlayEnabled, setOverlayEnabled] = useState(false);
  const [overlayPattern, setOverlayPattern] = useState('none');
  const [overlayOpacity, setOverlayOpacity] = useState(0.1);
  const [chipEnabled, setChipEnabled] = useState(true);
  const [chipColor, setChipColor] = useState('#FFD700');
  const [zoomLevel, setZoomLevel] = useState(1);

  const [shapeFillType, setShapeFillType] = useState('solid');
  const [shapeFillColor, setShapeFillColor] = useState('#4CAF50');
  const [shapeGradientColor1, setShapeGradientColor1] = useState('#667eea');
  const [shapeGradientColor2, setShapeGradientColor2] = useState('#764ba2');
  const [shapeGradientDirection, setShapeGradientDirection] = useState('135deg');
  const [shapeBorderRadius, setShapeBorderRadius] = useState(8);
  const [shapeShadowEnabled, setShapeShadowEnabled] = useState(false);
  const [shapeShadowColor, setShapeShadowColor] = useState('rgba(0,0,0,0.3)');
  const [shapeShadowBlur, setShapeShadowBlur] = useState(10);
  const [shapeOpacity, setShapeOpacity] = useState(1);
  const [shapeBorderEnabled, setShapeBorderEnabled] = useState(false);
  const [shapeBorderColor, setShapeBorderColor] = useState('#ffffff');
  const [shapeBorderWidth, setShapeBorderWidth] = useState(1);

  const [qrBgColor, setQrBgColor] = useState('#FFFFFF');
  const [qrFgColor, setQrFgColor] = useState('#000000');
  const [qrCornerColor, setQrCornerColor] = useState('#000000');
  const [qrStyle, setQrStyle] = useState('square');
  const [qrEyeStyle, setQrEyeStyle] = useState('square');

  const [signatureImage, setSignatureImage] = useState(null);
  const [signatureFile, setSignatureFile] = useState(null);
  const [signaturePreview, setSignaturePreview] = useState(null);
  const [signatureSize, setSignatureSize] = useState({ width: 150, height: 60 });
  
  const [logoImage, setLogoImage] = useState(null);
  const [logoFile, setLogoFile] = useState(null);
  const [logoPreview, setLogoPreview] = useState(null);
  const [logoSize, setLogoSize] = useState({ width: 80, height: 80 });
  
  const [customPhotos, setCustomPhotos] = useState([]);
  const [uploadedImages, setUploadedImages] = useState([]);

  const [isDragging, setIsDragging] = useState(false);
  const [dragElement, setDragElement] = useState(null);
  const [dragStartPos, setDragStartPos] = useState({ x: 0, y: 0 });
  const [elementStartPos, setElementStartPos] = useState({ x: 0, y: 0 });
  const canvasRef = useRef(null);
  const [templateForm] = Form.useForm();

  // ==================== HELPERS ====================
  const getBackgroundStyle = () => {
    let style = {};
    if (backgroundType === 'image' && bgImagePreview) {
      style.backgroundImage = `url(${bgImagePreview})`;
      style.backgroundSize = bgImageSize === 'stretch' ? '100% 100%' : bgImageSize;
      style.backgroundPosition = bgImagePosition;
      style.backgroundRepeat = 'no-repeat';
      if (bgImageOpacity < 1) style.opacity = bgImageOpacity;
      return style;
    }
    if (backgroundType === 'gradient') {
      style.background = gradientType === 'linear'
        ? `linear-gradient(${gradientDirection}, ${gradientColor1}, ${gradientColor2})`
        : `radial-gradient(circle at center, ${gradientColor1}, ${gradientColor2})`;
    } else if (backgroundType === 'color') {
      style.backgroundColor = bgColor;
    } else {
      style.backgroundColor = 'transparent';
    }
    if (overlayEnabled && overlayPattern !== 'none') {
      const o = overlayOpacity;
      if (overlayPattern === 'dots') {
        style.backgroundImage = `radial-gradient(circle, rgba(255,255,255,${o}) 1px, transparent 1px)`;
        style.backgroundSize = '20px 20px';
      } else if (overlayPattern === 'lines') {
        style.backgroundImage = `linear-gradient(90deg, rgba(255,255,255,${o}) 1px, transparent 1px)`;
        style.backgroundSize = '20px 20px';
      } else if (overlayPattern === 'grid') {
        style.backgroundImage = `linear-gradient(90deg, rgba(255,255,255,${o}) 1px, transparent 1px), linear-gradient(0deg, rgba(255,255,255,${o}) 1px, transparent 1px)`;
        style.backgroundSize = '20px 20px';
      }
    }
    return style;
  };

  const getCardShadow = () => shadowEnabled 
    ? `${shadowX}px ${shadowY}px ${shadowBlur}px ${shadowSpread}px ${shadowColor}` 
    : 'none';

  const getShapeStyle = (el) => {
    let style = {
      width: '100%',
      height: '100%',
      opacity: el.shape_opacity || 1,
    };
    if (el.shape_fill_type === 'gradient') {
      style.background = `linear-gradient(${el.shape_gradient_direction || '135deg'}, ${el.shape_gradient_color1 || '#667eea'}, ${el.shape_gradient_color2 || '#764ba2'})`;
    } else {
      style.backgroundColor = el.shape_fill_color || '#4CAF50';
    }
    if (el.shape_type === 'circle') {
      style.borderRadius = '50%';
    } else if (el.shape_type === 'rounded') {
      style.borderRadius = `${el.shape_border_radius || 8}px`;
    }
    if (el.shape_shadow_enabled) {
      style.boxShadow = `0 ${el.shape_shadow_blur || 10}px ${el.shape_shadow_blur * 2 || 20}px ${el.shape_shadow_color || 'rgba(0,0,0,0.3)'}`;
    }
    if (el.shape_border_enabled) {
      style.border = `${el.shape_border_width || 1}px solid ${el.shape_border_color || '#ffffff'}`;
    }
    return style;
  };

  const generateQRCode = (text, size, fgColor = '#000000', bgColor = '#FFFFFF') => {
    if (!text) return '';
    return `https://api.qrserver.com/v1/create-qr-code/?size=${size}x${size}&data=${encodeURIComponent(text)}&margin=5&color=${fgColor.replace('#', '')}&bgcolor=${bgColor.replace('#', '')}`;
  };

  const bringToFront = (eid) => {
    const maxZ = Math.max(...elements.map(el => el.z_index || 2), 2);
    updateElementProps(eid, { z_index: maxZ + 1 });
  };
  const sendToBack = (eid) => {
    const minZ = Math.min(...elements.map(el => el.z_index || 2), 2);
    updateElementProps(eid, { z_index: Math.max(1, minZ - 1) });
  };
  const bringForward = (eid) => {
    const el = elements.find(e => (e.id || e.tempId) === eid);
    if (el) updateElementProps(eid, { z_index: (el.z_index || 2) + 1 });
  };
  const sendBackward = (eid) => {
    const el = elements.find(e => (e.id || e.tempId) === eid);
    if (el) updateElementProps(eid, { z_index: Math.max(1, (el.z_index || 2) - 1) });
  };

  const getCustomPhotoByIndex = (index) => {
    if (index !== undefined && index !== null && index >= 0 && customPhotos[index]) {
      return customPhotos[index];
    }
    return null;
  };

  const updateImageElementsSize = (imageKey, newSize) => {
    setElements(prev => prev.map(el => {
      if (el.element_type === 'image' && el.element_key === imageKey) {
        return { ...el, width: newSize.width, height: newSize.height };
      }
      return el;
    }));
  };

  const updateCustomPhotoElementsSize = (photoIndex, newSize) => {
    setElements(prev => prev.map(el => {
      if (el.element_type === 'image' && el.element_key === 'custom_photo' && el.custom_photo_index === photoIndex) {
        return { ...el, width: newSize.width, height: newSize.height };
      }
      return el;
    }));
  };

  // ==================== LOAD DATA ====================
  const loadTemplates = async () => {
    setLoading(true);
    try {
      const param = new URLSearchParams({ org_code: getProfile.org_code });
      const res = await request(`id-card-templates?${param.toString()}`, "get", {});
      if (res?.success) {
        setTemplates(res.data);
        if (res.data.length > 0 && !currentTemplate) loadTemplate(res.data[0].id);
      }
    } catch (e) { console.error(e); }
    finally { setLoading(false); }
  };

  const loadTemplateImages = async (templateId) => {
    try {
      const res = await request(`id-card-images/template/${templateId}`, "get", {});
      if (res?.success) {
        setUploadedImages(res.data);
        setSignatureImage(null);
        setSignaturePreview(null);
        setLogoImage(null);
        setLogoPreview(null);
        const photos = [];
        
        res.data.forEach(img => {
          const url = `${linkPath}/${img.image_path}`;
          if (img.image_type === 'signature') { 
            setSignatureImage(img.image_path); 
            setSignaturePreview(url);
            if (img.width) setSignatureSize({ width: parseInt(img.width) || 150, height: parseInt(img.height) || 60 });
          }
          if (img.image_type === 'logo') { 
            setLogoImage(img.image_path); 
            setLogoPreview(url);
            if (img.width) setLogoSize({ width: parseInt(img.width) || 80, height: parseInt(img.height) || 80 });
          }
          if (img.image_type === 'custom_photo') { 
            photos.push({
              id: img.id,
              image_path: img.image_path,
              preview: url,
              size: { width: parseInt(img.width) || 80, height: parseInt(img.height) || 100 },
              file: null,
              tempId: null
            });
          }
        });
        setCustomPhotos(photos);
      }
    } catch (e) { console.error(e); }
  };

  const loadTemplate = async (templateId) => {
    setLoading(true);
    try {
      const res = await request(`id-card-templates/${templateId}`, "get", {});
      if (res?.success) {
        const tpl = res.data;
        setCurrentTemplate(tpl);
        setElements(tpl.elements || []);
        setOrientation(tpl.orientation || 'landscape');
        setCardSize({ width: tpl.width || 540, height: tpl.height || 340 });
        setBackgroundType(tpl.background_type || 'gradient');
        setBgColor(tpl.background_color || '#1a237e');
        setGradientType(tpl.gradient_type || 'linear');
        setGradientColor1(tpl.gradient_color1 || '#1a237e');
        setGradientColor2(tpl.gradient_color2 || '#4a148c');
        setGradientDirection(tpl.gradient_direction || '135deg');
        if (tpl.background_image) {
          setBgImage(tpl.background_image);
          setBgImagePreview(`${linkPath}/${tpl.background_image}`);
        } else { setBgImage(null); setBgImagePreview(null); }
        setBgImageSize(tpl.bg_image_size || 'cover');
        setBgImagePosition(tpl.bg_image_position || 'center');
        setBgImageOpacity(tpl.bg_image_opacity || 1);
        setBorderRadius(tpl.border_radius || 16);
        setShadowEnabled(tpl.shadow_enabled === 1);
        setShadowColor(tpl.shadow_color || 'rgba(0,0,0,0.3)');
        setShadowBlur(tpl.shadow_blur || 20);
        setShadowSpread(tpl.shadow_spread || 0);
        setShadowX(tpl.shadow_x || 0);
        setShadowY(tpl.shadow_y || 10);
        setOverlayEnabled(tpl.overlay_enabled === 1);
        setOverlayPattern(tpl.overlay_pattern || 'none');
        setOverlayOpacity(tpl.overlay_opacity || 0.1);
        setChipEnabled(tpl.chip_enabled === 1);
        setChipColor(tpl.chip_color || '#FFD700');
        setSelectedElement(null);
        await loadTemplateImages(templateId);
      }
    } catch (e) { console.error(e); }
    finally { setLoading(false); }
  };

  useEffect(() => { loadTemplates(); }, []);

  // ==================== HANDLERS ====================
  const handleOrientationChange = (v) => {
    setOrientation(v);
    setCardSize(v === 'portrait' ? { width: 340, height: 540 } : { width: 540, height: 340 });
  };

  const handleBgImageUpload = (file) => {
    const reader = new FileReader();
    reader.onload = (e) => { setBgImagePreview(e.target.result); setBgImageFile(file); };
    reader.readAsDataURL(file);
    return false;
  };
  const handleRemoveBgImage = () => { setBgImagePreview(null); setBgImageFile(null); setBgImage(null); };

  const handleSignatureUpload = (file) => {
    const reader = new FileReader();
    reader.onload = (e) => { setSignaturePreview(e.target.result); setSignatureFile(file); };
    reader.readAsDataURL(file);
    return false;
  };
  const handleRemoveSignature = () => { setSignaturePreview(null); setSignatureFile(null); setSignatureImage(null); };

  const handleLogoUpload = (file) => {
    const reader = new FileReader();
    reader.onload = (e) => { setLogoPreview(e.target.result); setLogoFile(file); };
    reader.readAsDataURL(file);
    return false;
  };
  const handleRemoveLogo = () => { setLogoPreview(null); setLogoFile(null); setLogoImage(null); };

  const handleCustomPhotoUpload = (file) => {
    const reader = new FileReader();
    reader.onload = (e) => {
      const newPhoto = {
        tempId: `cp_${Date.now()}_${Math.random().toString(36).substr(2, 5)}`,
        preview: e.target.result,
        file: file,
        size: { width: 80, height: 100 },
        id: null,
        image_path: null
      };
      setCustomPhotos(prev => [...prev, newPhoto]);
    };
    reader.readAsDataURL(file);
    return false;
  };

  const handleRemoveCustomPhoto = (index) => {
    setCustomPhotos(prev => prev.filter((_, i) => i !== index));
  };

  const handleSignatureSizeChange = (newSize) => {
    setSignatureSize(newSize);
    updateImageElementsSize('signature', newSize);
  };

  const handleLogoSizeChange = (newSize) => {
    setLogoSize(newSize);
    updateImageElementsSize('org_logo', newSize);
  };

  const handleCustomPhotoSizeChange = (index, newSize) => {
    setCustomPhotos(prev => prev.map((p, i) => i === index ? { ...p, size: newSize } : p));
    updateCustomPhotoElementsSize(index, newSize);
  };

  const uploadImageWithType = async (file, imageType, extraData = {}) => {
    const fd = new FormData();
    fd.append('idcard_bg', file);
    fd.append('template_id', currentTemplate?.id);
    fd.append('image_type', imageType);
    fd.append('org_code', getProfile.org_code);
    if (extraData.width) fd.append('width', extraData.width);
    if (extraData.height) fd.append('height', extraData.height);
    try {
      const res = await request("id-card-images", "POST", fd, true);
      if (res?.success) { 
        message.success(`${imageType} uploaded!`); 
        return res.data; 
      }
    } catch (e) { message.error("Upload failed"); }
    return null;
  };

  const addElement = (type, key = null, label = '', extraData = {}) => {
    let defaultW = 150, defaultH = 30;
    if (type === 'image') {
      if (key === 'signature') { defaultW = signatureSize.width; defaultH = signatureSize.height; }
      else if (key === 'org_logo') { defaultW = logoSize.width; defaultH = logoSize.height; }
      else if (key === 'custom_photo' && extraData.photoIndex !== undefined) {
        const photo = customPhotos[extraData.photoIndex];
        if (photo) { defaultW = photo.size.width; defaultH = photo.size.height; }
      }
      else if (key === 'photo') { defaultW = 80; defaultH = 100; }
      else { defaultW = extraData.width || 80; defaultH = extraData.height || 100; }
    } else if (type === 'qrcode') { defaultW = 80; defaultH = 80; }
    else if (type === 'shape') { defaultW = 100; defaultH = 80; }

    const maxZ = Math.max(...elements.map(el => el.z_index || 2), 2);
    const el = {
      template_id: currentTemplate?.id,
      element_type: type, element_key: key, label: label || type,
      custom_text: type === 'custom-text' ? 'Enter text' : '',
      x_position: 50 + elements.length * 20, y_position: 50 + elements.length * 20,
      width: defaultW, height: defaultH, font_size: 14, font_color: '#FFFFFF',
      font_weight: 'bold', font_family: 'Content, sans-serif', text_align: 'left',
      is_visible: 1, sort_order: elements.length + 1, is_new: true,
      tempId: `t_${Date.now()}_${Math.random().toString(36).substr(2, 9)}`,
      z_index: maxZ + 1,
      custom_photo_index: extraData.photoIndex !== undefined ? extraData.photoIndex : null,
      shape_type: 'rounded', shape_fill_type: 'solid', shape_fill_color: '#4CAF50',
      shape_gradient_color1: '#667eea', shape_gradient_color2: '#764ba2', shape_gradient_direction: '135deg',
      shape_border_radius: 8, shape_shadow_enabled: false, shape_shadow_color: 'rgba(0,0,0,0.3)',
      shape_shadow_blur: 10, shape_opacity: 1, shape_border_enabled: false,
      shape_border_color: '#ffffff', shape_border_width: 1,
      qr_bg_color: '#FFFFFF', qr_fg_color: '#000000', qr_corner_color: '#000000',
      qr_style: 'square', qr_eye_style: 'square',
    };
    if (type === 'image' || type === 'qrcode' || type === 'shape') {
      el.font_size = 0;
      el.font_weight = 'normal';
    }
    setElements([...elements, el]);
    setSelectedElement(el);
  };

  const handleMouseDown = (e, el) => {
    e.preventDefault(); e.stopPropagation();
    setSelectedElement(el);
    if (el.element_type === 'shape') {
      setShapeFillType(el.shape_fill_type || 'solid');
      setShapeFillColor(el.shape_fill_color || '#4CAF50');
      setShapeGradientColor1(el.shape_gradient_color1 || '#667eea');
      setShapeGradientColor2(el.shape_gradient_color2 || '#764ba2');
      setShapeGradientDirection(el.shape_gradient_direction || '135deg');
      setShapeBorderRadius(el.shape_border_radius || 8);
      setShapeShadowEnabled(el.shape_shadow_enabled || false);
      setShapeShadowColor(el.shape_shadow_color || 'rgba(0,0,0,0.3)');
      setShapeShadowBlur(el.shape_shadow_blur || 10);
      setShapeOpacity(el.shape_opacity || 1);
      setShapeBorderEnabled(el.shape_border_enabled || false);
      setShapeBorderColor(el.shape_border_color || '#ffffff');
      setShapeBorderWidth(el.shape_border_width || 1);
    }
    if (el.element_type === 'qrcode') {
      setQrBgColor(el.qr_bg_color || '#FFFFFF');
      setQrFgColor(el.qr_fg_color || '#000000');
      setQrCornerColor(el.qr_corner_color || '#000000');
      setQrStyle(el.qr_style || 'square');
      setQrEyeStyle(el.qr_eye_style || 'square');
    }
    setIsDragging(true); setDragElement(el);
    setDragStartPos({ x: e.clientX, y: e.clientY });
    setElementStartPos({ x: el.x_position || 0, y: el.y_position || 0 });
  };

  const handleMouseMove = useCallback((e) => {
    if (!isDragging || !dragElement) return;
    const dx = (e.clientX - dragStartPos.x) / zoomLevel;
    const dy = (e.clientY - dragStartPos.y) / zoomLevel;
    const nx = Math.max(0, Math.min(cardSize.width - (dragElement.width || 100), elementStartPos.x + dx));
    const ny = Math.max(0, Math.min(cardSize.height - (dragElement.height || 30), elementStartPos.y + dy));
    const eid = dragElement.id || dragElement.tempId;
    setElements(prev => prev.map(el => (el.id || el.tempId) === eid ? { ...el, x_position: Math.round(nx), y_position: Math.round(ny) } : el));
  }, [isDragging, dragElement, dragStartPos, elementStartPos, cardSize, zoomLevel]);

  const handleMouseUp = useCallback(() => { setIsDragging(false); setDragElement(null); }, [isDragging]);

  useEffect(() => {
    if (isDragging) { window.addEventListener('mousemove', handleMouseMove); window.addEventListener('mouseup', handleMouseUp); }
    return () => { window.removeEventListener('mousemove', handleMouseMove); window.removeEventListener('mouseup', handleMouseUp); };
  }, [isDragging, handleMouseMove, handleMouseUp]);

  const updateElementProps = (eid, props) => {
    setElements(prev => prev.map(el => (el.id || el.tempId) === eid ? { ...el, ...props } : el));
    setSelectedElement(prev => prev && ((prev.id || prev.tempId) === eid) ? { ...prev, ...props } : prev);
  };

  const deleteElement = async (eid) => {
    const el = elements.find(e => (e.id || e.tempId) === eid);
    if (el?.is_new) { setElements(elements.filter(e => (e.id || e.tempId) !== eid)); setSelectedElement(null); return; }
    if (el?.id) {
      try { await request(`id-card-elements/${el.id}`, "DELETE", {}); setElements(elements.filter(e => e.id !== el.id)); setSelectedElement(null); }
      catch (e) { console.error(e); }
    }
  };

  // ==================== SAVE ====================
  const saveElements = async () => {
    if (!currentTemplate) { message.warning("Select a template first"); return; }
    setLoadingSpin(true);
    try {
      if (signatureFile) { 
        const d = await uploadImageWithType(signatureFile, 'signature', signatureSize); 
        if (d) { setSignatureImage(d.filename || d.image_path); setSignatureFile(null); } 
      }
      if (logoFile) { 
        const d = await uploadImageWithType(logoFile, 'logo', logoSize); 
        if (d) { setLogoImage(d.filename || d.image_path); setLogoFile(null); } 
      }
      
      for (let i = 0; i < customPhotos.length; i++) {
        const photo = customPhotos[i];
        if (photo.file) {
          const d = await uploadImageWithType(photo.file, 'custom_photo', photo.size);
          if (d) {
            setCustomPhotos(prev => prev.map((p, idx) => 
              idx === i ? { ...p, image_path: d.filename || d.image_path, file: null, id: d.id, tempId: null } : p
            ));
          }
        }
      }
      
      let fBg = bgImage;
      if (bgImageFile) {
        const fd = new FormData(); fd.append('idcard_bg', bgImageFile);
        const res = await request("id-card-upload", "POST", fd, true);
        if (res?.success) { fBg = res.data.filename || res.data.image_path; setBgImage(fBg); setBgImageFile(null); setBgImagePreview(`${linkPath}/${fBg}`); }
      }
      
      await request(`id-card-templates/${currentTemplate.id}`, "PUT", {
        width: cardSize.width, height: cardSize.height, orientation,
        background_type: backgroundType, background_color: bgColor, background_image: fBg,
        gradient_type: gradientType, gradient_color1: gradientColor1, gradient_color2: gradientColor2, gradient_direction: gradientDirection,
        bg_image_size: bgImageSize, bg_image_position: bgImagePosition, bg_image_opacity: bgImageOpacity,
        border_radius: borderRadius, shadow_enabled: shadowEnabled, shadow_color: shadowColor,
        shadow_blur: shadowBlur, shadow_spread: shadowSpread, shadow_x: shadowX, shadow_y: shadowY,
        overlay_enabled: overlayEnabled, overlay_pattern: overlayPattern, overlay_opacity: overlayOpacity,
        chip_enabled: chipEnabled, chip_color: chipColor,
      });
      
      for (const el of elements) {
        const data = {
          id: el.id || null, template_id: currentTemplate.id,
          element_type: el.element_type, element_key: el.element_key, label: el.label,
          custom_text: el.custom_text || null,
          x_position: el.x_position, y_position: el.y_position, width: el.width, height: el.height,
          font_size: el.font_size, font_color: el.font_color, font_weight: el.font_weight,
          font_family: el.font_family, text_align: el.text_align,
          is_visible: el.is_visible, sort_order: el.sort_order,
          z_index: el.z_index || 2,
          custom_photo_index: el.custom_photo_index,
          shape_type: el.shape_type, shape_fill_type: el.shape_fill_type,
          shape_fill_color: el.shape_fill_color, shape_gradient_color1: el.shape_gradient_color1,
          shape_gradient_color2: el.shape_gradient_color2, shape_gradient_direction: el.shape_gradient_direction,
          shape_border_radius: el.shape_border_radius, shape_shadow_enabled: el.shape_shadow_enabled,
          shape_shadow_color: el.shape_shadow_color, shape_shadow_blur: el.shape_shadow_blur,
          shape_opacity: el.shape_opacity, shape_border_enabled: el.shape_border_enabled,
          shape_border_color: el.shape_border_color, shape_border_width: el.shape_border_width,
          qr_bg_color: el.qr_bg_color, qr_fg_color: el.qr_fg_color,
          qr_corner_color: el.qr_corner_color, qr_style: el.qr_style, qr_eye_style: el.qr_eye_style,
        };
        const r = await request("id-card-elements", "POST", data);
        if (r?.data?.id && el.is_new) {
          setElements(prev => prev.map(e => e.tempId === el.tempId ? { ...e, id: r.data.id, is_new: false } : e));
        }
      }
      message.success("Saved!");
      await loadTemplate(currentTemplate.id);
    } catch (e) { console.error(e); message.error("Save failed"); }
    finally { setLoadingSpin(false); }
  };

  const previewIDCard = async () => {
    setLoadingSpin(true);
    try {
      const res = await request(`id-card-preview?username=${getProfile.username}&org_code=${getProfile.org_code}`, "get", {});
      if (res?.success) { setPreviewStaff(res.data.staff); setShowPreview(true); }
    } catch (e) { console.error(e); }
    finally { setLoadingSpin(false); }
  };

  const handleTemplateSave = async () => {
    try {
      const v = await templateForm.validateFields();
      setLoadingSpin(true);
      const data = { ...v, org_code: getProfile.org_code, usercreate: getProfile.fullname, width: cardSize.width, height: cardSize.height, orientation, background_type: backgroundType, background_color: bgColor, gradient_type: gradientType, gradient_color1: gradientColor1, gradient_color2: gradientColor2, gradient_direction: gradientDirection, border_radius: borderRadius, shadow_enabled: shadowEnabled, shadow_color: shadowColor, overlay_enabled: overlayEnabled, chip_enabled: chipEnabled, chip_color: chipColor };
      const res = editingTemplate ? await request(`id-card-templates/${editingTemplate.id}`, "PUT", data) : await request("id-card-templates", "POST", data);
      if (res?.isOk || res?.success) { message.success(editingTemplate ? "Updated!" : "Created!"); setShowTemplateModal(false); templateForm.resetFields(); loadTemplates(); }
    } catch (e) { console.error(e); }
    finally { setLoadingSpin(false); }
  };

  const applyGradientPreset = (p) => {
    if (p.type === 'none') { setBackgroundType('none'); return; }
    setBackgroundType('gradient'); setGradientColor1(p.color1); setGradientColor2(p.color2); setGradientDirection(p.direction); setGradientType(p.type);
  };

  const updateShapeProps = (props) => {
    if (!selectedElement) return;
    updateElementProps(selectedElement.id || selectedElement.tempId, props);
  };

  const updateQRProps = (props) => {
    if (!selectedElement) return;
    updateElementProps(selectedElement.id || selectedElement.tempId, props);
  };

  // ==================== RENDER ID CARD ====================
  const renderIDCard = () => (
    <div ref={canvasRef} style={{
      width: cardSize.width, height: cardSize.height, ...getBackgroundStyle(),
      borderRadius: borderRadius, boxShadow: getCardShadow(),
      position: 'relative', overflow: 'hidden',
      border: backgroundType === 'none' ? '2px dashed #d9d9d9' : '1px solid rgba(255,255,255,0.2)',
      cursor: isDragging ? 'grabbing' : 'default', userSelect: 'none',
    }}>
      {backgroundType !== 'none' && (
        <>
          <div style={{ position: 'absolute', top: -60, right: -60, width: 220, height: 220, borderRadius: '50%', background: 'rgba(255,255,255,0.03)', pointerEvents: 'none' }} />
          <div style={{ position: 'absolute', bottom: -90, left: -40, width: 280, height: 280, borderRadius: '50%', background: 'rgba(255,255,255,0.03)', pointerEvents: 'none' }} />
        </>
      )}
      {chipEnabled && (
        <div style={{ position: 'absolute', top: 20, left: 20, width: 45, height: 32, borderRadius: 6, background: `linear-gradient(135deg, ${chipColor}, ${chipColor}cc)`, boxShadow: '0 2px 8px rgba(0,0,0,0.2)', zIndex: 2, pointerEvents: 'none' }}>
          <div style={{ width: '100%', height: '100%', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
            <div style={{ width: 22, height: 16, borderRadius: 3, background: 'rgba(255,255,255,0.3)', border: '1px solid rgba(255,255,255,0.5)' }} />
          </div>
        </div>
      )}
      {backgroundType === 'none' && (
        <div style={{ position: 'absolute', top: '50%', left: '50%', transform: 'translate(-50%,-50%)', color: '#d9d9d9', textAlign: 'center', pointerEvents: 'none' }}>
          <PictureOutlined style={{ fontSize: 48, display: 'block', marginBottom: 8 }} />
          {cardSize.width} x {cardSize.height}
        </div>
      )}
      {elements.filter(el => el.is_visible !== 0)
        .sort((a, b) => (a.z_index || 2) - (b.z_index || 2))
        .map((el, i) => {
        const eid = el.id || el.tempId;
        const sel = selectedElement && (selectedElement.id || selectedElement.tempId) === eid;
        const customPhoto = el.element_key === 'custom_photo' ? getCustomPhotoByIndex(el.custom_photo_index) : null;
        
        return (
          <div key={eid} onMouseDown={(e) => handleMouseDown(e, el)} style={{
            position: 'absolute', left: el.x_position || 0, top: el.y_position || 0,
            width: el.width || 100, height: el.height || 30,
            display: 'flex', alignItems: 'center',
            justifyContent: el.text_align === 'center' ? 'center' : el.text_align === 'right' ? 'flex-end' : 'flex-start',
            fontSize: el.font_size || 12, color: el.font_color || '#FFF',
            fontWeight: el.font_weight || 'normal', fontFamily: el.font_family || 'Content',
            zIndex: sel ? 1000 : (el.z_index || 2), overflow: 'hidden', cursor: 'move',
            border: sel ? '2px solid #1890ff' : (el.element_type === 'shape' ? 'none' : '1px dashed rgba(255,255,255,0.3)'),
            background: el.element_type === 'shape' ? 'transparent' : (sel ? 'rgba(24,144,255,0.15)' : 'rgba(255,255,255,0.05)'),
            borderRadius: el.element_type === 'shape' ? 0 : 4, padding: el.element_type === 'shape' ? 0 : 2,
          }}>
            {el.element_type === 'shape' ? (
              <div style={getShapeStyle(el)}>
                {el.label && el.label !== 'Shape' && (
                  <div style={{ position: 'absolute', top: '50%', left: '50%', transform: 'translate(-50%, -50%)', color: '#fff', fontSize: el.font_size || 12, fontWeight: el.font_weight || 'bold', textAlign: 'center', width: '100%', padding: '4px', textShadow: '0 1px 3px rgba(0,0,0,0.3)' }}>{el.label}</div>
                )}
              </div>
            ) : el.element_type === 'qrcode' ? (
              <div style={{ width: '100%', height: '100%', display: 'flex', alignItems: 'center', justifyContent: 'center', background: el.qr_bg_color || '#FFFFFF', borderRadius: 4, padding: 4 }}>
                <img src={generateQRCode(el.label || 'QR', Math.min(el.width, el.height), el.qr_fg_color || '#000000', el.qr_bg_color || '#FFFFFF')} alt="QR" style={{ width: '100%', height: '100%', objectFit: 'contain', borderRadius: el.qr_style === 'rounded' ? '8px' : '0' }} />
              </div>
            ) : el.element_type === 'image' ? (
              <div style={{ width: '100%', height: '100%', borderRadius: el.element_key === 'photo' ? 6 : 0, border: el.element_key === 'photo' ? '1px solid rgba(255,255,255,0.3)' : 'none', overflow: 'hidden', display: 'flex', alignItems: 'center', justifyContent: 'center', background: 'rgba(255,255,255,0.1)', color: 'rgba(255,255,255,0.6)', fontSize: 11 }}>
                {el.element_key === 'signature' ? (
                  signaturePreview ? <img src={signaturePreview} alt="Sig" style={{ width: '100%', height: '100%', objectFit: 'contain' }} /> : <EditOutlined style={{ fontSize: 20 }} />
                ) : el.element_key === 'org_logo' ? (
                  logoPreview ? <img src={logoPreview} alt="Logo" style={{ width: '100%', height: '100%', objectFit: 'contain' }} /> : <BankOutlined style={{ fontSize: 20 }} />
                ) : el.element_key === 'photo' ? (
                  <CameraOutlined style={{ fontSize: 20 }} />
                ) : el.element_key === 'custom_photo' ? (
                  customPhoto?.preview ? <img src={customPhoto.preview} alt="Custom" style={{ width: '100%', height: '100%', objectFit: 'cover' }} /> : <PictureOutlined style={{ fontSize: 20 }} />
                ) : <PictureOutlined style={{ fontSize: 20 }} />}
              </div>
            ) : (
              <span style={{ width: '100%', textAlign: el.text_align || 'left', fontFamily: el.font_family || 'Content, sans-serif' }}>
                {el.element_type === 'custom-text' ? (el.custom_text || 'Custom Text') : el.label}
              </span>
            )}
            {sel && <div style={{ position: 'absolute', top: -10, right: -10, width: 20, height: 20, borderRadius: '50%', background: '#ff4d4f', color: 'white', display: 'flex', alignItems: 'center', justifyContent: 'center', cursor: 'pointer', fontSize: 12, zIndex: 1001 }} onClick={(e) => { e.stopPropagation(); deleteElement(eid); }}>x</div>}
          </div>
        );
      })}
    </div>
  );

  // ==================== ELEMENT GROUPS ====================
  const elementGroups = [
    { 
      title: 'Personal',
      icon: <UserOutlined />,
      items: [
        { type: 'text', key: 'fullname', label: 'Full Name', icon: <UserOutlined /> },
        { type: 'text', key: 'frontname', label: 'Title', icon: <StarOutlined /> },
        { type: 'text', key: 'staffname_eng', label: 'Name ENG', icon: <GlobalOutlined /> },
        { type: 'text', key: 'idnumber', label: 'ID Number', icon: <IdcardOutlined /> },
        { type: 'text', key: 'gender', label: 'Gender', icon: <UserOutlined /> },
        { type: 'text', key: 'dob', label: 'Date of Birth', icon: <IdcardOutlined /> },
      ]
    },
    { 
      title: 'Work',
      icon: <SolutionOutlined />,
      items: [
        { type: 'text', key: 'position_name', label: 'Position', icon: <CrownOutlined /> },
        { type: 'text', key: 'department_name', label: 'Department', icon: <TeamOutlined /> },
        { type: 'text', key: 'skill_name', label: 'Skill', icon: <ThunderboltOutlined /> },
        { type: 'text', key: 'jobstatus', label: 'Job Status', icon: <CheckCircleOutlined /> },
        { type: 'text', key: 'stafftype', label: 'Staff Type', icon: <IdcardOutlined /> },
        { type: 'text', key: 'level', label: 'Level', icon: <StarOutlined /> },
        { type: 'text', key: 'joinwork', label: 'Join Date', icon: <IdcardOutlined /> },
      ]
    },
    { 
      title: 'Contact',
      icon: <PhoneOutlined />,
      items: [
        { type: 'text', key: 'username', label: 'Phone', icon: <PhoneOutlined /> },
      ]
    },
    { 
      title: 'Media',
      icon: <FileImageOutlined />,
      items: [
        { type: 'image', key: 'photo', label: 'Staff Photo', icon: <CameraOutlined /> },
        { type: 'image', key: 'org_logo', label: 'Org Logo', icon: <BankOutlined /> },
        { type: 'image', key: 'signature', label: 'Signature', icon: <EditOutlined /> },
        { type: 'text', key: 'org_name', label: 'Org Name', icon: <GlobalOutlined /> },
      ]
    },
    { 
      title: 'Custom Photos',
      icon: <PictureOutlined />,
      items: [] 
    },
    { 
      title: 'Custom Text',
      icon: <FontSizeOutlined />,
      items: [
        { type: 'custom-text', key: 'custom_text', label: 'Custom Text', icon: <FontSizeOutlined /> },
      ]
    },
    { 
      title: 'Shapes',
      icon: <HighlightOutlined />,
      items: [
        { type: 'shape', key: null, label: 'Shape', icon: <HighlightOutlined /> },
      ]
    },
    { 
      title: 'Extra',
      icon: <AppstoreOutlined />,
      items: [
        { type: 'qrcode', key: 'qrcode_id', label: 'QR Code', icon: <QrcodeOutlined /> },
        { type: 'text', key: 'role_name', label: 'Role', icon: <TeamOutlined /> },
      ]
    },
  ];

  const customPhotoItems = customPhotos.map((photo, index) => ({
    type: 'image',
    key: 'custom_photo',
    label: `Custom Photo ${index + 1}`,
    icon: <PictureOutlined />,
    photoIndex: index,
  }));

  // ==================== RETURN ====================
  return (
    <div className="id-card-designer" style={{ padding: 24, background: '#f0f2f5', minHeight: '100vh' }}>
      {loadingSpin && <div className="sprinSave"><GetLoading /></div>}
      
      {/* Header */}
      {/* <div style={{ background: 'linear-gradient(135deg, #667eea, #764ba2)', borderRadius: 16, padding: '24px 32px', marginBottom: 24, color: 'white', boxShadow: '0 10px 40px rgba(102,126,234,0.4)' }}>
        <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', flexWrap: 'wrap', gap: 16 }}>
          <div>
            <h1 style={{ color: 'white', margin: 0, fontSize: 28, fontWeight: 700 }}>
              <IdcardOutlined style={{ marginRight: 12 }} />គ្រប់គ្រងការ រចនាកាតបុគ្គលិក
            </h1>
            <p style={{ color: 'rgba(255,255,255,0.8)', margin: '8px 0 0', fontSize: 14 }}>
              Click & drag elements to position them
            </p>
          </div>
          <Space>
            
          </Space>
        </div>
      </div> */}

      <div style={{ display: 'grid', gridTemplateColumns: '260px 1fr 350px', gap: 24 }}>
        {/* Left - Elements */}
        <Card 
          title={<Space><AppstoreOutlined />Elements</Space>} 
          style={{ borderRadius: 16, boxShadow: '0 4px 20px rgba(0,0,0,0.08)', position: 'sticky', top: 24 }}
        >
          <Segmented block value={orientation} onChange={handleOrientationChange} 
            options={[
              { label: <Space><PictureOutlined />Landscape</Space>, value: 'landscape' }, 
              { label: <Space><PictureOutlined style={{ transform: 'rotate(90deg)' }} />Portrait</Space>, value: 'portrait' }
            ]} 
            style={{ marginBottom: 16 }} 
          />
          <Divider />
          {elementGroups.map(g => (
            <div key={g.title} style={{ marginBottom: 20 }}>
              <h4 style={{ color: '#666', fontSize: 12, textTransform: 'uppercase', marginBottom: 8, display: 'flex', alignItems: 'center', gap: 6 }}>
                {g.icon} {g.title}
              </h4>
              <Space direction="vertical" style={{ width: '100%' }}>
                {g.title === 'Custom Photos' ? (
                  customPhotoItems.length > 0 ? customPhotoItems.map((item, i) => (
                    <Button key={i} block icon={item.icon} 
                      onClick={() => addElement(item.type, item.key, item.label, { photoIndex: item.photoIndex })} 
                      style={{ textAlign: 'left', borderRadius: 10, height: 40 }}>
                      {item.label}
                    </Button>
                  )) : (
                    <div style={{ color: '#999', fontSize: 11, padding: '8px', textAlign: 'center' }}>
                      Upload photos in Images tab
                    </div>
                  )
                ) : (
                  g.items.map(item => (
                    <Button key={item.key || item.label} block icon={item.icon} 
                      onClick={() => addElement(item.type, item.key, item.label)} 
                      style={{ textAlign: 'left', borderRadius: 10, height: 40 }}>
                      {item.label}
                    </Button>
                  ))
                )}
              </Space>
            </div>
          ))}
        </Card>

        {/* Center - Canvas */}
        <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', gap: 16 }}>
          <Card style={{ width: '100%', borderRadius: 16, boxShadow: '0 4px 20px rgba(0,0,0,0.08)' }}>
            <Space style={{ width: '100%', justifyContent: 'space-between' }}>
              <Select style={{ width: 250 }} placeholder="Select template" value={currentTemplate?.id} onChange={loadTemplate} size="large">
                {templates.map(t => (
                  <Option key={t.id} value={t.id}>
                    <Space>
                      {t.is_default === 1  }
                      {t.template_name}
                      {t.is_default === 1 && <Tag color="gold" style={{ fontSize: '10px' }}>Default</Tag>}
                    </Space>
                  </Option>
                ))}
              </Select>
              <Space>
                <Button 
                     size="large"      style={{ background: 'gray', color: '#fff', border: 'none', fontWeight:'bold' }}
                icon={<PlusOutlined />} onClick={() => { setEditingTemplate(null); templateForm.resetFields(); setShowTemplateModal(true); }}>
                  New
                </Button>
                <Button 
                         size="large"      style={{ background: 'black', color: '#fff', border: 'none', fontWeight:'bold' }}
                icon={<SettingOutlined />} onClick={() => { setEditingTemplate(currentTemplate); templateForm.setFieldsValue(currentTemplate); setShowTemplateModal(true); }} disabled={!currentTemplate}>
                  Settings
                </Button>
                 <Button icon={<ImCheckmark2 />} onClick={saveElements} loading={loadingSpin} size="large" 
               style={{ background: 'green', color: '#fff', border: 'none', fontWeight:'bold' }}>
               Save Design
             </Button>
              </Space>
            </Space>
          </Card>
          <div style={{ background: '#e8e8e8', borderRadius: 16, padding: 40, boxShadow: 'inset 0 2px 10px rgba(0,0,0,0.1)', overflow: 'auto', maxHeight: 'calc(100vh - 300px)', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
            <div style={{ transform: `scale(${zoomLevel})`, transformOrigin: 'center center', transition: 'transform 0.2s' }}>
              {renderIDCard()}
            </div>
          </div>
          <Card size="small" style={{ borderRadius: 12 }}>
            <Space>
              <SearchOutlined />
              <Slider min={0.5} max={1.5} step={0.1} value={zoomLevel} onChange={setZoomLevel} style={{ width: 150 }} />
              <span>{Math.round(zoomLevel * 100)}%</span>
            </Space>
          </Card>
        </div>

        {/* Right - Settings */}
        <div style={{ maxHeight: 'calc(100vh - 150px)', overflowY: 'auto' }}>
          
          {/* Background */}
          <Card 
            title={<Space><BgColorsOutlined />Background</Space>} 
            style={{ borderRadius: 16, boxShadow: '0 4px 20px rgba(0,0,0,0.08)', marginBottom: 16 }}
          >
            <Radio.Group value={backgroundType} onChange={(e) => setBackgroundType(e.target.value)} style={{ marginBottom: 16, width: '100%' }} size="small">
              <Radio.Button value="none" style={{ width: '25%', textAlign: 'center' }}>None</Radio.Button>
              <Radio.Button value="color" style={{ width: '25%', textAlign: 'center' }}>Color</Radio.Button>
              <Radio.Button value="gradient" style={{ width: '25%', textAlign: 'center' }}>Gradient</Radio.Button>
              <Radio.Button value="image" style={{ width: '25%', textAlign: 'center' }}>Image</Radio.Button>
            </Radio.Group>
            {backgroundType === 'color' && <div style={{ marginBottom: 12 }}><label style={{ fontSize: 12, color: '#666' }}>Color</label><ColorPicker value={bgColor} onChange={(c) => setBgColor(c.toHexString())} style={{ width: '100%' }} /></div>}
            {backgroundType === 'gradient' && (
              <div>
                <div style={{ marginBottom: 12 }}><label style={{ fontSize: 12, color: '#666' }}>Presets</label><div style={{ display: 'grid', gridTemplateColumns: 'repeat(4, 1fr)', gap: 6 }}>{GRADIENT_PRESETS.filter(p => p.type !== 'none').map((p, i) => (<Tooltip key={i} title={p.name}><div onClick={() => applyGradientPreset(p)} style={{ height: 30, borderRadius: 6, cursor: 'pointer', background: `linear-gradient(${p.direction}, ${p.color1}, ${p.color2})`, border: gradientColor1 === p.color1 ? '2px solid #1890ff' : '2px solid transparent' }} /></Tooltip>))}</div></div>
                <Select value={gradientType} onChange={setGradientType} style={{ width: '100%', marginBottom: 8 }} size="small"><Option value="linear">Linear</Option><Option value="radial">Radial</Option></Select>
                <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: 8, marginBottom: 8 }}><ColorPicker value={gradientColor1} onChange={(c) => setGradientColor1(c.toHexString())} /><ColorPicker value={gradientColor2} onChange={(c) => setGradientColor2(c.toHexString())} /></div>
                <Select value={gradientDirection} onChange={setGradientDirection} style={{ width: '100%' }} size="small">{['0deg','45deg','90deg','135deg','180deg','225deg','270deg','315deg'].map(d => <Option key={d} value={d}>{d}</Option>)}</Select>
              </div>
            )}
            {backgroundType === 'image' && (
              <div>
                <label style={{ fontSize: 12, color: '#666' }}>Image</label>
                {bgImagePreview ? (<div style={{ position: 'relative', marginBottom: 8 }}><img src={bgImagePreview} alt="BG" style={{ width: '100%', height: 120, objectFit: 'cover', borderRadius: 8 }} /><Button icon={<DeleteIcon />} size="small" danger onClick={handleRemoveBgImage} style={{ position: 'absolute', top: 8, right: 8 }} /></div>) : (<Upload beforeUpload={handleBgImageUpload} showUploadList={false} accept="image/*"><Button icon={<UploadOutlined />} block style={{ borderRadius: 8, height: 80 }}>Upload Background</Button></Upload>)}
                <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: 8, marginTop: 8 }}><Select value={bgImageSize} onChange={setBgImageSize} size="small"><Option value="cover">Cover</Option><Option value="contain">Contain</Option><Option value="stretch">Stretch</Option></Select><Select value={bgImagePosition} onChange={setBgImagePosition} size="small"><Option value="center">Center</Option><Option value="top">Top</Option><Option value="bottom">Bottom</Option></Select></div>
                <div style={{ marginTop: 8 }}><label style={{ fontSize: 12, color: '#666' }}>Opacity: {bgImageOpacity}</label><Slider min={0.1} max={1} step={0.1} value={bgImageOpacity} onChange={setBgImageOpacity} /></div>
              </div>
            )}
          </Card>

          {/* Card Style */}
          <Card 
            title={<Space><FormatPainterOutlined />Card Style</Space>} 
            style={{ borderRadius: 16, boxShadow: '0 4px 20px rgba(0,0,0,0.08)', marginBottom: 16 }}
          >
            <Space direction="vertical" style={{ width: '100%' }} size="small">
              <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}><span style={{ fontSize: 12 }}>Border Radius</span><InputNumber size="small" min={0} max={50} value={borderRadius} onChange={setBorderRadius} style={{ width: 80 }} addonAfter="px" /></div>
              <Divider style={{ margin: '8px 0' }} />
              <div style={{ display: 'flex', justifyContent: 'space-between' }}><span style={{ fontSize: 12, fontWeight: 'bold' }}>Shadow</span><Switch size="small" checked={shadowEnabled} onChange={setShadowEnabled} /></div>
              {shadowEnabled && (<><div style={{ display: 'flex', justifyContent: 'space-between' }}><span style={{ fontSize: 11 }}>Color</span><ColorPicker value={shadowColor} onChange={(c) => setShadowColor(c.toHexString())} size="small" /></div><div style={{ display: 'flex', justifyContent: 'space-between' }}><span style={{ fontSize: 11 }}>Blur</span><InputNumber size="small" min={0} max={100} value={shadowBlur} onChange={setShadowBlur} style={{ width: 80 }} /></div><div style={{ display: 'flex', justifyContent: 'space-between' }}><span style={{ fontSize: 11 }}>Spread</span><InputNumber size="small" min={-50} max={50} value={shadowSpread} onChange={setShadowSpread} style={{ width: 80 }} /></div><div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: 8 }}><div style={{ display: 'flex', justifyContent: 'space-between' }}><span style={{ fontSize: 11 }}>X</span><InputNumber size="small" min={-50} max={50} value={shadowX} onChange={setShadowX} style={{ width: 70 }} /></div><div style={{ display: 'flex', justifyContent: 'space-between' }}><span style={{ fontSize: 11 }}>Y</span><InputNumber size="small" min={-50} max={50} value={shadowY} onChange={setShadowY} style={{ width: 70 }} /></div></div></>)}
              <Divider style={{ margin: '8px 0' }} />
              <div style={{ display: 'flex', justifyContent: 'space-between' }}><span style={{ fontSize: 12 }}>Overlay</span><Select size="small" value={overlayPattern} onChange={setOverlayPattern} style={{ width: 100 }}>{PATTERNS.map(p => <Option key={p.value} value={p.value}>{p.name}</Option>)}</Select></div>
              {overlayPattern !== 'none' && <div style={{ display: 'flex', justifyContent: 'space-between' }}><span style={{ fontSize: 12 }}>Opacity</span><InputNumber size="small" min={0} max={1} step={0.1} value={overlayOpacity} onChange={setOverlayOpacity} style={{ width: 80 }} /></div>}
              <div style={{ display: 'flex', justifyContent: 'space-between' }}><span style={{ fontSize: 12 }}>Gold Chip</span><Space size="small"><Switch size="small" checked={chipEnabled} onChange={setChipEnabled} />{chipEnabled && <ColorPicker value={chipColor} onChange={(c) => setChipColor(c.toHexString())} size="small" />}</Space></div>
            </Space>
          </Card>

          {/* Images Section */}
          <Card 
            title={<Space><FolderOpenOutlined />Images</Space>} 
            style={{ borderRadius: 16, boxShadow: '0 4px 20px rgba(0,0,0,0.08)', marginBottom: 16 }}
          >
            <Tabs size="small" items={[
              {
                key: 'signature', 
                label: <Space><EditOutlined />Signature</Space>, 
                children: (
                  <div>
                    {signaturePreview ? (<div style={{ position: 'relative', marginBottom: 12 }}><img src={signaturePreview} alt="Sig" style={{ width: '100%', height: 70, objectFit: 'contain', borderRadius: 8, background: '#f5f5f5', padding: 8 }} /><Button icon={<DeleteIcon />} size="small" danger onClick={handleRemoveSignature} style={{ position: 'absolute', top: 4, right: 4 }} /></div>) : (<Upload beforeUpload={handleSignatureUpload} showUploadList={false} accept="image/*"><Button icon={<UploadOutlined />} block style={{ borderRadius: 8, height: 50 }}>Upload Signature</Button></Upload>)}
                    <Divider style={{ margin: '8px 0' }} />
                    <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                      <span style={{ fontSize: 11, color: '#666' }}>Size:</span>
                      <Space size="small">
                        <InputNumber size="small" min={20} max={cardSize.width} value={signatureSize.width} onChange={(v) => handleSignatureSizeChange({...signatureSize, width: v})} style={{ width: 120 }} addonAfter="W" />
                        <InputNumber size="small" min={20} max={cardSize.height} value={signatureSize.height} onChange={(v) => handleSignatureSizeChange({...signatureSize, height: v})} style={{ width: 120 }} addonAfter="H" />
                      </Space>
                    </div>
                  </div>
                )
              },
              {
                key: 'logo', 
                label: <Space><BankOutlined />Logo</Space>, 
                children: (
                  <div>
                    {logoPreview ? (<div style={{ position: 'relative', marginBottom: 12 }}><img src={logoPreview} alt="Logo" style={{ width: '100%', height: 70, objectFit: 'contain', borderRadius: 8, background: '#f5f5f5', padding: 8 }} /><Button icon={<DeleteIcon />} size="small" danger onClick={handleRemoveLogo} style={{ position: 'absolute', top: 4, right: 4 }} /></div>) : (<Upload beforeUpload={handleLogoUpload} showUploadList={false} accept="image/*"><Button icon={<UploadOutlined />} block style={{ borderRadius: 8, height: 50 }}>Upload Logo</Button></Upload>)}
                    <Divider style={{ margin: '8px 0' }} />
                    <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                      <span style={{ fontSize: 11, color: '#666' }}>Size:</span>
                      <InputNumber style={{ width: 120 }} size="small" min={20} max={cardSize.width} value={logoSize.width} onChange={(v) => handleLogoSizeChange({...logoSize, width: v})} addonAfter="W" />
                      <InputNumber style={{ width: 120 }} size="small" min={20} max={cardSize.height} value={logoSize.height} onChange={(v) => handleLogoSizeChange({...logoSize, height: v})} addonAfter="H" />
                    </div>
                  </div>
                )
              },
              {
                key: 'custom_photos', 
                label: <Space><PictureOutlined />Photos ({customPhotos.length})</Space>, 
                children: (
                  <div>
                    <Upload beforeUpload={handleCustomPhotoUpload} showUploadList={false} accept="image/*" multiple><Button icon={<UploadOutlined />} block style={{ borderRadius: 8, height: 40, marginBottom: 12 }}>Add Photo</Button></Upload>
                    {customPhotos.map((photo, index) => (
                      <div key={photo.tempId || photo.id || index} style={{ position: 'relative', marginBottom: 12, padding: 8, background: '#fafafa', borderRadius: 8, border: '1px solid #f0f0f0' }}>
                        <div style={{ display: 'flex', gap: 8, alignItems: 'center' }}>
                          <img src={photo.preview} alt={`Custom ${index + 1}`} style={{ width: 50, height: 50, objectFit: 'cover', borderRadius: 6 }} />
                          <div style={{ flex: 1 }}>
                            <div style={{ fontSize: 11, fontWeight: 'bold', marginBottom: 4 }}>Photo {index + 1}</div>
                            <InputNumber size="small" style={{ width: 120 }} min={20} max={cardSize.width} value={photo.size.width} onChange={(v) => handleCustomPhotoSizeChange(index, {...photo.size, width: v})} addonAfter="W" />
                            <InputNumber size="small" style={{ width: 120 }} min={20} max={cardSize.height} value={photo.size.height} onChange={(v) => handleCustomPhotoSizeChange(index, {...photo.size, height: v})} addonAfter="H" />
                          </div>
                          <Button icon={<DeleteIcon />} size="small" danger onClick={() => handleRemoveCustomPhoto(index)} />
                        </div>
                      </div>
                    ))}
                  </div>
                )
              },
            ]} />
          </Card>

          {/* Layer Management */}
          {selectedElement && (
            <Card 
              title={<Space><VerticalAlignTopOutlined />Layer Order</Space>} 
              style={{ borderRadius: 16, boxShadow: '0 4px 20px rgba(0,0,0,0.08)', marginBottom: 16 }} 
              size="small"
            >
              <div style={{ background: '#f5f5f5', padding: '12px', borderRadius: '8px', marginBottom: '12px' }}>
                <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                  <span style={{ fontSize: '12px', color: '#666' }}>Current Layer:</span>
                  <Tag color="blue" style={{ fontSize: '12px' }}>Z-Index: {selectedElement.z_index || 2}</Tag>
                </div>
              </div>
              <Space direction="vertical" style={{ width: '100%' }} size="small">
                <Button block icon={<VerticalAlignTopOutlined />} onClick={() => bringToFront(selectedElement.id || selectedElement.tempId)} style={{ background: 'linear-gradient(135deg, #667eea, #764ba2)', color: 'white', border: 'none', borderRadius: '8px' }}>Bring to Front</Button>
                <Button block icon={<ArrowUpOutlined />} onClick={() => bringForward(selectedElement.id || selectedElement.tempId)} style={{ borderRadius: '8px' }}>Bring Forward</Button>
                <Button block icon={<ArrowDownOutlined />} onClick={() => sendBackward(selectedElement.id || selectedElement.tempId)} style={{ borderRadius: '8px' }}>Send Backward</Button>
                <Button block icon={<VerticalAlignBottomOutlined />} onClick={() => sendToBack(selectedElement.id || selectedElement.tempId)} style={{ background: 'linear-gradient(135deg, #ff4d4f, #ff7875)', color: 'white', border: 'none', borderRadius: '8px' }}>Send to Back</Button>
              </Space>
              <Divider style={{ margin: '12px 0' }} />
              <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                <span style={{ fontSize: '12px', color: '#666' }}>Manual Z-Index:</span>
                <InputNumber size="small" min={1} max={999} value={selectedElement.z_index || 2} onChange={(v) => updateElementProps(selectedElement.id || selectedElement.tempId, { z_index: v })} style={{ width: '80px' }} />
              </div>
            </Card>
          )}

          {/* Shape Properties */}
          {selectedElement && selectedElement.element_type === 'shape' && (
            <Card 
              title={<Space><HighlightOutlined />Shape Properties</Space>} 
              extra={<Space size="small"><Tooltip title="Front"><Button type="text" size="small" icon={<VerticalAlignTopOutlined />} onClick={() => bringToFront(selectedElement.id || selectedElement.tempId)} /></Tooltip><Tooltip title="Back"><Button type="text" size="small" icon={<VerticalAlignBottomOutlined />} onClick={() => sendToBack(selectedElement.id || selectedElement.tempId)} /></Tooltip><Button type="text" danger icon={<DeleteOutlined />} size="small" onClick={() => deleteElement(selectedElement.id || selectedElement.tempId)} /></Space>} 
              style={{ borderRadius: 16, boxShadow: '0 4px 20px rgba(0,0,0,0.08)', marginBottom: 16 }}
            >
              <Space direction="vertical" style={{ width: '100%' }} size="small">
                <div><label style={{ fontSize: 12, color: '#666' }}>Shape Type</label><Select value={selectedElement.shape_type} onChange={(v) => updateShapeProps({ shape_type: v })} style={{ width: '100%' }} size="small">{SHAPE_TYPES.map(s => <Option key={s.value} value={s.value}>{s.name}</Option>)}</Select></div>
                <Divider style={{ margin: '8px 0' }} />
                <div><label style={{ fontSize: 12, color: '#666' }}>Fill Type</label><Radio.Group value={selectedElement.shape_fill_type} onChange={(e) => updateShapeProps({ shape_fill_type: e.target.value })} size="small" style={{ width: '100%' }}><Radio.Button value="solid" style={{ width: '50%', textAlign: 'center' }}>Solid</Radio.Button><Radio.Button value="gradient" style={{ width: '50%', textAlign: 'center' }}>Gradient</Radio.Button></Radio.Group></div>
                {selectedElement.shape_fill_type === 'solid' ? (<div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}><span style={{ fontSize: 12 }}>Color</span><ColorPicker value={selectedElement.shape_fill_color} onChange={(c) => updateShapeProps({ shape_fill_color: c.toHexString() })} size="small" /></div>) : (<><div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: 8 }}><ColorPicker value={selectedElement.shape_gradient_color1} onChange={(c) => updateShapeProps({ shape_gradient_color1: c.toHexString() })} /><ColorPicker value={selectedElement.shape_gradient_color2} onChange={(c) => updateShapeProps({ shape_gradient_color2: c.toHexString() })} /></div><Select value={selectedElement.shape_gradient_direction} onChange={(v) => updateShapeProps({ shape_gradient_direction: v })} size="small">{['0deg','45deg','90deg','135deg','180deg','225deg','270deg','315deg'].map(d => <Option key={d} value={d}>{d}</Option>)}</Select></>)}
                <Divider style={{ margin: '8px 0' }} />
                <div style={{ display: 'flex', justifyContent: 'space-between' }}><span style={{ fontSize: 12 }}>Opacity</span><InputNumber size="small" min={0} max={1} step={0.1} value={selectedElement.shape_opacity} onChange={(v) => updateShapeProps({ shape_opacity: v })} style={{ width: 80 }} /></div>
                {selectedElement.shape_type !== 'circle' && <div style={{ display: 'flex', justifyContent: 'space-between' }}><span style={{ fontSize: 12 }}>Border Radius</span><InputNumber size="small" min={0} max={50} value={selectedElement.shape_border_radius} onChange={(v) => updateShapeProps({ shape_border_radius: v })} style={{ width: 80 }} addonAfter="px" /></div>}
                <Divider style={{ margin: '8px 0' }} />
                <div style={{ display: 'flex', justifyContent: 'space-between' }}><span style={{ fontSize: 12, fontWeight: 'bold' }}>Shadow</span><Switch size="small" checked={selectedElement.shape_shadow_enabled} onChange={(v) => updateShapeProps({ shape_shadow_enabled: v })} /></div>
                {selectedElement.shape_shadow_enabled && (<><div style={{ display: 'flex', justifyContent: 'space-between' }}><span style={{ fontSize: 11 }}>Color</span><ColorPicker value={selectedElement.shape_shadow_color} onChange={(c) => updateShapeProps({ shape_shadow_color: c.toHexString() })} size="small" /></div><div style={{ display: 'flex', justifyContent: 'space-between' }}><span style={{ fontSize: 11 }}>Blur</span><InputNumber size="small" min={0} max={100} value={selectedElement.shape_shadow_blur} onChange={(v) => updateShapeProps({ shape_shadow_blur: v })} style={{ width: 80 }} /></div></>)}
                <Divider style={{ margin: '8px 0' }} />
                <div style={{ display: 'flex', justifyContent: 'space-between' }}><span style={{ fontSize: 12, fontWeight: 'bold' }}>Border</span><Switch size="small" checked={selectedElement.shape_border_enabled} onChange={(v) => updateShapeProps({ shape_border_enabled: v })} /></div>
                {selectedElement.shape_border_enabled && (<><div style={{ display: 'flex', justifyContent: 'space-between' }}><span style={{ fontSize: 11 }}>Color</span><ColorPicker value={selectedElement.shape_border_color} onChange={(c) => updateShapeProps({ shape_border_color: c.toHexString() })} size="small" /></div><div style={{ display: 'flex', justifyContent: 'space-between' }}><span style={{ fontSize: 11 }}>Width</span><InputNumber size="small" min={1} max={10} value={selectedElement.shape_border_width} onChange={(v) => updateShapeProps({ shape_border_width: v })} style={{ width: 80 }} addonAfter="px" /></div></>)}
                <Divider style={{ margin: '8px 0' }} />
                <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: 8 }}><div><label style={{ fontSize: 11 }}>W</label><InputNumber size="small" min={10} max={cardSize.width} value={selectedElement.width} onChange={(v) => updateElementProps(selectedElement.id || selectedElement.tempId, { width: v })} style={{ width: '100%' }} /></div><div><label style={{ fontSize: 11 }}>H</label><InputNumber size="small" min={10} max={cardSize.height} value={selectedElement.height} onChange={(v) => updateElementProps(selectedElement.id || selectedElement.tempId, { height: v })} style={{ width: '100%' }} /></div></div>
                <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: 8 }}><div><label style={{ fontSize: 11 }}>X</label><InputNumber size="small" min={0} max={cardSize.width} value={selectedElement.x_position} onChange={(v) => updateElementProps(selectedElement.id || selectedElement.tempId, { x_position: v })} style={{ width: '100%' }} /></div><div><label style={{ fontSize: 11 }}>Y</label><InputNumber size="small" min={0} max={cardSize.height} value={selectedElement.y_position} onChange={(v) => updateElementProps(selectedElement.id || selectedElement.tempId, { y_position: v })} style={{ width: '100%' }} /></div></div>
              </Space>
            </Card>
          )}

          {/* QR Code Properties */}
          {selectedElement && selectedElement.element_type === 'qrcode' && (
            <Card 
              title={<Space><QrcodeOutlined />QR Code Style</Space>} 
              extra={<Space size="small"><Tooltip title="Front"><Button type="text" size="small" icon={<VerticalAlignTopOutlined />} onClick={() => bringToFront(selectedElement.id || selectedElement.tempId)} /></Tooltip><Tooltip title="Back"><Button type="text" size="small" icon={<VerticalAlignBottomOutlined />} onClick={() => sendToBack(selectedElement.id || selectedElement.tempId)} /></Tooltip><Button type="text" danger icon={<DeleteOutlined />} size="small" onClick={() => deleteElement(selectedElement.id || selectedElement.tempId)} /></Space>} 
              style={{ borderRadius: 16, boxShadow: '0 4px 20px rgba(0,0,0,0.08)', marginBottom: 16 }}
            >
              <Space direction="vertical" style={{ width: '100%' }} size="small">
                <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}><span style={{ fontSize: 12 }}>Background</span><ColorPicker value={selectedElement.qr_bg_color} onChange={(c) => updateQRProps({ qr_bg_color: c.toHexString() })} size="small" /></div>
                <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}><span style={{ fontSize: 12 }}>Foreground</span><ColorPicker value={selectedElement.qr_fg_color} onChange={(c) => updateQRProps({ qr_fg_color: c.toHexString() })} size="small" /></div>
                <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}><span style={{ fontSize: 12 }}>Corner</span><ColorPicker value={selectedElement.qr_corner_color} onChange={(c) => updateQRProps({ qr_corner_color: c.toHexString() })} size="small" /></div>
                <Divider style={{ margin: '8px 0' }} />
                <div><label style={{ fontSize: 12, color: '#666' }}>Dot Style</label><Select value={selectedElement.qr_style} onChange={(v) => updateQRProps({ qr_style: v })} style={{ width: '100%' }} size="small"><Option value="square">Square</Option><Option value="dots">Dots</Option><Option value="rounded">Rounded</Option></Select></div>
                <div><label style={{ fontSize: 12, color: '#666' }}>Eye Style</label><Select value={selectedElement.qr_eye_style} onChange={(v) => updateQRProps({ qr_eye_style: v })} style={{ width: '100%' }} size="small"><Option value="square">Square</Option><Option value="circle">Circle</Option></Select></div>
                <Divider style={{ margin: '8px 0' }} />
                <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: 8 }}><div><label style={{ fontSize: 11 }}>W</label><InputNumber size="small" min={30} max={cardSize.width} value={selectedElement.width} onChange={(v) => updateElementProps(selectedElement.id || selectedElement.tempId, { width: v })} style={{ width: '100%' }} /></div><div><label style={{ fontSize: 11 }}>H</label><InputNumber size="small" min={30} max={cardSize.height} value={selectedElement.height} onChange={(v) => updateElementProps(selectedElement.id || selectedElement.tempId, { height: v })} style={{ width: '100%' }} /></div></div>
                <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: 8 }}><div><label style={{ fontSize: 11 }}>X</label><InputNumber size="small" min={0} max={cardSize.width} value={selectedElement.x_position} onChange={(v) => updateElementProps(selectedElement.id || selectedElement.tempId, { x_position: v })} style={{ width: '100%' }} /></div><div><label style={{ fontSize: 11 }}>Y</label><InputNumber size="small" min={0} max={cardSize.height} value={selectedElement.y_position} onChange={(v) => updateElementProps(selectedElement.id || selectedElement.tempId, { y_position: v })} style={{ width: '100%' }} /></div></div>
              </Space>
            </Card>
          )}

          {/* Text Element Properties */}
          {selectedElement && (selectedElement.element_type === 'text' || selectedElement.element_type === 'custom-text') && (
            <Card 
              title={<Space><FontSizeOutlined />Text Properties</Space>} 
              extra={<Button type="text" danger icon={<DeleteOutlined />} size="small" onClick={() => deleteElement(selectedElement.id || selectedElement.tempId)} />} 
              style={{ borderRadius: 16, boxShadow: '0 4px 20px rgba(0,0,0,0.08)' }}
            >
              <Form layout="vertical" size="small">
                <Form.Item label="Label"><Input value={selectedElement.label} onChange={(e) => updateElementProps(selectedElement.id || selectedElement.tempId, { label: e.target.value })} /></Form.Item>
                {selectedElement.element_type === 'custom-text' && <Form.Item label="Custom Text"><Input.TextArea value={selectedElement.custom_text || ''} rows={3} onChange={(e) => updateElementProps(selectedElement.id || selectedElement.tempId, { custom_text: e.target.value })} /></Form.Item>}
                <Form.Item label="Font"><Select value={selectedElement.font_family || 'Content, sans-serif'} onChange={(v) => updateElementProps(selectedElement.id || selectedElement.tempId, { font_family: v })} size="small">{FONT_FAMILIES.map(f => <Option key={f.value} value={f.value}><span style={{ fontFamily: f.value }}>{f.name}</span></Option>)}</Select></Form.Item>
                <Form.Item label="Size"><InputNumber value={selectedElement.font_size} min={8} max={72} style={{ width: '100%' }} onChange={(v) => updateElementProps(selectedElement.id || selectedElement.tempId, { font_size: v })} /></Form.Item>
                <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: 8 }}><Form.Item label="Color"><ColorPicker value={selectedElement.font_color} onChange={(c) => updateElementProps(selectedElement.id || selectedElement.tempId, { font_color: c.toHexString() })} /></Form.Item><Form.Item label="Weight"><Select value={selectedElement.font_weight} onChange={(v) => updateElementProps(selectedElement.id || selectedElement.tempId, { font_weight: v })}><Option value="normal">Normal</Option><Option value="bold">Bold</Option></Select></Form.Item></div>
                <Form.Item label="Align"><Segmented block value={selectedElement.text_align} onChange={(v) => updateElementProps(selectedElement.id || selectedElement.tempId, { text_align: v })} options={[{ label: 'L', value: 'left' }, { label: 'C', value: 'center' }, { label: 'R', value: 'right' }]} /></Form.Item>
                <Divider />
                <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: 8 }}><Form.Item label="W"><InputNumber value={selectedElement.width} min={10} max={cardSize.width} style={{ width: '100%' }} onChange={(v) => updateElementProps(selectedElement.id || selectedElement.tempId, { width: v })} /></Form.Item><Form.Item label="H"><InputNumber value={selectedElement.height} min={10} max={cardSize.height} style={{ width: '100%' }} onChange={(v) => updateElementProps(selectedElement.id || selectedElement.tempId, { height: v })} /></Form.Item></div>
                <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: 8 }}><Form.Item label="X"><InputNumber value={selectedElement.x_position} min={0} max={cardSize.width} style={{ width: '100%' }} onChange={(v) => updateElementProps(selectedElement.id || selectedElement.tempId, { x_position: v })} /></Form.Item><Form.Item label="Y"><InputNumber value={selectedElement.y_position} min={0} max={cardSize.height} style={{ width: '100%' }} onChange={(v) => updateElementProps(selectedElement.id || selectedElement.tempId, { y_position: v })} /></Form.Item></div>
              </Form>
            </Card>
          )}
        </div>
      </div>

      {/* Template Modal */}
      <Modal 
        title={<Space><SettingOutlined />{editingTemplate ? 'Edit Template' : 'New Template'}</Space>} 
        open={showTemplateModal} onOk={handleTemplateSave} onCancel={() => setShowTemplateModal(false)} 
        confirmLoading={loadingSpin} width={500}
      >
        <Form form={templateForm} layout="vertical">
          <Form.Item name="template_name" label="Name" rules={[{ required: true }]}><Input placeholder="Premium Gold Card" size="large" /></Form.Item>
          <Divider>Card Size</Divider>
          <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: 16 }}>
            <Form.Item label="Width"><InputNumber value={cardSize.width} onChange={(v) => setCardSize({ ...cardSize, width: v })} min={200} max={1200} style={{ width: '100%' }} size="large" /></Form.Item>
            <Form.Item label="Height"><InputNumber value={cardSize.height} onChange={(v) => setCardSize({ ...cardSize, height: v })} min={150} max={800} style={{ width: '100%' }} size="large" /></Form.Item>
          </div>
          <Divider>Presets</Divider>
          <Space style={{ width: '100%', justifyContent: 'center' }}>
            <Button type={orientation === 'landscape' ? 'primary' : 'default'} icon={<SwapOutlined />} onClick={() => { setOrientation('landscape'); setCardSize({ width: 540, height: 340 }); }}>Landscape (540x340)</Button>
            <Button type={orientation === 'portrait' ? 'primary' : 'default'} icon={<SwapOutlined style={{ transform: 'rotate(90deg)' }} />} onClick={() => { setOrientation('portrait'); setCardSize({ width: 340, height: 540 }); }}>Portrait (340x540)</Button>
          </Space>
          <div style={{ marginTop: 16, padding: 12, background: '#f5f5f5', borderRadius: 8, textAlign: 'center' }}>
            <span style={{ color: '#666' }}>Size: <strong>{cardSize.width} x {cardSize.height} px</strong></span>
          </div>
        </Form>
      </Modal>

      {/* Preview Modal */}
      <Modal 
        title={<Space><EyeOutlined />Preview</Space>} 
        open={showPreview} onCancel={() => setShowPreview(false)} 
        footer={<Space><Button onClick={() => setShowPreview(false)}>Close</Button><Button type="primary" icon={<DownloadOutlined />}>Download</Button></Space>} 
        width={cardSize.width + 120} 
        bodyStyle={{ display: 'flex', justifyContent: 'center', padding: 40, background: '#f0f2f5' }}
      >
        <div style={{ width: cardSize.width, height: cardSize.height }} />
      </Modal>
    </div>
  );
};

export default IDCardDesigner;